import {defineStore} from "pinia";
import DOCS_I18N from "./docs_i18n.js";

const getUrlLang = function () {
        try {
            var params = new URLSearchParams(window.location.search);
            return params.get("lr") || params.get("lang") || "";
        } catch (e) { return ""; }
    },

    getLang = function () {

        if (navigator.userLanguage) {

            return navigator.userLanguage;

        } else if (navigator.language) {

            return navigator.language;

        }

        return "en-US";

    },

    SUPPORTED_LANGS = ["en", "ja", "es", "fr", "zh", "zh-TW", "de", "ar"],
    RTL_LANGS = ["ar"],

    getBrowserLanguage = function () {
        // URL parameter takes priority
        var urlLang = getUrlLang();
        if (urlLang && SUPPORTED_LANGS.indexOf(urlLang) !== -1) return urlLang;

        switch (getLang()) {

        case "en-US":
            return "en";
        case "en-AU":
            return "en";
        case "en-CA":
            return "en";
        case "en-IE":
            return "en";
        case "en-GB":
            return "en";
        case "en-JM":
            return "en";
        case "en-ZA":
            return "en";
        case "en-PH":
            return "en";
        case "ja":
            return "ja";
        case "ja-jp":
            return "ja";
        case "ja-JP":
            return "ja";
        case "es":
            return "es";
        case "es-ES":
            return "es";
        case "es-MX":
            return "es";
        case "es-AR":
            return "es";
        case "fr":
            return "fr";
        case "fr-FR":
            return "fr";
        case "fr-CA":
            return "fr";
        case "fr-BE":
            return "fr";
        case "zh":
            return "zh";
        case "zh-CN":
            return "zh";
        case "zh-TW":
            return "zh-TW";
        case "zh-HK":
            return "zh-TW";
        case "de":
            return "de";
        case "de-DE":
            return "de";
        case "de-AT":
            return "de";
        case "de-CH":
            return "de";
        case "ar":
            return "ar";
        case "ar-SA":
            return "ar";
        case "ar-EG":
            return "ar";
        case "ar-AE":
            return "ar";
        case "ar-MA":
            return "ar";
        case "ar-DZ":
            return "ar";
        case "ar-IQ":
            return "ar";
        case "ar-KW":
            return "ar";
        case "ar-QA":
            return "ar";
        default:
            return "en";

        }

    },

    translationStore = defineStore(
        "translation",
        {
            "actions": {
                "setLanguage": (state) => function (lang) {

                    state.VUE_APP_USER_LANGUAGE = lang;

                }
            },
            "getters": {
                "getLang": () => function () {

                    return getLang();

                },
                "localize": (state) => function (...args) {

                    const args_ = Array.prototype.slice.call(args),
                        i = args_[0],
                        r = [];
                    for (let j = 1; j < args_.length; j++) {

                        r.push(args_[j]);

                    }
                    if (!state.VUE_APP_USER_LANGUAGE) {

                        state.VUE_APP_USER_LANGUAGE = getBrowserLanguage();

                    }
                    if (!state[i]) {

                        return i;

                    }
                    if (state[i] && state.VUE_APP_USER_LANGUAGE) {

                        let localized = state[i][state.VUE_APP_USER_LANGUAGE];
                        if (!localized) {

                            localized = state[i]["en"];
                            if (!localized) {

                                return "";

                            }

                        }
                        if (r.length > 0) {

                            let l = 0;
                            for (const k in r) {

                                if (r[k]) {

                                    localized = localized.replace(
                                        `{${l}}`,
                                        r[k]
                                    );

                                } else {

                                    localized = localized.replace(
                                        `{${l}}`,
                                        ""
                                    );

                                }
                                l++;

                            }
                            return localized;

                        }
                        return localized;

                    }
                    return i;

                }
            },
            "state": () => ({
                // ---- Documentation (/docs) strings ----
                ...DOCS_I18N,
                // ---- Existing keys (now with Spanish) ----
                "TEXT_HOME": {
                    "en": "Home",
                    "ja": "ホーム",
                    "es": "Inicio",
                    "ar": "الرئيسية"
                },
                "TEXT_LOGIN": {
                    "en": "Login",
                    "ja": "ログイン",
                    "es": "Iniciar sesión",
                    "ar": "تسجيل الدخول"
                },
                "TEXT_LOGOUT": {
                    "en": "Logout",
                    "ja": "ログアウト",
                    "es": "Cerrar sesión",
                    "ar": "تسجيل الخروج"
                },
                "TEXT_ACCOUNT": {
                    "en": "Account",
                    "ja": "アカウント",
                    "es": "Cuenta",
                    "ar": "الحساب"
                },
                "TEXT_LICENCES": {
                    "en": "Licences",
                    "ja": "ライセンス",
                    "es": "Licencias",
                    "ar": "التراخيص"
                },
                "TEXT_CONNECT": {
                    "en": "Connect",
                    "ja": "接続",
                    "es": "Conectar",
                    "ar": "اتصال"
                },
                "TEXT_MESSAGES": {
                    "en": "Messages",
                    "ja": "メッセージ",
                    "es": "Mensajes",
                    "ar": "الرسائل"
                },
                "TEXT_CHATS": {
                    "en": "Chats",
                    "ja": "チャット",
                    "es": "Chats",
                    "ar": "المحادثات"
                },
                "TEXT_SIGN_UP": {
                    "en": "Sign Up",
                    "ja": "サインアップ",
                    "es": "Registrarse",
                    "ar": "إنشاء حساب"
                },
                "TEXT_SENDING_FILE": {
                    "en": "Sending file...",
                    "ja": "ファイルを送信中...",
                    "es": "Enviando archivo...",
                    "ar": "جارٍ إرسال الملف..."
                },
                "LOGIN_CONNECT_WALLET": {
                    "en": "Connect your wallet to sign in.",
                    "ja": "ウォレットを接続してサインインしてください。",
                    "es": "Conecta tu billetera para iniciar sesión.",
                    "ar": "قم بتوصيل محفظتك لتسجيل الدخول."
                },
                "LOGIN_FAILED": {
                    "en": "Login failed. Please check your credentials.",
                    "ja": "ログインに失敗しました。入力内容をご確認ください。",
                    "es": "Error de inicio de sesión. Verifica tus credenciales.",
                    "ar": "فشل تسجيل الدخول. يرجى التحقق من بيانات الاعتماد الخاصة بك."
                },
                "LOGIN_EMAIL_AVAILABLE": {
                    "en": "Email available",
                    "ja": "メールアドレスは利用可能です",
                    "es": "Correo disponible",
                    "ar": "البريد الإلكتروني متاح"
                },
                "LOGIN_ALREADY_REGISTERED_EMAIL": {
                    "en": "Email already registered",
                    "ja": "メールアドレスはすでに登録されています",
                    "es": "Correo ya registrado",
                    "ar": "البريد الإلكتروني مسجّل مسبقاً"
                },
                "CONTACT_WILL_CONTACT": {
                    "en": "Registration successful! Please check your email.",
                    "ja": "登録が成功しました！メールを確認してください。",
                    "es": "¡Registro exitoso! Revisa tu correo.",
                    "ar": "تم التسجيل بنجاح! يرجى التحقق من بريدك الإلكتروني."
                },
                "CONTACT_ERROR": {
                    "en": "An error occurred. Please try again.",
                    "ja": "エラーが発生しました。もう一度お試しください。",
                    "es": "Ocurrió un error. Inténtalo de nuevo.",
                    "ar": "حدث خطأ. يرجى المحاولة مرة أخرى."
                },
                "TEXT_ABOUT": {
                    "en": "About",
                    "ja": "会社概要",
                    "es": "Acerca de",
                    "ar": "حول"
                },
                "APP_SET_EMAIL": {
                    "en": "Set e-mail",
                    "ja": "メールアドレスを入力",
                    "es": "Establecer correo",
                    "ar": "تعيين البريد الإلكتروني"
                },
                "TEXT_TERMS_CONDITIONS": {
                    "en": "Terms and Conditions",
                    "ja": "利用規約",
                    "es": "Términos y condiciones",
                    "ar": "الشروط والأحكام"
                },
                "LOGIN_INVALID_EMAIL": {
                    "en": "Please enter a valid email address",
                    "ja": "有効なメールアドレスを入力してください",
                    "es": "Ingresa un correo electrónico válido",
                    "ar": "يرجى إدخال عنوان بريد إلكتروني صالح"
                },

                // ---- Hero Section ----
                "HERO_BADGE": {
                    "en": "Agentic AI Cybersecurity",
                    "ja": "AI自律型サイバーセキュリティ",
                    "es": "Ciberseguridad con IA Agéntica",
                    "ar": "الأمن السيبراني بالذكاء الاصطناعي الوكيل"
                },
                "HERO_TITLE_1": {
                    "en": "Autonomous Defense",
                    "ja": "自律型防御",
                    "es": "Defensa Autónoma",
                    "ar": "دفاع ذاتي"
                },
                "HERO_TITLE_2": {
                    "en": "for the Modern Threat Landscape",
                    "ja": "攻撃がAIなら、防御もAIで",
                    "es": "para el Panorama de Amenazas Moderno",
                    "ar": "لمشهد التهديدات الحديث"
                },
                "HERO_SUBTITLE": {
                    "en": "AI agents that think, adapt, and respond — securing your infrastructure before threats materialize.",
                    "ja": "自ら考え、学習し、即座に対応するAIが、脅威が現実になる前にお客様のシステムを守り続けます。",
                    "es": "Agentes de IA que piensan, se adaptan y responden — protegiendo tu infraestructura antes de que las amenazas se materialicen.",
                    "ar": "وكلاء ذكاء اصطناعي يفكرون ويتكيفون ويستجيبون — لتأمين بنيتك التحتية قبل أن تتحقق التهديدات."
                },
                "HERO_CTA_PRIMARY": {
                    "en": "Request Early Access",
                    "ja": "先行アクセスに申し込む",
                    "es": "Solicitar Acceso Anticipado",
                    "ar": "طلب الوصول المبكر"
                },
                "HERO_CTA_SECONDARY": {
                    "en": "Learn More",
                    "ja": "詳細を見る",
                    "es": "Más información",
                    "ar": "اعرف المزيد"
                },
                "HERO_STAT_THREATS": {
                    "en": "Threats Identified",
                    "ja": "検出された脅威",
                    "es": "Amenazas Neutralizadas",
                    "ar": "التهديدات المكتشفة"
                },
                "HERO_STAT_RESPONSE": {
                    "en": "Response Time",
                    "ja": "応答時間",
                    "es": "Tiempo de Respuesta",
                    "ar": "وقت الاستجابة"
                },
                "HERO_STAT_UPTIME": {
                    "en": "Uptime",
                    "ja": "稼働率",
                    "es": "Disponibilidad",
                    "ar": "وقت التشغيل"
                },

                // ---- Features Section ----
                "FEATURES_TITLE": {
                    "en": "Intelligent Security, Autonomous Operations",
                    "ja": "賢く守る、自動で動く",
                    "es": "Seguridad Inteligente, Operaciones Autónomas",
                    "ar": "أمن ذكي، عمليات ذاتية"
                },
                "FEATURES_SUBTITLE": {
                    "en": "Our AI agents work around the clock, learning and evolving to stay ahead of emerging threats.",
                    "ja": "AIが24時間365日、休むことなく最新の脅威を学習しながらお客様の環境を守り続けます。",
                    "es": "Nuestros agentes de IA trabajan las 24 horas, aprendiendo y evolucionando para adelantarse a las amenazas emergentes.",
                    "ar": "وكلاء الذكاء الاصطناعي لدينا يعملون على مدار الساعة، يتعلمون ويتطورون للبقاء متقدمين على التهديدات الناشئة."
                },
                "FEATURE_SHIELD_TITLE": {
                    "en": "Adaptive Threat Shield",
                    "ja": "攻撃に適応する防御",
                    "es": "Escudo de Amenazas Adaptativo",
                    "ar": "درع التهديدات التكيفي"
                },
                "FEATURE_SHIELD_DESC": {
                    "en": "Real-time threat detection that evolves with attack patterns, neutralizing zero-day exploits autonomously.",
                    "ja": "攻撃手法の変化に合わせて進化し続け、未知のゼロデイ攻撃もリアルタイムで自動的に阻止します。",
                    "es": "Detección de amenazas en tiempo real que evoluciona con los patrones de ataque, neutralizando exploits de día cero de forma autónoma.",
                    "ar": "كشف التهديدات في الوقت الفعلي يتطور مع أنماط الهجوم، ويحيّد ثغرات اليوم صفر بشكل ذاتي."
                },
                "FEATURE_BRAIN_TITLE": {
                    "en": "Neural Threat Analysis",
                    "ja": "AI脅威分析",
                    "es": "Análisis Neuronal de Amenazas",
                    "ar": "تحليل التهديدات العصبي"
                },
                "FEATURE_BRAIN_DESC": {
                    "en": "Deep learning models that understand attacker behavior, predicting and preventing breaches before they occur.",
                    "ja": "攻撃者の行動パターンを深く理解し、被害が起きる前に脅威を予測・遮断します。",
                    "es": "Modelos de aprendizaje profundo que comprenden el comportamiento del atacante, prediciendo y previniendo brechas antes de que ocurran.",
                    "ar": "نماذج التعلم العميق التي تفهم سلوك المهاجمين، وتتنبأ بالاختراقات وتمنعها قبل حدوثها."
                },
                "FEATURE_RADAR_TITLE": {
                    "en": "Continuous Reconnaissance",
                    "ja": "常時モニタリング",
                    "es": "Reconocimiento Continuo",
                    "ar": "الاستطلاع المستمر"
                },
                "FEATURE_RADAR_DESC": {
                    "en": "24/7 autonomous scanning of your attack surface, identifying vulnerabilities across all endpoints.",
                    "ja": "すべての端末を24時間365日自動でスキャンし、脆弱性を漏れなく検出します。",
                    "es": "Escaneo autónomo 24/7 de tu superficie de ataque, identificando vulnerabilidades en todos los endpoints.",
                    "ar": "مسح ذاتي على مدار الساعة لسطح الهجوم الخاص بك، لتحديد الثغرات عبر جميع نقاط النهاية."
                },
                "FEATURE_LOCK_TITLE": {
                    "en": "Zero-Trust Enforcement",
                    "ja": "ゼロトラストの徹底",
                    "es": "Aplicación Zero-Trust",
                    "ar": "تطبيق Zero Trust"
                },
                "FEATURE_LOCK_DESC": {
                    "en": "Intelligent access control that verifies every request, adapting permissions based on behavioral analysis.",
                    "ja": "すべてのアクセスを検証し、ユーザーの行動パターンに基づいて権限を動的に制御。不正アクセスを未然に防ぎます。",
                    "es": "Control de acceso inteligente que verifica cada solicitud, adaptando permisos según el análisis de comportamiento.",
                    "ar": "تحكم ذكي في الوصول يتحقق من كل طلب، ويكيّف الصلاحيات بناءً على التحليل السلوكي."
                },
                "FEATURE_NETWORK_TITLE": {
                    "en": "Vendor Consolidation",
                    "ja": "ツールの一本化",
                    "es": "Consolidación de Proveedores",
                    "ar": "توحيد الموردين"
                },
                "FEATURE_NETWORK_DESC": {
                    "en": "Replace fragmented security toolchains and multi-vendor complexity with a single autonomous agent. Streamline your security team while gaining deeper coverage than legacy stacks.",
                    "ja": "バラバラだったセキュリティツールを1つのAIに集約。複数ベンダーの管理負担をなくし、従来より幅広い保護をより少ない人員で実現します。",
                    "es": "Reemplaza cadenas de herramientas fragmentadas y la complejidad multi-proveedor con un solo agente autónomo. Optimiza tu equipo de seguridad con una cobertura más profunda que las soluciones heredadas.",
                    "ar": "استبدل سلاسل أدوات الأمان المجزأة وتعقيد الموردين المتعددين بوكيل ذاتي واحد. بسّط فريق الأمان لديك مع تحقيق تغطية أعمق من الحلول القديمة."
                },
                "FEATURE_BOLT_TITLE": {
                    "en": "Instant Incident Response",
                    "ja": "瞬時のインシデント対応",
                    "es": "Respuesta Instantánea a Incidentes",
                    "ar": "استجابة فورية للحوادث"
                },
                "FEATURE_BOLT_DESC": {
                    "en": "Sub-second automated response to active threats, containing breaches and initiating recovery protocols instantly.",
                    "ja": "脅威を検知した瞬間に自動対応を開始。被害の拡大を防ぎ、復旧まで一気に進めます。",
                    "es": "Respuesta automatizada en menos de un segundo a amenazas activas, conteniendo brechas e iniciando protocolos de recuperación al instante.",
                    "ar": "استجابة آلية في أقل من ثانية للتهديدات النشطة، لاحتواء الاختراقات وبدء بروتوكولات الاسترداد فوراً."
                },

                // ---- Trusted Tester Section ----
                "TESTER_TITLE": {
                    "en": "Join the Trusted Tester Program",
                    "ja": "先行テストプログラムに参加する",
                    "es": "Únete al Programa de Testers Confiables",
                    "ar": "انضم إلى برنامج المختبرين الموثوقين"
                },
                "TESTER_DESC": {
                    "en": "Be among the first to experience autonomous AI cybersecurity. Early access members help shape the future of intelligent defense.",
                    "ja": "AI自律型セキュリティをいち早くお試しください。先行ユーザーの声が、次世代セキュリティの未来を形づくります。",
                    "es": "Sé de los primeros en experimentar la ciberseguridad autónoma con IA. Los miembros de acceso anticipado ayudan a dar forma al futuro de la defensa inteligente.",
                    "ar": "كن من أوائل من يختبر الأمن السيبراني الذاتي بالذكاء الاصطناعي. أعضاء الوصول المبكر يساعدون في تشكيل مستقبل الدفاع الذكي."
                },
                "TESTER_PLACEHOLDER": {
                    "en": "Enter your email",
                    "ja": "メールアドレスを入力",
                    "es": "Ingresa tu correo",
                    "ar": "أدخل بريدك الإلكتروني"
                },
                "TESTER_SUBMIT": {
                    "en": "Request Access",
                    "ja": "アクセスを申請",
                    "es": "Solicitar Acceso",
                    "ar": "طلب الوصول"
                },
                "TESTER_SUCCESS": {
                    "en": "Welcome aboard! We'll be in touch soon.",
                    "ja": "ようこそ！まもなくご連絡いたします。",
                    "es": "¡Bienvenido a bordo! Te contactaremos pronto.",
                    "ar": "مرحباً بك! سنتواصل معك قريباً."
                },
                "TESTER_ERROR": {
                    "en": "Something went wrong. Please try again.",
                    "ja": "エラーが発生しました。もう一度お試しください。",
                    "es": "Algo salió mal. Inténtalo de nuevo.",
                    "ar": "حدث خطأ ما. يرجى المحاولة مرة أخرى."
                },
                "TESTER_INVALID_EMAIL": {
                    "en": "Please enter a valid email address.",
                    "ja": "有効なメールアドレスを入力してください。",
                    "es": "Ingresa un correo electrónico válido.",
                    "ar": "يرجى إدخال عنوان بريد إلكتروني صالح."
                },

                // ---- Footer ----
                "FOOTER_BRAND_DESC": {
                    "en": "Agentic AI cybersecurity for the modern threat landscape.",
                    "ja": "進化する脅威に立ち向かう、AI自律型サイバーセキュリティ。",
                    "es": "Ciberseguridad con IA agéntica para el panorama de amenazas moderno.",
                    "ar": "الأمن السيبراني بالذكاء الاصطناعي الوكيل لمشهد التهديدات الحديث."
                },
                "FOOTER_COMPANY": {
                    "en": "Company",
                    "ja": "会社",
                    "es": "Empresa",
                    "ar": "الشركة"
                },
                "FOOTER_LEGAL": {
                    "en": "Legal",
                    "ja": "法務",
                    "es": "Legal",
                    "ar": "الشؤون القانونية"
                },
                "FOOTER_PRIVACY": {
                    "en": "Privacy Policy",
                    "ja": "プライバシーポリシー",
                    "es": "Política de privacidad",
                    "ar": "سياسة الخصوصية"
                },
                "FOOTER_COPYRIGHT": {
                    "en": "All Rights Reserved.",
                    "ja": "All Rights Reserved.",
                    "es": "Todos los derechos reservados.",
                    "ar": "جميع الحقوق محفوظة."
                },
                "FOOTER_PRODUCT": {
                    "en": "Product",
                    "ja": "製品",
                    "es": "Producto",
                    "ar": "المنتج"
                },

                // ---- Navigation ----
                "TEXT_TECHNOLOGY": {
                    "en": "Technology",
                    "ja": "技術",
                    "es": "Tecnología",
                    "ar": "التكنولوجيا"
                },

                // ---- Technology Page: Hero ----
                "TECH_BADGE": {
                    "en": "Cross-Platform Endpoint Security",
                    "ja": "マルチOS対応の端末セキュリティ",
                    "es": "Seguridad de Endpoints Multiplataforma",
                    "ar": "أمن نقاط النهاية عبر المنصات"
                },
                "TECH_HERO_TITLE": {
                    "en": "Security Without Surveillance",
                    "ja": "監視されないセキュリティ",
                    "es": "Seguridad Sin Vigilancia",
                    "ar": "أمن بدون مراقبة"
                },
                "TECH_HERO_SUBTITLE": {
                    "en": "Enbarr is a next-generation endpoint security platform that monitors your systems for threats without sending your data to the cloud. AI-powered threat detection across Windows, macOS, and Linux — entirely self-contained within your network.",
                    "ja": "Enbarrは、お客様のデータを外部に送信せずにシステムを守る次世代セキュリティです。Windows・macOS・LinuxすべてのAI脅威検出が、お客様のネットワーク内だけで完結します。",
                    "es": "Enbarr es una plataforma de seguridad de endpoints de próxima generación que monitorea tus sistemas en busca de amenazas sin enviar datos a la nube. Detección de amenazas impulsada por IA en Windows, macOS y Linux — completamente autónoma dentro de tu red.",
                    "ar": "Enbarr هي منصة أمن نقاط النهاية من الجيل التالي التي تراقب أنظمتك بحثاً عن التهديدات دون إرسال بياناتك إلى السحابة. كشف التهديدات المدعوم بالذكاء الاصطناعي عبر Windows وmacOS وLinux — بشكل مستقل تماماً داخل شبكتك."
                },

                // ---- Technology Page: Problem Section ----
                "TECH_PROBLEM_TITLE": {
                    "en": "The Problem with Enterprise Security",
                    "ja": "企業セキュリティが抱える課題",
                    "es": "El Problema con la Seguridad Empresarial",
                    "ar": "مشكلة أمن المؤسسات"
                },
                "TECH_PROBLEM_INTRO": {
                    "en": "Modern endpoint security has a fundamental flaw: it works by surveilling you. Every process you run, every file you open, every connection you make — enterprise EDR solutions capture it all and stream it to their cloud infrastructure. They promise protection, but demand complete visibility into your operations in return.",
                    "ja": "今のセキュリティ製品には根本的な矛盾があります。守るために、あなたを監視しているのです。実行するプロセス、開くファイル、すべての通信——従来のEDR製品はそのすべてを収集し、ベンダーのクラウドに送信します。「保護」と引き換えに、業務の完全な可視化を求められているのが現状です。",
                    "es": "La seguridad moderna de endpoints tiene un defecto fundamental: funciona vigilándote. Cada proceso que ejecutas, cada archivo que abres, cada conexión que realizas — las soluciones EDR empresariales capturan todo y lo transmiten a su infraestructura en la nube. Prometen protección, pero exigen visibilidad completa de tus operaciones a cambio.",
                    "ar": "أمن نقاط النهاية الحديث يعاني من خلل جوهري: فهو يعمل من خلال مراقبتك. كل عملية تنفذها، كل ملف تفتحه، كل اتصال تجريه — حلول EDR المؤسسية تلتقط كل ذلك وتنقله إلى بنيتها التحتية السحابية. تعد بالحماية، لكنها تطالب برؤية كاملة لعملياتك في المقابل."
                },
                "TECH_PROBLEM_1_TITLE": {
                    "en": "Privacy Erosion",
                    "ja": "プライバシーの流出",
                    "es": "Erosión de la Privacidad",
                    "ar": "تآكل الخصوصية"
                },
                "TECH_PROBLEM_1_DESC": {
                    "en": "Your sensitive operations are visible to your security vendor, creating a complete profile of your organization's activity on servers you don't control.",
                    "ja": "お客様の機密業務がベンダーに丸見えになり、管理できないサーバー上に組織の行動履歴がすべて蓄積されています。",
                    "es": "Tus operaciones sensibles son visibles para tu proveedor de seguridad, creando un perfil completo de la actividad de tu organización en servidores que no controlas.",
                    "ar": "عملياتك الحساسة مرئية لمورد الأمان الخاص بك، مما يخلق ملفاً كاملاً لنشاط مؤسستك على خوادم لا تتحكم فيها."
                },
                "TECH_PROBLEM_2_TITLE": {
                    "en": "Data Sovereignty Risk",
                    "ja": "データ管理権の喪失",
                    "es": "Riesgo de Soberanía de Datos",
                    "ar": "مخاطر سيادة البيانات"
                },
                "TECH_PROBLEM_2_DESC": {
                    "en": "Your data may cross borders and jurisdictions without your knowledge, violating compliance requirements and regulatory frameworks.",
                    "ja": "知らないうちにデータが国境を越え、コンプライアンスや各国の規制に抵触するリスクがあります。",
                    "es": "Tus datos pueden cruzar fronteras y jurisdicciones sin tu conocimiento, violando requisitos de cumplimiento y marcos regulatorios.",
                    "ar": "قد تعبر بياناتك الحدود والولايات القضائية دون علمك، مما ينتهك متطلبات الامتثال والأطر التنظيمية."
                },
                "TECH_PROBLEM_3_TITLE": {
                    "en": "Cloud Dependency",
                    "ja": "クラウド障害への脆弱性",
                    "es": "Dependencia de la Nube",
                    "ar": "الاعتماد على السحابة"
                },
                "TECH_PROBLEM_3_DESC": {
                    "en": "If the vendor's cloud goes down, your protection degrades. Your organization's security depends entirely on third-party infrastructure you don't control.",
                    "ja": "ベンダーのクラウドが止まれば、防御も止まります。自社で管理できない外部インフラに、セキュリティの命運を預けることになります。",
                    "es": "Si la nube del proveedor se cae, tu protección se degrada. La seguridad de tu organización depende completamente de infraestructura de terceros que no controlas.",
                    "ar": "إذا تعطلت سحابة المورد، تتدهور حمايتك. يعتمد أمن مؤسستك كلياً على بنية تحتية لطرف ثالث لا تتحكم فيها."
                },
                "TECH_PROBLEM_4_TITLE": {
                    "en": "Misplaced Trust",
                    "ja": "見合わない信頼",
                    "es": "Confianza Mal Depositada",
                    "ar": "ثقة في غير محلها"
                },
                "TECH_PROBLEM_4_DESC": {
                    "en": "You trust a third party with complete visibility into your operations. Despite all this data collection, breaches keep happening.",
                    "ja": "業務のすべてを第三者に見せているにもかかわらず、情報漏洩は後を絶ちません。データを渡しても、守られるとは限らないのです。",
                    "es": "Confías a un tercero con visibilidad completa de tus operaciones. A pesar de toda esta recopilación de datos, las brechas siguen ocurriendo.",
                    "ar": "تمنح ثقتك لطرف ثالث برؤية كاملة لعملياتك. رغم كل هذا الجمع للبيانات، تستمر الاختراقات في الحدوث."
                },

                // ---- Technology Page: Approach Section ----
                "TECH_APPROACH_TITLE": {
                    "en": "A Different Approach",
                    "ja": "Enbarrのアプローチ",
                    "es": "Un Enfoque Diferente",
                    "ar": "نهج مختلف"
                },
                "TECH_APPROACH_1_TITLE": {
                    "en": "Your Data Stays Yours",
                    "ja": "データは自社で管理",
                    "es": "Tus Datos Son Tuyos",
                    "ar": "بياناتك تبقى ملكك"
                },
                "TECH_APPROACH_1_DESC": {
                    "en": "All monitoring, analysis, and detection happens locally. Enbarr never phones home. No vendor dependency, no third-party data processing. Replace fragmented security toolchains with a single autonomous agent — streamline your team and eliminate multi-vendor complexity.",
                    "ja": "監視・分析・検出のすべてがお客様の環境内で完結。Enbarrは外部にデータを送信しません。ベンダー依存ゼロ、外部データ処理ゼロ。バラバラだったツールを1つに集約し、チームの負担を減らしながら、より確実なセキュリティを実現します。",
                    "es": "Todo el monitoreo, análisis y detección ocurre localmente. Enbarr nunca se comunica con el exterior. Sin dependencia de proveedores, sin procesamiento de datos de terceros. Reemplaza cadenas de herramientas fragmentadas con un solo agente autónomo — optimiza tu equipo y elimina la complejidad multi-proveedor.",
                    "ar": "كل المراقبة والتحليل والكشف يحدث محلياً. Enbarr لا يتصل بأي جهة خارجية. لا اعتماد على مورد، لا معالجة بيانات من طرف ثالث. استبدل سلاسل أدوات الأمان المجزأة بوكيل ذاتي واحد — بسّط فريقك وأزل تعقيد الموردين المتعددين."
                },
                "TECH_APPROACH_2_TITLE": {
                    "en": "AI-Native Architecture",
                    "ja": "AIを前提に設計",
                    "es": "Arquitectura Nativa de IA",
                    "ar": "هندسة أصيلة للذكاء الاصطناعي"
                },
                "TECH_APPROACH_2_DESC": {
                    "en": "Built from the ground up for AI analysis. A novel planner uses parallel execution to perform machine learning analysis in seconds — understanding attack chains, not just matching patterns. Bring your own model or use ours.",
                    "ja": "AI分析を前提にゼロから設計。独自の分析エンジンが並列処理で数秒のうちに機械学習分析を完了し、単なるパターン照合ではなく攻撃の流れ全体を把握します。お手持ちのAIモデルも利用可能です。",
                    "es": "Construido desde cero para análisis de IA. Un planificador novedoso utiliza ejecución paralela para realizar análisis de aprendizaje automático en segundos — entendiendo cadenas de ataque, no solo coincidiendo patrones. Trae tu propio modelo o usa el nuestro.",
                    "ar": "مبني من الصفر لتحليل الذكاء الاصطناعي. مخطط مبتكر يستخدم التنفيذ المتوازي لإجراء تحليل التعلم الآلي في ثوانٍ — فهم سلاسل الهجوم، وليس مجرد مطابقة الأنماط. أحضر نموذجك الخاص أو استخدم نموذجنا."
                },
                "TECH_APPROACH_3_TITLE": {
                    "en": "Distributed Intelligence",
                    "ja": "分散型の脅威共有",
                    "es": "Inteligencia Distribuida",
                    "ar": "ذكاء موزّع"
                },
                "TECH_APPROACH_3_DESC": {
                    "en": "Enbarr nodes form a gossip network within your infrastructure, sharing threat intelligence in real time. When one system sees something suspicious, others are warned instantly — no central cloud required. Your organization builds its own collective immunity.",
                    "ja": "Enbarrの各端末が自律的にネットワークを形成し、脅威情報をリアルタイムで共有します。1台が不審な動きを検知すれば、他の端末にも即座に警告。中央サーバー不要で、組織全体が自動的に防御力を高めていきます。",
                    "es": "Los nodos de Enbarr forman una red gossip dentro de tu infraestructura, compartiendo inteligencia de amenazas en tiempo real. Cuando un sistema detecta algo sospechoso, los demás son alertados instantáneamente — sin nube central requerida. Tu organización construye su propia inmunidad colectiva.",
                    "ar": "عُقد Enbarr تشكل شبكة gossip داخل بنيتك التحتية، وتتشارك استخبارات التهديدات في الوقت الفعلي. عندما يرصد نظام ما شيئاً مريباً، يتم تحذير الأنظمة الأخرى فوراً — دون الحاجة لسحابة مركزية. مؤسستك تبني مناعتها الجماعية الخاصة."
                },

                // ---- Technology Page: Capabilities ----
                "TECH_CAP_TITLE": {
                    "en": "Platform Capabilities",
                    "ja": "プラットフォーム機能",
                    "es": "Capacidades de la Plataforma",
                    "ar": "قدرات المنصة"
                },
                "TECH_CAP_SUBTITLE": {
                    "en": "Deep system telemetry across every major operating system, powered by native OS instrumentation.",
                    "ja": "OS標準の計測機能を活用し、主要OSすべてでシステム内部の動きを詳細に把握します。",
                    "es": "Telemetría profunda del sistema en todos los principales sistemas operativos, impulsada por instrumentación nativa del SO.",
                    "ar": "قياس عن بُعد عميق للنظام عبر جميع أنظمة التشغيل الرئيسية، مدعوم بأدوات قياس نظام التشغيل الأصلية."
                },
                "TECH_CAP_TELEMETRY_TITLE": {
                    "en": "Deep System Telemetry",
                    "ja": "システム内部の詳細な可視化",
                    "es": "Telemetría Profunda del Sistema",
                    "ar": "قياس عن بُعد عميق للنظام"
                },
                "TECH_CAP_TELEMETRY_DESC": {
                    "en": "Comprehensive activity monitoring using native OS instrumentation across Windows, macOS, and Linux. Process lifecycle, network connections, file system activity, configuration changes, authentication events, script execution, and device connections — all captured locally.",
                    "ja": "Windows・macOS・LinuxのOS標準機能を活用した包括的な監視。プロセスの起動から終了、ネットワーク通信、ファイル操作、設定変更、認証、スクリプト実行、デバイス接続まで、すべてお客様の環境内で記録されます。",
                    "es": "Monitoreo integral de actividad utilizando instrumentación nativa del SO en Windows, macOS y Linux. Ciclo de vida de procesos, conexiones de red, actividad del sistema de archivos, cambios de configuración, eventos de autenticación, ejecución de scripts y conexiones de dispositivos — todo capturado localmente.",
                    "ar": "مراقبة شاملة للنشاط باستخدام أدوات قياس نظام التشغيل الأصلية عبر Windows وmacOS وLinux. دورة حياة العمليات، اتصالات الشبكة، نشاط نظام الملفات، تغييرات التكوين، أحداث المصادقة، تنفيذ البرامج النصية، واتصالات الأجهزة — كلها ملتقطة محلياً."
                },
                "TECH_CAP_INJECTION_TITLE": {
                    "en": "Injection Chain Detection",
                    "ja": "攻撃チェーンの検出",
                    "es": "Detección de Cadenas de Inyección",
                    "ar": "كشف سلاسل الحقن"
                },
                "TECH_CAP_INJECTION_DESC": {
                    "en": "Correlates related system operations to surface complete attack chains. Instead of isolated alerts, Enbarr connects the dots across processes and time — showing you the full story of how an attack unfolds, not just fragments.",
                    "ja": "バラバラのアラートではなく、攻撃の全体像を把握。関連するシステム操作を時系列で結びつけ、攻撃がどのように広がっていくかを一目で理解できます。",
                    "es": "Correlaciona operaciones del sistema relacionadas para revelar cadenas de ataque completas. En lugar de alertas aisladas, Enbarr conecta los puntos a través de procesos y tiempo — mostrándote la historia completa de cómo se desarrolla un ataque, no solo fragmentos.",
                    "ar": "يربط العمليات المتعلقة بالنظام لإظهار سلاسل الهجوم الكاملة. بدلاً من التنبيهات المعزولة، يربط Enbarr النقاط عبر العمليات والزمن — ليعرض لك القصة الكاملة لكيفية تطور الهجوم، وليس مجرد أجزاء."
                },
                "TECH_CAP_MEMORY_TITLE": {
                    "en": "Memory Analysis",
                    "ja": "メモリ分析",
                    "es": "Análisis de Memoria",
                    "ar": "تحليل الذاكرة"
                },
                "TECH_CAP_MEMORY_DESC": {
                    "en": "Deep runtime inspection that catches threats hiding in memory — the attacks that never touch disk and bypass traditional antivirus. Enbarr identifies malicious payloads, classifies risk levels, and extracts indicators of compromise in real time.",
                    "ja": "ディスクに痕跡を残さず従来のウイルス対策をすり抜ける高度な攻撃も、メモリ上でリアルタイムに検知。悪意のあるコードを特定し、リスクを評価し、侵害の痕跡を即座に抽出します。",
                    "es": "Inspección profunda en tiempo de ejecución que detecta amenazas ocultas en memoria — los ataques que nunca tocan el disco y evaden el antivirus tradicional. Enbarr identifica payloads maliciosos, clasifica niveles de riesgo y extrae indicadores de compromiso en tiempo real.",
                    "ar": "فحص عميق أثناء التشغيل يلتقط التهديدات المختبئة في الذاكرة — الهجمات التي لا تلمس القرص وتتجاوز مضاد الفيروسات التقليدي. Enbarr يحدد الحمولات الخبيثة، ويصنف مستويات المخاطر، ويستخلص مؤشرات الاختراق في الوقت الفعلي."
                },
                "TECH_CAP_SUMMARY_TITLE": {
                    "en": "Intelligent Insight",
                    "ja": "わかりやすい分析結果",
                    "es": "Información Inteligente",
                    "ar": "رؤية ذكية"
                },
                "TECH_CAP_SUMMARY_DESC": {
                    "en": "Chat with the agent to get easy-to-understand information about your security posture and take corrective actions. Instead of overwhelming log volumes, conversational AI translates complex threats into clear guidance — so you can respond faster and with confidence.",
                    "ja": "AIとの対話で、セキュリティの状況をすぐに把握し、適切な対策を実行できます。大量のログを読み解く必要はありません。複雑な脅威情報をわかりやすい日本語で説明し、迅速で的確な判断をサポートします。",
                    "es": "Chatea con el agente para obtener información fácil de entender sobre tu postura de seguridad y tomar acciones correctivas. En lugar de volúmenes abrumadores de logs, la IA conversacional traduce amenazas complejas en orientación clara — para que puedas responder más rápido y con confianza.",
                    "ar": "تحدّث مع الوكيل للحصول على معلومات سهلة الفهم حول وضعك الأمني واتخاذ إجراءات تصحيحية. بدلاً من أحجام السجلات الهائلة، الذكاء الاصطناعي المحادثاتي يترجم التهديدات المعقدة إلى إرشادات واضحة — لتتمكن من الاستجابة بشكل أسرع وبثقة."
                },

                // ---- Technology Page: Roadmap ----
                "TECH_ROADMAP_TITLE": {
                    "en": "Roadmap",
                    "ja": "ロードマップ",
                    "es": "Hoja de Ruta",
                    "ar": "خارطة الطريق"
                },
                "TECH_ROADMAP_SUBTITLE": {
                    "en": "Where we're headed — from passive observation to active, autonomous defense.",
                    "ja": "「見るだけ」から「自ら守る」セキュリティへ。Enbarrの進化の方向性をご紹介します。",
                    "es": "Hacia dónde nos dirigimos — de la observación pasiva a la defensa activa y autónoma.",
                    "ar": "إلى أين نتجه — من المراقبة السلبية إلى الدفاع النشط الذاتي."
                },
                "TECH_ROADMAP_1_TITLE": {
                    "en": "Threat Intelligence Integration",
                    "ja": "脅威情報との連携",
                    "es": "Integración de Inteligencia de Amenazas",
                    "ar": "تكامل استخبارات التهديدات"
                },
                "TECH_ROADMAP_1_DESC": {
                    "en": "Optional integration with threat feeds, hash reputation services, and YARA rules — all processed locally. Subscribe to the intelligence sources you trust, or bring your own.",
                    "ja": "脅威フィード、ハッシュ評価サービス、YARAルールとの連携に対応。すべてローカルで処理されます。信頼できる情報源を選ぶことも、独自のものを利用することも可能です。",
                    "es": "Integración opcional con feeds de amenazas, servicios de reputación de hashes y reglas YARA — todo procesado localmente. Suscríbete a las fuentes de inteligencia en las que confías, o trae las tuyas.",
                    "ar": "تكامل اختياري مع خلاصات التهديدات وخدمات سمعة التجزئة وقواعد YARA — كلها تُعالج محلياً. اشترك في مصادر الاستخبارات التي تثق بها، أو أحضر مصادرك الخاصة."
                },
                "TECH_ROADMAP_2_TITLE": {
                    "en": "Agentic Response",
                    "ja": "AIによる自律対応",
                    "es": "Respuesta Agéntica",
                    "ar": "الاستجابة الوكيلة"
                },
                "TECH_ROADMAP_2_DESC": {
                    "en": "AI agents that don't just observe but act. Automated investigation, threat hunting, and response — with human approval gates where you want them.",
                    "ja": "見るだけでなく行動するAI。調査、脅威の追跡、対応まで自動化しながら、重要な判断には人間の承認を挟めます。",
                    "es": "Agentes de IA que no solo observan sino que actúan. Investigación automatizada, caza de amenazas y respuesta — con puertas de aprobación humana donde las necesites.",
                    "ar": "وكلاء ذكاء اصطناعي لا يكتفون بالمراقبة بل يتصرفون. تحقيق آلي، صيد التهديدات، واستجابة — مع بوابات موافقة بشرية حيث تريدها."
                },
                "TECH_ROADMAP_3_TITLE": {
                    "en": "Reactive Containment",
                    "ja": "即時封じ込め",
                    "es": "Contención Reactiva",
                    "ar": "الاحتواء التفاعلي"
                },
                "TECH_ROADMAP_3_DESC": {
                    "en": "Network isolation, process termination, and script blocking when threats are confirmed. Moving from passive observation to active protection.",
                    "ja": "脅威を確認次第、ネットワーク隔離・プロセス停止・スクリプト遮断を自動実行。監視するだけの時代から、能動的に守る時代へ。",
                    "es": "Aislamiento de red, terminación de procesos y bloqueo de scripts cuando se confirman amenazas. Pasando de la observación pasiva a la protección activa.",
                    "ar": "عزل الشبكة، إنهاء العمليات، وحظر البرامج النصية عند تأكيد التهديدات. الانتقال من المراقبة السلبية إلى الحماية الفعّالة."
                },
                "TECH_ROADMAP_4_TITLE": {
                    "en": "3D Visualization Dashboard",
                    "ja": "3D可視化ダッシュボード",
                    "es": "Dashboard de Visualización 3D",
                    "ar": "لوحة معلومات التصور ثلاثية الأبعاد"
                },
                "TECH_ROADMAP_4_DESC": {
                    "en": "An immersive interface for understanding your security posture. Visualize process relationships, network connections, and threat signals in an intuitive spatial environment.",
                    "ja": "セキュリティの全体像を直感的に把握できる3D表示。プロセス間の関係、通信経路、脅威の兆候を空間的に可視化します。",
                    "es": "Una interfaz inmersiva para comprender tu postura de seguridad. Visualiza relaciones de procesos, conexiones de red y señales de amenazas en un entorno espacial intuitivo.",
                    "ar": "واجهة غامرة لفهم وضعك الأمني. تصوّر علاقات العمليات واتصالات الشبكة وإشارات التهديد في بيئة مكانية بديهية."
                },
                "TECH_ROADMAP_5_TITLE": {
                    "en": "Mesh Networking",
                    "ja": "メッシュネットワーキング",
                    "es": "Red Mesh",
                    "ar": "الشبكات المتداخلة"
                },
                "TECH_ROADMAP_5_DESC": {
                    "en": "A gossip network that lets Enbarr nodes share threat intelligence across your organization. Distributed defense without centralized infrastructure. Optional anonymized signal sharing across organizations.",
                    "ja": "Enbarrの端末同士が自動的に脅威情報を共有する分散ネットワーク。中央サーバーなしで組織全体を防御。組織間での匿名化された脅威シグナルの共有も可能です。",
                    "es": "Una red gossip que permite a los nodos Enbarr compartir inteligencia de amenazas en toda tu organización. Defensa distribuida sin infraestructura centralizada. Compartición opcional de señales anonimizadas entre organizaciones.",
                    "ar": "شبكة gossip تتيح لعُقد Enbarr مشاركة استخبارات التهديدات عبر مؤسستك. دفاع موزّع بدون بنية تحتية مركزية. مشاركة اختيارية لإشارات مجهولة الهوية بين المؤسسات."
                },

                // ---- Technology Page: Architecture ----
                "TECH_ARCH_TITLE": {
                    "en": "Technical Architecture",
                    "ja": "技術アーキテクチャ",
                    "es": "Arquitectura Técnica",
                    "ar": "الهندسة التقنية"
                },
                "TECH_ARCH_SUBTITLE": {
                    "en": "Everything runs within your network. No cloud required.",
                    "ja": "すべてがお客様のネットワーク内で完結。クラウド不要です。",
                    "es": "Todo funciona dentro de tu red. Sin nube requerida.",
                    "ar": "كل شيء يعمل داخل شبكتك. لا حاجة للسحابة."
                },
                "TECH_ARCH_1_TITLE": {
                    "en": "Native OS Collection",
                    "ja": "OS標準の情報収集",
                    "es": "Recopilación Nativa del SO",
                    "ar": "جمع نظام التشغيل الأصلي"
                },
                "TECH_ARCH_1_DESC": {
                    "en": "Non-invasive telemetry collection using each platform's built-in instrumentation. No kernel driver required for observation capabilities.",
                    "ja": "各OSの標準機能を活用した、システムに負担をかけない情報収集。カーネルドライバのインストールは不要です。",
                    "es": "Recopilación de telemetría no invasiva utilizando la instrumentación integrada de cada plataforma. Sin necesidad de driver de kernel para capacidades de observación.",
                    "ar": "جمع قياس عن بُعد غير تدخلي باستخدام أدوات القياس المدمجة في كل منصة. لا حاجة لبرنامج تشغيل النواة لقدرات المراقبة."
                },
                "TECH_ARCH_2_TITLE": {
                    "en": "Structured Signal Output",
                    "ja": "構造化されたレポート出力",
                    "es": "Salida de Señales Estructuradas",
                    "ar": "مخرجات إشارات منظمة"
                },
                "TECH_ARCH_2_DESC": {
                    "en": "Activity summaries in markdown and JSON formats, designed for both human readability and LLM consumption.",
                    "ja": "MarkdownとJSON形式で出力される活動レポート。人間にもAIにも読みやすい設計です。",
                    "es": "Resúmenes de actividad en formatos markdown y JSON, diseñados tanto para legibilidad humana como para consumo por LLM.",
                    "ar": "ملخصات نشاط بتنسيقات markdown وJSON، مصممة لقراءة البشر واستهلاك نماذج اللغة الكبيرة."
                },
                "TECH_ARCH_3_TITLE": {
                    "en": "Local AI Processing",
                    "ja": "ローカルAI処理",
                    "es": "Procesamiento de IA Local",
                    "ar": "معالجة الذكاء الاصطناعي محلياً"
                },
                "TECH_ARCH_3_DESC": {
                    "en": "On-device inference for threat analysis. Your security decisions are made on your hardware, by your models.",
                    "ja": "脅威分析をお客様の端末上で実行。セキュリティの判断は、お客様自身のハードウェアとモデルで行われます。",
                    "es": "Inferencia en el dispositivo para análisis de amenazas. Tus decisiones de seguridad se toman en tu hardware, por tus modelos.",
                    "ar": "استدلال على الجهاز لتحليل التهديدات. قرارات الأمان الخاصة بك تُتخذ على أجهزتك، بنماذجك."
                },
                "TECH_ARCH_4_TITLE": {
                    "en": "Gossip Network",
                    "ja": "自律分散ネットワーク",
                    "es": "Red Gossip",
                    "ar": "شبكة Gossip"
                },
                "TECH_ARCH_4_DESC": {
                    "en": "A gossip network that shares threat intelligence across your endpoints — encrypted, decentralized, and entirely within your control.",
                    "ja": "すべての端末間で脅威情報を共有する自律分散ネットワーク。暗号化済み、中央サーバー不要、すべてお客様の管理下にあります。",
                    "es": "Una red gossip que comparte inteligencia de amenazas en todos tus endpoints — cifrada, descentralizada y completamente bajo tu control.",
                    "ar": "شبكة gossip تشارك استخبارات التهديدات عبر نقاط النهاية الخاصة بك — مشفرة، لا مركزية، وتحت سيطرتك الكاملة."
                },

                // ---- Technology Page: Audience ----
                "TECH_AUDIENCE_TITLE": {
                    "en": "Who Is Enbarr For",
                    "ja": "こんな方におすすめ",
                    "es": "Para Quién Es Enbarr",
                    "ar": "لمن صُمم Enbarr"
                },
                "TECH_AUDIENCE_1_TITLE": {
                    "en": "Privacy-Conscious Organizations",
                    "ja": "データ保護を重視する企業",
                    "es": "Organizaciones Conscientes de la Privacidad",
                    "ar": "المؤسسات الواعية بالخصوصية"
                },
                "TECH_AUDIENCE_1_DESC": {
                    "en": "Companies that take data protection seriously and want full operational independence from third-party security infrastructure.",
                    "ja": "データ保護に真剣に取り組み、外部ベンダーに業務データを預けたくない企業に最適です。",
                    "es": "Empresas que toman en serio la protección de datos y no quieren que los proveedores de seguridad vigilen sus operaciones.",
                    "ar": "الشركات التي تأخذ حماية البيانات على محمل الجد وتريد استقلالية تشغيلية كاملة عن البنية التحتية الأمنية لأطراف ثالثة."
                },
                "TECH_AUDIENCE_2_TITLE": {
                    "en": "Critical Industries",
                    "ja": "規制の厳しい業界",
                    "es": "Industrias Críticas",
                    "ar": "القطاعات الحيوية"
                },
                "TECH_AUDIENCE_2_DESC": {
                    "en": "Healthcare, finance, legal, and government organizations with strict data handling requirements.",
                    "ja": "医療・金融・法律・行政など、データ管理に厳格な基準が求められる組織。",
                    "es": "Organizaciones de salud, finanzas, legal y gobierno con requisitos estrictos de manejo de datos.",
                    "ar": "مؤسسات الرعاية الصحية والمالية والقانونية والحكومية ذات متطلبات التعامل الصارم مع البيانات."
                },
                "TECH_AUDIENCE_3_TITLE": {
                    "en": "Air-Gapped Environments",
                    "ja": "閉域ネットワーク環境",
                    "es": "Entornos Aislados",
                    "ar": "البيئات المعزولة"
                },
                "TECH_AUDIENCE_3_DESC": {
                    "en": "Networks that cannot or should not have internet connectivity. Defense, critical infrastructure, research facilities.",
                    "ja": "インターネット接続できない、またはすべきでない環境。防衛・社会インフラ・研究機関など。",
                    "es": "Redes que no pueden o no deben tener conectividad a internet. Defensa, infraestructura crítica, instalaciones de investigación.",
                    "ar": "الشبكات التي لا يمكنها أو لا ينبغي لها الاتصال بالإنترنت. الدفاع، البنية التحتية الحيوية، مرافق البحث."
                },
                "TECH_AUDIENCE_4_TITLE": {
                    "en": "Security Researchers",
                    "ja": "セキュリティ研究者",
                    "es": "Investigadores de Seguridad",
                    "ar": "باحثو الأمن"
                },
                "TECH_AUDIENCE_4_DESC": {
                    "en": "A transparent, extensible platform for understanding system internals and attack techniques across operating systems.",
                    "ja": "各OSのシステム内部や攻撃手法を深く理解するための、オープンで拡張可能な研究基盤。",
                    "es": "Una plataforma transparente y extensible para comprender los internos del sistema y técnicas de ataque en todos los sistemas operativos.",
                    "ar": "منصة شفافة وقابلة للتوسيع لفهم البنية الداخلية للأنظمة وتقنيات الهجوم عبر أنظمة التشغيل."
                },
                "TECH_AUDIENCE_5_TITLE": {
                    "en": "Managed Security Providers",
                    "ja": "セキュリティ運用代行事業者",
                    "es": "Proveedores de Seguridad Gestionada",
                    "ar": "مزودو الأمن المُدار"
                },
                "TECH_AUDIENCE_5_DESC": {
                    "en": "Offer clients enterprise-grade security without requiring their data to leave their premises.",
                    "ja": "顧客データを社外に出さずに、企業レベルのセキュリティサービスを提供できます。",
                    "es": "Ofrece a los clientes seguridad de nivel empresarial sin requerir que sus datos salgan de sus instalaciones.",
                    "ar": "قدّم للعملاء أماناً بمستوى المؤسسات دون الحاجة لخروج بياناتهم من مقراتهم."
                },
                "TECH_AUDIENCE_6_TITLE": {
                    "en": "Individuals Who Care",
                    "ja": "セキュリティに関心のある個人",
                    "es": "Individuos Conscientes",
                    "ar": "الأفراد المهتمون"
                },
                "TECH_AUDIENCE_6_DESC": {
                    "en": "Power users who want enterprise-grade visibility into their systems without enterprise-grade surveillance.",
                    "ja": "企業レベルのシステム可視化を、プライバシーを犠牲にせず手に入れたい上級ユーザー。",
                    "es": "Usuarios avanzados que quieren visibilidad de nivel empresarial en sus sistemas sin la vigilancia de nivel empresarial.",
                    "ar": "مستخدمون متقدمون يريدون رؤية بمستوى المؤسسات لأنظمتهم دون مراقبة بمستوى المؤسسات."
                },

                // ---- Technology Deep Dive Page ----
                "TP_BADGE": {
                    "en": "Technical Architecture",
                    "ja": "技術アーキテクチャ",
                    "es": "Arquitectura Técnica",
                    "ar": "الهندسة التقنية"
                },
                "TP_HERO_TITLE": {
                    "en": "Distributed Agentic Reasoning",
                    "ja": "分散型AI自律推論",
                    "es": "Razonamiento Agéntico Distribuido",
                    "ar": "الاستدلال الوكيل الموزّع"
                },
                "TP_HERO_SUBTITLE": {
                    "en": "A lightweight service on each endpoint collects security telemetry through multiple channels and synthesizes it into actionable intelligence — all without cloud dependencies.",
                    "ja": "各端末に常駐する軽量サービスが、複数の経路からセキュリティ情報を収集し、すぐに使える分析結果に変換します。クラウドへの依存はありません。",
                    "es": "Un servicio ligero en cada endpoint recopila telemetría de seguridad a través de múltiples canales y la sintetiza en inteligencia accionable — todo sin dependencias de la nube.",
                    "ar": "خدمة خفيفة على كل نقطة نهاية تجمع قياس الأمان عن بُعد عبر قنوات متعددة وتحولها إلى استخبارات قابلة للتنفيذ — كل ذلك بدون اعتماد على السحابة."
                },

                // ---- Telemetry Collection ----
                "TP_TELEMETRY_TITLE": {
                    "en": "Multi-Channel Telemetry",
                    "ja": "多層的なセキュリティ監視",
                    "es": "Telemetría Multicanal",
                    "ar": "قياس عن بُعد متعدد القنوات"
                },
                "TP_TELEMETRY_SUBTITLE": {
                    "en": "Deep integration with native OS instrumentation captures system-wide security events in real-time — surfacing threat intelligence that most third-party tools never see.",
                    "ja": "OS標準の計測機能と深く連携し、システム全体のセキュリティイベントをリアルタイムで取得。一般的なツールでは見逃される脅威の兆候も捉えます。",
                    "es": "La integración profunda con instrumentación nativa del SO captura eventos de seguridad de todo el sistema en tiempo real — revelando inteligencia de amenazas que la mayoría de herramientas de terceros nunca ven.",
                    "ar": "تكامل عميق مع أدوات قياس نظام التشغيل الأصلية يلتقط أحداث الأمان على مستوى النظام في الوقت الفعلي — ويكشف استخبارات التهديدات التي لا تراها معظم أدوات الطرف الثالث."
                },
                "TP_TEL_PROCESS_TITLE": {
                    "en": "Process Activity",
                    "ja": "プロセス監視",
                    "es": "Actividad de Procesos",
                    "ar": "نشاط العمليات"
                },
                "TP_TEL_PROCESS_DESC": {
                    "en": "Complete process lifecycle with parent-child relationships, command lines, and user context.",
                    "ja": "プロセスの起動から終了まで、親子関係・コマンドライン・実行ユーザーを含めて完全に追跡します。",
                    "es": "Ciclo de vida completo de procesos con relaciones padre-hijo, líneas de comando y contexto de usuario.",
                    "ar": "دورة حياة العمليات الكاملة مع علاقات الأب والابن، وأسطر الأوامر، وسياق المستخدم."
                },
                "TP_TEL_MEMORY_TITLE": {
                    "en": "Memory Operations",
                    "ja": "メモリ操作",
                    "es": "Operaciones de Memoria",
                    "ar": "عمليات الذاكرة"
                },
                "TP_TEL_MEMORY_DESC": {
                    "en": "Runtime memory activity that reveals in-memory attacks, fileless malware, and stealthy code execution.",
                    "ja": "ファイルを使わないマルウェアやメモリ上だけで動く高度な攻撃も、実行時のメモリ監視で検知します。",
                    "es": "Actividad de memoria en tiempo de ejecución que revela ataques en memoria, malware sin archivos y ejecución de código sigilosa.",
                    "ar": "نشاط الذاكرة أثناء التشغيل الذي يكشف هجمات الذاكرة والبرمجيات الخبيثة بدون ملفات وتنفيذ الشيفرة الخفي."
                },
                "TP_TEL_NETWORK_TITLE": {
                    "en": "Network Connections",
                    "ja": "ネットワーク接続",
                    "es": "Conexiones de Red",
                    "ar": "اتصالات الشبكة"
                },
                "TP_TEL_NETWORK_DESC": {
                    "en": "All connection activity, DNS resolution, and protocol-level identification.",
                    "ja": "すべての接続アクティビティ、DNS解決、プロトコルレベルの識別。",
                    "es": "Toda la actividad de conexión, resolución DNS e identificación a nivel de protocolo.",
                    "ar": "كل نشاط الاتصالات، دقة DNS، والتعريف على مستوى البروتوكول."
                },
                "TP_TEL_FILE_TITLE": {
                    "en": "File System",
                    "ja": "ファイルシステム",
                    "es": "Sistema de Archivos",
                    "ar": "نظام الملفات"
                },
                "TP_TEL_FILE_DESC": {
                    "en": "Operations on sensitive locations, mass modifications, and suspicious access patterns.",
                    "ja": "機密ロケーションの操作、大量変更、不審なアクセスパターン。",
                    "es": "Operaciones en ubicaciones sensibles, modificaciones masivas y patrones de acceso sospechosos.",
                    "ar": "العمليات على المواقع الحساسة، التعديلات الجماعية، وأنماط الوصول المشبوهة."
                },
                "TP_TEL_AUTH_TITLE": {
                    "en": "Authentication",
                    "ja": "認証",
                    "es": "Autenticación",
                    "ar": "المصادقة"
                },
                "TP_TEL_AUTH_DESC": {
                    "en": "Logon events, privilege changes, and credential access monitoring.",
                    "ja": "ログオンイベント、権限変更、資格情報アクセスの監視。",
                    "es": "Eventos de inicio de sesión, cambios de privilegios y monitoreo de acceso a credenciales.",
                    "ar": "أحداث تسجيل الدخول، تغييرات الصلاحيات، ومراقبة الوصول إلى بيانات الاعتماد."
                },
                "TP_TEL_SCRIPT_TITLE": {
                    "en": "Script Execution",
                    "ja": "スクリプト実行",
                    "es": "Ejecución de Scripts",
                    "ar": "تنفيذ البرامج النصية"
                },
                "TP_TEL_SCRIPT_DESC": {
                    "en": "Interpreter activity, inline execution, and runtime security scan integration.",
                    "ja": "インタープリターアクティビティ、インライン実行、ランタイムセキュリティスキャン統合。",
                    "es": "Actividad de intérpretes, ejecución en línea e integración de escaneo de seguridad en tiempo de ejecución.",
                    "ar": "نشاط المفسّرات، التنفيذ المباشر، وتكامل فحص الأمان أثناء التشغيل."
                },

                // ---- Signal Correlation ----
                "TP_CORRELATION_TITLE": {
                    "en": "Signal Correlation",
                    "ja": "シグナル相関",
                    "es": "Correlación de Señales",
                    "ar": "ربط الإشارات"
                },
                "TP_CORRELATION_DESC": {
                    "en": "Raw events are noise. Enbarr's correlation engine links related activity across time and processes into coherent attack narratives. A typical attack generates dozens of disconnected events — most tools show you separate alerts and leave you to piece them together. Enbarr shows you one clear story with full context.",
                    "ja": "生のイベントはノイズです。Enbarrの相関エンジンは、時間とプロセスにわたる関連アクティビティを一貫した攻撃ナラティブにリンクします。典型的な攻撃は数十の分断されたイベントを生成し、ほとんどのツールは個別のアラートを表示して組み立てを任せます。Enbarrは完全なコンテキストを持つ一つの明確なストーリーを表示します。",
                    "es": "Los eventos sin procesar son ruido. El motor de correlación de Enbarr vincula la actividad relacionada a través del tiempo y los procesos en narrativas de ataque coherentes. Un ataque típico genera docenas de eventos desconectados — la mayoría de herramientas muestran alertas separadas y te dejan unir las piezas. Enbarr muestra una historia clara con contexto completo.",
                    "ar": "الأحداث الخام مجرد ضوضاء. محرك الربط في Enbarr يصل النشاط المرتبط عبر الزمن والعمليات في سرديات هجوم متماسكة. الهجوم النموذجي يولّد عشرات الأحداث المنفصلة — معظم الأدوات تعرض تنبيهات منفصلة وتتركك لتجميعها. Enbarr يعرض لك قصة واحدة واضحة مع السياق الكامل."
                },

                // ---- Memory Intelligence ----
                "TP_MEMORY_TITLE": {
                    "en": "Runtime Memory Intelligence",
                    "ja": "ランタイムメモリインテリジェンス",
                    "es": "Inteligencia de Memoria en Tiempo de Ejecución",
                    "ar": "استخبارات ذاكرة وقت التشغيل"
                },
                "TP_MEMORY_DESC": {
                    "en": "When suspicious activity is detected, Enbarr performs deep runtime forensics — not just logging, but active analysis. Threats hiding in memory are identified, classified by risk level, and fed to the AI reasoning layer for autonomous decision-making.",
                    "ja": "不審なアクティビティが検出されると、Enbarrは深層ランタイムフォレンジックを実行します — 単なるログ記録ではなく、アクティブな分析です。メモリに潜む脅威を識別し、リスクレベルで分類し、自律的な意思決定のためにAI推論レイヤーに送ります。",
                    "es": "Cuando se detecta actividad sospechosa, Enbarr realiza análisis forense profundo en tiempo de ejecución — no solo registro, sino análisis activo. Las amenazas ocultas en memoria son identificadas, clasificadas por nivel de riesgo y alimentadas a la capa de razonamiento de IA para toma de decisiones autónoma.",
                    "ar": "عند اكتشاف نشاط مشبوه، يجري Enbarr تحليلاً جنائياً عميقاً أثناء التشغيل — ليس مجرد تسجيل، بل تحليل فعّال. التهديدات المختبئة في الذاكرة يتم تحديدها وتصنيفها حسب مستوى المخاطر وتغذيتها لطبقة الاستدلال بالذكاء الاصطناعي لاتخاذ القرارات الذاتية."
                },
                "TP_MEM_PAYLOAD_TITLE": {
                    "en": "Payload Identification",
                    "ja": "ペイロード識別",
                    "es": "Identificación de Payloads",
                    "ar": "تحديد الحمولات"
                },
                "TP_MEM_PAYLOAD_DESC": {
                    "en": "Detects malicious code hiding in memory — the payloads that never touch disk and evade traditional file-based scanning.",
                    "ja": "メモリに潜む悪意のあるコードを検出 — ディスクに触れず従来のファイルベーススキャンを回避するペイロード。",
                    "es": "Detecta código malicioso oculto en memoria — los payloads que nunca tocan el disco y evaden el escaneo tradicional basado en archivos.",
                    "ar": "يكتشف الشيفرة الخبيثة المختبئة في الذاكرة — الحمولات التي لا تلمس القرص أبداً وتتجاوز الفحص التقليدي القائم على الملفات."
                },
                "TP_MEM_ENTROPY_TITLE": {
                    "en": "Entropy Analysis",
                    "ja": "エントロピー分析",
                    "es": "Análisis de Entropía",
                    "ar": "تحليل الإنتروبيا"
                },
                "TP_MEM_ENTROPY_DESC": {
                    "en": "Identifies encrypted, packed, and obfuscated payloads — catching threats that are deliberately designed to avoid detection.",
                    "ja": "暗号化、パック、難読化されたペイロードを識別 — 検出を意図的に回避するよう設計された脅威を捕捉。",
                    "es": "Identifica payloads cifrados, empaquetados y ofuscados — detectando amenazas diseñadas deliberadamente para evitar la detección.",
                    "ar": "يحدد الحمولات المشفرة والمضغوطة والمبهمة — ويلتقط التهديدات المصممة عمداً لتجنب الاكتشاف."
                },
                "TP_MEM_CLASSIFY_TITLE": {
                    "en": "Address Classification",
                    "ja": "アドレス分類",
                    "es": "Clasificación de Direcciones",
                    "ar": "تصنيف العناوين"
                },
                "TP_MEM_CLASSIFY_DESC": {
                    "en": "Every suspicious activity is classified by risk level — separating legitimate system behavior from genuine threats automatically.",
                    "ja": "すべての不審なアクティビティをリスクレベル別に分類 — 正当なシステム動作と本物の脅威を自動的に分離。",
                    "es": "Cada actividad sospechosa se clasifica por nivel de riesgo — separando automáticamente el comportamiento legítimo del sistema de las amenazas genuinas.",
                    "ar": "كل نشاط مشبوه يُصنف حسب مستوى المخاطر — فصل السلوك المشروع للنظام عن التهديدات الحقيقية تلقائياً."
                },
                "TP_MEM_EXTRACT_TITLE": {
                    "en": "IOC Extraction",
                    "ja": "IOC抽出",
                    "es": "Extracción de IOC",
                    "ar": "استخلاص IOC"
                },
                "TP_MEM_EXTRACT_DESC": {
                    "en": "Automatically extracts indicators of compromise from live system activity — giving your team actionable intelligence, not just raw logs.",
                    "ja": "ライブシステムアクティビティからIOCを自動抽出 — 生のログではなく、チームに実用的なインテリジェンスを提供。",
                    "es": "Extrae automáticamente indicadores de compromiso de la actividad del sistema en vivo — dando a tu equipo inteligencia accionable, no solo logs sin procesar.",
                    "ar": "يستخلص تلقائياً مؤشرات الاختراق من نشاط النظام الحي — مما يمنح فريقك استخبارات قابلة للتنفيذ، وليس مجرد سجلات خام."
                },

                // ---- AI & Mesh ----
                "TP_AI_TITLE": {
                    "en": "Local AI Reasoning",
                    "ja": "ローカルAI推論",
                    "es": "Razonamiento de IA Local",
                    "ar": "الاستدلال المحلي بالذكاء الاصطناعي"
                },
                "TP_AI_DESC": {
                    "en": "Enbarr runs AI analysis entirely on your hardware using a novel planner that uses parallel execution to perform machine learning analysis in seconds. No cloud API calls. No data exfiltration. Autonomous agents reason about attack chains, contextualize activity against your environment's baseline, reduce false positives over time, and generate human-readable threat narratives — not just alert codes.",
                    "ja": "Enbarrは、並列実行を使用する独自のプランナーにより、機械学習分析を数秒で実行します。完全にあなたのハードウェア上で動作。クラウドAPIコールなし。データ流出なし。自律型エージェントが攻撃チェーンについて推論し、環境のベースラインに対してアクティビティをコンテキスト化し、時間とともに誤検知を削減し、人間が読める脅威ナラティブを生成します。",
                    "es": "Enbarr ejecuta análisis de IA completamente en tu hardware usando un planificador novedoso que utiliza ejecución paralela para realizar análisis de aprendizaje automático en segundos. Sin llamadas API a la nube. Sin exfiltración de datos. Agentes autónomos razonan sobre cadenas de ataque, contextualizan la actividad contra la línea base de tu entorno, reducen falsos positivos con el tiempo y generan narrativas de amenazas legibles — no solo códigos de alerta.",
                    "ar": "يشغّل Enbarr تحليل الذكاء الاصطناعي بالكامل على أجهزتك باستخدام مخطط مبتكر يستخدم التنفيذ المتوازي لإجراء تحليل التعلم الآلي في ثوانٍ. لا مكالمات API سحابية. لا تسريب بيانات. وكلاء ذاتيون يستدلون حول سلاسل الهجوم، ويضعون النشاط في سياق خط الأساس لبيئتك، ويقللون الإنذارات الكاذبة بمرور الوقت، ويولّدون سرديات تهديد مقروءة — وليس مجرد رموز تنبيه."
                },
                "TP_MESH_TITLE": {
                    "en": "The Gossip Network",
                    "ja": "ゴシップネットワーク",
                    "es": "La Red de Gossip",
                    "ar": "شبكة Gossip"
                },
                "TP_MESH_DESC": {
                    "en": "When multiple Enbarr nodes are deployed, they form a gossip network — sharing threat signals across your organization in real time. When one endpoint sees something suspicious, every other node is warned instantly. Your network builds its own collective immunity, without any central infrastructure.",
                    "ja": "複数のEnbarrノードが展開されると、ゴシップネットワークを形成し、組織全体でリアルタイムに脅威シグナルを共有します。あるエンドポイントが不審なものを検知すると、他のすべてのノードに即座に警告されます。中央インフラなしで、ネットワーク独自の集団免疫を構築します。",
                    "es": "Cuando se despliegan múltiples nodos Enbarr, forman una red gossip — compartiendo señales de amenazas a través de tu organización en tiempo real. Cuando un endpoint detecta algo sospechoso, todos los demás nodos son alertados instantáneamente. Tu red construye su propia inmunidad colectiva, sin infraestructura central.",
                    "ar": "عند نشر عُقد Enbarr متعددة، تشكل شبكة gossip — تتشارك إشارات التهديد عبر مؤسستك في الوقت الفعلي. عندما ترصد نقطة نهاية شيئاً مريباً، يتم تحذير كل العُقد الأخرى فوراً. شبكتك تبني مناعتها الجماعية الخاصة، بدون أي بنية تحتية مركزية."
                },
                "TP_MESH_SHARED": {
                    "en": "Shared: threat intelligence, behavioral patterns, and indicators of compromise",
                    "ja": "共有: 脅威インテリジェンス、行動パターン、侵害の指標",
                    "es": "Compartido: inteligencia de amenazas, patrones de comportamiento e indicadores de compromiso",
                    "ar": "مشترك: استخبارات التهديدات، الأنماط السلوكية، ومؤشرات الاختراق"
                },
                "TP_MESH_NEVER": {
                    "en": "Never shared: file contents, user credentials, PII, business data",
                    "ja": "共有されない: ファイル内容、ユーザー資格情報、PII、ビジネスデータ",
                    "es": "Nunca compartido: contenidos de archivos, credenciales de usuario, PII, datos de negocio",
                    "ar": "لا يُشارك أبداً: محتويات الملفات، بيانات اعتماد المستخدمين، المعلومات الشخصية، بيانات الأعمال"
                },

                // ---- Detection Coverage ----
                "TP_DETECT_TITLE": {
                    "en": "Detection Coverage",
                    "ja": "検出カバレッジ",
                    "es": "Cobertura de Detección",
                    "ar": "تغطية الكشف"
                },
                "TP_DETECT_SUBTITLE": {
                    "en": "The attacks that bypass your existing tools — that's where we live.",
                    "ja": "既存ツールをバイパスする攻撃 — それが私たちの領域です。",
                    "es": "Los ataques que evadan tus herramientas existentes — ahí es donde vivimos.",
                    "ar": "الهجمات التي تتجاوز أدواتك الحالية — هذا هو مجالنا."
                },

                // ---- What Enbarr Is ----
                "TP_IDENTITY_TITLE": {
                    "en": "Think of Enbarr As",
                    "ja": "Enbarrとは",
                    "es": "Piensa en Enbarr Como",
                    "ar": "فكّر في Enbarr على أنه"
                },
                "TP_IDENTITY_DESC": {
                    "en": "A living thinking watchman, all seeing, all knowing, a critical layer to protect your business in the age of AI.",
                    "ja": "AI時代において、全てを見通し、全てを知る、思考する番人。貴社のビジネスを死守する不可欠な防衛階層。",
                    "es": "Un vigilante vivo y pensante, que todo lo ve y todo lo sabe; una capa crítica para proteger su negocio en la era de la IA.",
                    "ar": "حارس حي مفكر، يرى كل شيء ويعلم كل شيء، طبقة حاسمة لحماية أعمالك في عصر الذكاء الاصطناعي."
                },
                "TP_IDENTITY_1": {
                    "en": "A living, thinking organism protecting your network",
                    "ja": "ネットワークを保護する生きた思考する有機体",
                    "es": "Un organismo vivo y pensante protegiendo tu red",
                    "ar": "كائن حي مفكر يحمي شبكتك"
                },
                "TP_IDENTITY_2": {
                    "en": "A second pair of eyes that never blinks",
                    "ja": "瞬きしない第二の目",
                    "es": "Un segundo par de ojos que nunca parpadea",
                    "ar": "زوج ثانٍ من العيون لا يرمش أبداً"
                },
                "TP_IDENTITY_3": {
                    "en": "An analyst that works 24/7 on every endpoint",
                    "ja": "すべてのエンドポイントで24時間365日働くアナリスト",
                    "es": "Un analista que trabaja 24/7 en cada endpoint",
                    "ar": "محلل يعمل على مدار الساعة على كل نقطة نهاية"
                },
                "TP_IDENTITY_4": {
                    "en": "An early warning system that buys you response time",
                    "ja": "対応時間を稼ぐ早期警戒システム",
                    "es": "Un sistema de alerta temprana que te da tiempo de respuesta",
                    "ar": "نظام إنذار مبكر يمنحك وقت الاستجابة"
                },

                // ---- Performance ----
                "TP_PERF_TITLE": {
                    "en": "Performance",
                    "ja": "パフォーマンス",
                    "es": "Rendimiento",
                    "ar": "الأداء"
                },
                "TP_PERF_DESC": {
                    "en": "Designed to be invisible. We don't slow down your endpoints. We don't interrupt your users. We just watch.",
                    "ja": "見えないように設計されています。エンドポイントを遅くしません。ユーザーを中断しません。ただ監視します。",
                    "es": "Diseñado para ser invisible. No ralentizamos tus endpoints. No interrumpimos a tus usuarios. Solo observamos.",
                    "ar": "مصمم ليكون غير مرئي. لا نبطئ نقاط النهاية الخاصة بك. لا نقاطع مستخدميك. نحن فقط نراقب."
                },

                // ---- Bottom Line ----
                "TP_BOTTOM_TITLE": {
                    "en": "The Bottom Line",
                    "ja": "結論",
                    "es": "La Conclusión",
                    "ar": "الخلاصة"
                },
                "TP_BOTTOM_DESC": {
                    "en": "Your current tools stop known threats. But the attacks making headlines aren't known threats — they're custom, patient, and designed to blend in. These bypass signatures, reputation databases, and cloud ML trained on other people's data. What they can't bypass is autonomous AI reasoning about behavior on your own endpoints, running entirely on your infrastructure.",
                    "ja": "現在のツールは既知の脅威を阻止します。しかし、ヘッドラインを飾る攻撃は既知の脅威ではありません — カスタムで、忍耐強く、溶け込むように設計されています。これらはシグネチャ、レピュテーションデータベース、他者のデータで訓練されたクラウドMLをバイパスします。バイパスできないのは、あなた自身のインフラ上で完全に動作する、エンドポイント上の行動についての自律的なAI推論です。",
                    "es": "Tus herramientas actuales detienen amenazas conocidas. Pero los ataques que generan titulares no son amenazas conocidas — son personalizados, pacientes y diseñados para pasar desapercibidos. Estos evaden firmas, bases de datos de reputación y ML en la nube entrenado con datos de otros. Lo que no pueden evadir es el razonamiento autónomo de IA sobre comportamiento en tus propios endpoints, ejecutándose completamente en tu infraestructura.",
                    "ar": "أدواتك الحالية توقف التهديدات المعروفة. لكن الهجمات التي تتصدر العناوين ليست تهديدات معروفة — إنها مخصصة وصبورة ومصممة للاندماج. هذه تتجاوز التوقيعات وقواعد البيانات والتعلم الآلي السحابي المدرّب على بيانات الآخرين. ما لا يمكنها تجاوزه هو الاستدلال الذاتي بالذكاء الاصطناعي حول السلوك على نقاط النهاية الخاصة بك، يعمل بالكامل على بنيتك التحتية."
                },
                "TP_BOTTOM_CLOSING": {
                    "en": "That's Enbarr.",
                    "ja": "それがEnbarrです。",
                    "es": "Eso es Enbarr.",
                    "ar": "هذا هو Enbarr."
                },
                "TP_BETA_BADGE": {
                    "en": "Currently in Private Beta",
                    "ja": "現在プライベートベータ中",
                    "es": "Actualmente en Beta Privada",
                    "ar": "حالياً في النسخة التجريبية الخاصة"
                },

                // ---- Breaches Page ----
                "BR_BADGE": {
                    "en": "Threat Intelligence",
                    "ja": "脅威インテリジェンス",
                    "es": "Inteligencia de Amenazas",
                    "ar": "استخبارات التهديدات"
                },
                "BR_HERO_TITLE": {
                    "en": "The Year the Weakest Link Finally Broke",
                    "ja": "最も脆弱なリンクが遂に破壊された年",
                    "es": "El Año en que el Eslabón Más Débil Finalmente se Rompió",
                    "ar": "العام الذي انكسر فيه الحلقة الأضعف أخيراً"
                },
                "BR_HERO_SUBTITLE": {
                    "en": "2025 marked a decisive shift in the global threat landscape. Attackers consistently targeted the connective tissue of modern organizations: third-party vendors, integration platforms, APIs, and internal collaboration tools.",
                    "ja": "2025年、グローバルな脅威の状況に決定的な変化がありました。攻撃者は一貫して現代組織の結合組織を標的にしました：サードパーティベンダー、統合プラットフォーム、API、そして内部コラボレーションツール。",
                    "es": "2025 marcó un cambio decisivo en el panorama global de amenazas. Los atacantes apuntaron consistentemente al tejido conectivo de las organizaciones modernas: proveedores externos, plataformas de integración, APIs y herramientas de colaboración interna.",
                    "ar": "شهد عام 2025 تحولاً حاسماً في مشهد التهديدات العالمي. استهدف المهاجمون باستمرار النسيج الضام للمؤسسات الحديثة: موردو الطرف الثالث، منصات التكامل، واجهات API، وأدوات التعاون الداخلية."
                },

                // ---- Common Pattern ----
                "BR_PATTERN_TITLE": {
                    "en": "The Common Pattern",
                    "ja": "共通パターン",
                    "es": "El Patrón Común",
                    "ar": "النمط المشترك"
                },
                "BR_PATTERN_INTRO": {
                    "en": "Attackers no longer break in — they log in, integrate, or inherit access. Across every incident analyzed, adversaries exploited systemic weaknesses that transformed isolated security gaps into organization-wide compromise events.",
                    "ja": "攻撃者はもはや侵入しません — ログインし、統合し、またはアクセスを継承します。分析されたすべてのインシデントにおいて、敵対者は孤立したセキュリティギャップを組織全体の侵害イベントに変える体系的な弱点を悪用しました。",
                    "es": "Los atacantes ya no irrumpen — inician sesión, se integran o heredan acceso. En todos los incidentes analizados, los adversarios explotaron debilidades sistémicas que transformaron brechas de seguridad aisladas en eventos de compromiso a nivel organizacional.",
                    "ar": "المهاجمون لم يعودوا يقتحمون — إنهم يسجلون الدخول أو يندمجون أو يرثون الوصول. عبر كل حادثة تم تحليلها، استغل المهاجمون نقاط ضعف نظامية حوّلت ثغرات أمنية معزولة إلى أحداث اختراق على مستوى المؤسسة."
                },
                "BR_WEAKNESS_1": {
                    "en": "Over-trusted third-party vendors and SaaS integrations",
                    "ja": "過度に信頼されたサードパーティベンダーとSaaS統合",
                    "es": "Proveedores externos y integraciones SaaS con exceso de confianza",
                    "ar": "موردو الطرف الثالث وتكاملات SaaS المفرطة الثقة"
                },
                "BR_WEAKNESS_2": {
                    "en": "Weak or nonexistent API security controls",
                    "ja": "脆弱または存在しないAPIセキュリティ制御",
                    "es": "Controles de seguridad API débiles o inexistentes",
                    "ar": "ضوابط أمان API ضعيفة أو معدومة"
                },
                "BR_WEAKNESS_3": {
                    "en": "Poor identity and access governance",
                    "ja": "不十分なアイデンティティとアクセスガバナンス",
                    "es": "Gobernanza deficiente de identidad y acceso",
                    "ar": "إدارة هوية ووصول ضعيفة"
                },
                "BR_WEAKNESS_4": {
                    "en": "Flat networks enabling lateral movement",
                    "ja": "ラテラルムーブメントを可能にするフラットネットワーク",
                    "es": "Redes planas que permiten movimiento lateral",
                    "ar": "شبكات مسطحة تتيح الحركة الجانبية"
                },
                "BR_WEAKNESS_5": {
                    "en": "Lack of visibility into trusted activity",
                    "ja": "信頼されたアクティビティへの可視性の欠如",
                    "es": "Falta de visibilidad en actividad confiable",
                    "ar": "انعدام الرؤية في النشاط الموثوق"
                },
                "BR_WEAKNESS_6": {
                    "en": "Delayed detection and response",
                    "ja": "検出と対応の遅延",
                    "es": "Detección y respuesta tardías",
                    "ar": "تأخر الكشف والاستجابة"
                },
                "BR_WEAKNESS_7": {
                    "en": "Sensitive data stored or transmitted without encryption",
                    "ja": "暗号化なしで保存・送信される機密データ",
                    "es": "Datos sensibles almacenados o transmitidos sin cifrado",
                    "ar": "بيانات حساسة مخزنة أو منقولة بدون تشفير"
                },

                // ---- Case Studies ----
                "BR_CASES_TITLE": {
                    "en": "Case Studies",
                    "ja": "ケーススタディ",
                    "es": "Casos de Estudio",
                    "ar": "دراسات حالة"
                },
                "BR_CASES_SUBTITLE": {
                    "en": "Real-world breaches that defined the 2025 threat landscape",
                    "ja": "2025年の脅威の状況を定義した実際の侵害",
                    "es": "Brechas reales que definieron el panorama de amenazas de 2025",
                    "ar": "اختراقات حقيقية شكّلت مشهد التهديدات لعام 2025"
                },

                "BR_CASE1_TAG": {
                    "en": "Ransomware / OT",
                    "ja": "ランサムウェア / OT",
                    "es": "Ransomware / OT",
                    "ar": "برمجيات الفدية / OT"
                },
                "BR_CASE1_TITLE": {
                    "en": "Asahi Group",
                    "ja": "アサヒグループ",
                    "es": "Grupo Asahi",
                    "ar": "مجموعة Asahi"
                },
                "BR_CASE1_SUBTITLE": {
                    "en": "Manufacturing & Supply Chain Disruption",
                    "ja": "製造業とサプライチェーンの混乱",
                    "es": "Disrupción de Manufactura y Cadena de Suministro",
                    "ar": "اضطراب التصنيع وسلسلة التوريد"
                },
                "BR_CASE1_DESC": {
                    "en": "Compromised credentials enabled attackers to traverse both corporate IT and operational production systems, encrypting infrastructure and exfiltrating data before detonation. Limited segmentation allowed ransomware to propagate unchecked, halting global production and leaking 9,300 files publicly.",
                    "ja": "侵害された認証情報により、攻撃者は企業ITと運用生産システムの両方を横断し、起爆前にインフラを暗号化しデータを流出させました。限定的なセグメンテーションにより、ランサムウェアが制御不能に伝播し、グローバル生産が停止し9,300ファイルが公開されました。",
                    "es": "Credenciales comprometidas permitieron a los atacantes atravesar tanto los sistemas de TI corporativos como los de producción operativa, cifrando infraestructura y exfiltrando datos antes de la detonación. La segmentación limitada permitió que el ransomware se propagara sin control, deteniendo la producción global y filtrando 9,300 archivos públicamente.",
                    "ar": "بيانات الاعتماد المخترقة مكّنت المهاجمين من التنقل عبر أنظمة تكنولوجيا المعلومات المؤسسية وأنظمة الإنتاج التشغيلية، مشفرين البنية التحتية ومسربين البيانات قبل التفجير. التجزئة المحدودة سمحت لبرمجيات الفدية بالانتشار دون رادع، موقفةً الإنتاج العالمي ومسربةً 9,300 ملف علنياً."
                },
                "BR_CASE1_INSIGHT": {
                    "en": "OT environments are no longer isolated. Once breached, they become force multipliers for attackers.",
                    "ja": "OT環境はもはや孤立していません。一度侵害されると、攻撃者の力の増幅器になります。",
                    "es": "Los entornos OT ya no están aislados. Una vez comprometidos, se convierten en multiplicadores de fuerza para los atacantes.",
                    "ar": "بيئات OT لم تعد معزولة. بمجرد اختراقها، تصبح مضاعفات قوة للمهاجمين."
                },

                "BR_CASE2_TAG": {
                    "en": "API Exposure",
                    "ja": "API露出",
                    "es": "Exposición de API",
                    "ar": "تعرّض API"
                },
                "BR_CASE2_TITLE": {
                    "en": "Jaguar Land Rover",
                    "ja": "ジャガーランドローバー",
                    "es": "Jaguar Land Rover",
                    "ar": "Jaguar Land Rover"
                },
                "BR_CASE2_SUBTITLE": {
                    "en": "Customer Data Exposure",
                    "ja": "顧客データの露出",
                    "es": "Exposición de Datos de Clientes",
                    "ar": "تعرّض بيانات العملاء"
                },
                "BR_CASE2_DESC": {
                    "en": "Publicly reachable APIs lacking proper authentication, rate limiting, and monitoring enabled attackers to enumerate internal services and systematically harvest sensitive customer data. Weak secrets management and poor input validation compounded the exposure.",
                    "ja": "適切な認証、レート制限、監視が欠如した公開APIにより、攻撃者は内部サービスを列挙し、機密顧客データを体系的に収集できました。シークレット管理の脆弱さと入力バリデーションの不備が露出を悪化させました。",
                    "es": "APIs públicamente accesibles sin autenticación adecuada, limitación de tasa y monitoreo permitieron a los atacantes enumerar servicios internos y recopilar sistemáticamente datos sensibles de clientes. La gestión débil de secretos y la validación deficiente de entrada agravaron la exposición.",
                    "ar": "واجهات API متاحة علنياً تفتقر للمصادقة المناسبة وتحديد المعدل والمراقبة مكّنت المهاجمين من حصر الخدمات الداخلية وجمع بيانات العملاء الحساسة بشكل منهجي. إدارة الأسرار الضعيفة والتحقق الضعيف من المدخلات ضاعفا التعرّض."
                },
                "BR_CASE2_INSIGHT": {
                    "en": "APIs are now frontline infrastructure. Treating them as \"just interfaces\" creates silent, large-scale data leakage risks.",
                    "ja": "APIは今やフロントラインインフラです。「単なるインターフェース」として扱うことは、静かな大規模データ漏洩リスクを生み出します。",
                    "es": "Las APIs son ahora infraestructura de primera línea. Tratarlas como \"solo interfaces\" crea riesgos silenciosos de fuga de datos a gran escala.",
                    "ar": "واجهات API أصبحت الآن بنية تحتية في الخط الأمامي. معاملتها على أنها \"مجرد واجهات\" يخلق مخاطر تسريب بيانات صامتة وواسعة النطاق."
                },

                "BR_CASE3_TAG": {
                    "en": "OAuth Abuse",
                    "ja": "OAuth悪用",
                    "es": "Abuso de OAuth",
                    "ar": "إساءة استخدام OAuth"
                },
                "BR_CASE3_TITLE": {
                    "en": "Salesforce / Salesloft",
                    "ja": "Salesforce / Salesloft",
                    "es": "Salesforce / Salesloft",
                    "ar": "Salesforce / Salesloft"
                },
                "BR_CASE3_SUBTITLE": {
                    "en": "OAuth Token Abuse via SaaS Integration",
                    "ja": "SaaS統合を介したOAuthトークン悪用",
                    "es": "Abuso de Tokens OAuth vía Integración SaaS",
                    "ar": "إساءة استخدام رموز OAuth عبر تكامل SaaS"
                },
                "BR_CASE3_DESC": {
                    "en": "Attackers weaponized OAuth tokens stolen from a third-party integration, granting persistent API access that completely bypassed MFA. Over-privileged integrations, static credentials, and absent token rotation allowed prolonged data exfiltration.",
                    "ja": "攻撃者はサードパーティ統合から盗まれたOAuthトークンを武器化し、MFAを完全にバイパスする永続的なAPIアクセスを取得しました。過剰な権限の統合、静的な認証情報、トークンローテーションの欠如が長期的なデータ流出を可能にしました。",
                    "es": "Los atacantes armaron tokens OAuth robados de una integración de terceros, otorgando acceso API persistente que eludió completamente la MFA. Integraciones con exceso de privilegios, credenciales estáticas y rotación de tokens ausente permitieron la exfiltración prolongada de datos.",
                    "ar": "سلّح المهاجمون رموز OAuth المسروقة من تكامل طرف ثالث، مما منح وصولاً مستمراً عبر API تجاوز MFA بالكامل. التكاملات ذات الصلاحيات المفرطة وبيانات الاعتماد الثابتة وغياب تدوير الرموز سمحت بتسريب بيانات مطوّل."
                },
                "BR_CASE3_INSIGHT": {
                    "en": "MFA is meaningless if long-lived tokens are trusted indefinitely. Integration ecosystems are now high-value attack paths.",
                    "ja": "長期間有効なトークンが無期限に信頼される場合、MFAは無意味です。統合エコシステムは今や高価値の攻撃パスです。",
                    "es": "La MFA no tiene sentido si los tokens de larga duración son confiados indefinidamente. Los ecosistemas de integración son ahora rutas de ataque de alto valor.",
                    "ar": "MFA لا معنى لها إذا كانت الرموز طويلة العمر موثوقة إلى أجل غير مسمى. أنظمة التكامل أصبحت الآن مسارات هجوم عالية القيمة."
                },

                "BR_CASE4_TAG": {
                    "en": "Third-Party",
                    "ja": "サードパーティ",
                    "es": "Terceros",
                    "ar": "طرف ثالث"
                },
                "BR_CASE4_TITLE": {
                    "en": "Qantas",
                    "ja": "カンタス航空",
                    "es": "Qantas",
                    "ar": "Qantas"
                },
                "BR_CASE4_SUBTITLE": {
                    "en": "Third-Party Contact Center Breach",
                    "ja": "サードパーティコンタクトセンター侵害",
                    "es": "Brecha en Centro de Contacto de Terceros",
                    "ar": "اختراق مركز اتصال طرف ثالث"
                },
                "BR_CASE4_DESC": {
                    "en": "A sophisticated social-engineering campaign against an outsourced contact center resulted in the exposure of up to 6 million customer records. Weak vendor security requirements and poor identity governance allowed attackers to harvest sensitive personal and travel data.",
                    "ja": "外部委託されたコンタクトセンターに対する高度なソーシャルエンジニアリングキャンペーンにより、最大600万件の顧客レコードが露出しました。ベンダーのセキュリティ要件の脆弱さとアイデンティティガバナンスの不備により、攻撃者は機密の個人情報と旅行データを収集できました。",
                    "es": "Una sofisticada campaña de ingeniería social contra un centro de contacto subcontratado resultó en la exposición de hasta 6 millones de registros de clientes. Requisitos de seguridad débiles del proveedor y gobernanza deficiente de identidad permitieron a los atacantes recopilar datos personales y de viaje sensibles.",
                    "ar": "حملة هندسة اجتماعية متطورة ضد مركز اتصال خارجي أسفرت عن كشف ما يصل إلى 6 ملايين سجل عملاء. متطلبات أمان الموردين الضعيفة وإدارة الهوية السيئة سمحت للمهاجمين بجمع بيانات شخصية وسفر حساسة."
                },
                "BR_CASE4_INSIGHT": {
                    "en": "Outsourced operations inherit your data risk. Without enforced security standards, vendors become breach accelerators.",
                    "ja": "外部委託された業務はデータリスクを継承します。強制されたセキュリティ基準がなければ、ベンダーは侵害の加速器になります。",
                    "es": "Las operaciones subcontratadas heredan tu riesgo de datos. Sin estándares de seguridad aplicados, los proveedores se convierten en aceleradores de brechas.",
                    "ar": "العمليات الخارجية ترث مخاطر بياناتك. بدون معايير أمنية مفروضة، يصبح الموردون مسرّعات للاختراق."
                },

                "BR_CASE5_TAG": {
                    "en": "Telecom / Critical",
                    "ja": "通信 / 重要",
                    "es": "Telecom / Crítico",
                    "ar": "اتصالات / حرج"
                },
                "BR_CASE5_TITLE": {
                    "en": "SK Telecom",
                    "ja": "SKテレコム",
                    "es": "SK Telecom",
                    "ar": "SK Telecom"
                },
                "BR_CASE5_SUBTITLE": {
                    "en": "Telecommunications Catastrophe",
                    "ja": "通信大惨事",
                    "es": "Catástrofe en Telecomunicaciones",
                    "ar": "كارثة الاتصالات"
                },
                "BR_CASE5_DESC": {
                    "en": "USIM authentication keys for approximately 23 million users were exposed. Nearly decade-old vulnerabilities remained unpatched, credentials were stored in plaintext, and breach disclosure was delayed. The compromise created permanent, unfixable risk — USIM keys cannot be rotated at scale.",
                    "ja": "約2,300万ユーザーのUSIM認証キーが露出しました。ほぼ10年前の脆弱性が未修正のまま残り、認証情報は平文で保存され、侵害の開示は遅延しました。この侵害は永続的で修復不可能なリスクを生み出しました — USIMキーは大規模にローテーションできません。",
                    "es": "Las claves de autenticación USIM de aproximadamente 23 millones de usuarios fueron expuestas. Vulnerabilidades de casi una década permanecieron sin parchar, las credenciales se almacenaban en texto plano y la divulgación de la brecha se retrasó. El compromiso creó un riesgo permanente e irreparable — las claves USIM no se pueden rotar a escala.",
                    "ar": "تم كشف مفاتيح مصادقة USIM لحوالي 23 مليون مستخدم. ثغرات عمرها عقد تقريباً ظلت دون إصلاح، وبيانات الاعتماد مخزنة بنص عادي، وتأخر الكشف عن الاختراق. الاختراق خلق مخاطر دائمة لا يمكن إصلاحها — مفاتيح USIM لا يمكن تدويرها على نطاق واسع."
                },
                "BR_CASE5_INSIGHT": {
                    "en": "Some data, once exposed, cannot be remediated. Prevention is the only control that matters.",
                    "ja": "一部のデータは一度露出すると修復できません。予防こそが唯一重要な制御です。",
                    "es": "Algunos datos, una vez expuestos, no pueden remediarse. La prevención es el único control que importa.",
                    "ar": "بعض البيانات، بمجرد كشفها، لا يمكن معالجتها. الوقاية هي الضابط الوحيد المهم."
                },

                "BR_CASE6_TAG": {
                    "en": "Insider Threat",
                    "ja": "内部脅威",
                    "es": "Amenaza Interna",
                    "ar": "تهديد داخلي"
                },
                "BR_CASE6_TITLE": {
                    "en": "Coinbase",
                    "ja": "Coinbase",
                    "es": "Coinbase",
                    "ar": "Coinbase"
                },
                "BR_CASE6_SUBTITLE": {
                    "en": "Bribery-Driven Insider Access",
                    "ja": "賄賂による内部アクセス",
                    "es": "Acceso Interno Impulsado por Soborno",
                    "ar": "وصول داخلي مدفوع بالرشوة"
                },
                "BR_CASE6_DESC": {
                    "en": "Rather than exploiting technical vulnerabilities, attackers bribed outsourced support staff to abuse legitimate access. Over-privileged accounts, lack of behavioral monitoring, and weak third-party workforce controls enabled large-scale PII extraction, detected only after an extortion attempt.",
                    "ja": "技術的な脆弱性を悪用するのではなく、攻撃者は外部委託されたサポートスタッフに賄賂を贈り、正当なアクセスを悪用させました。過剰な権限のアカウント、行動監視の欠如、サードパーティ労働力の脆弱な制御が大規模なPII抽出を可能にし、恐喝の試みの後にのみ検出されました。",
                    "es": "En lugar de explotar vulnerabilidades técnicas, los atacantes sobornaron al personal de soporte subcontratado para abusar del acceso legítimo. Cuentas con exceso de privilegios, falta de monitoreo conductual y controles débiles de fuerza laboral de terceros permitieron la extracción masiva de PII, detectada solo después de un intento de extorsión.",
                    "ar": "بدلاً من استغلال الثغرات التقنية، رشا المهاجمون موظفي الدعم الخارجيين لإساءة استخدام الوصول المشروع. الحسابات ذات الصلاحيات المفرطة وغياب المراقبة السلوكية وضعف ضوابط القوى العاملة الخارجية مكّنت استخلاص PII واسع النطاق، اكتُشف فقط بعد محاولة ابتزاز."
                },
                "BR_CASE6_INSIGHT": {
                    "en": "Zero-trust must apply to people, not just systems. Authorized access is now the most dangerous access.",
                    "ja": "ゼロトラストはシステムだけでなく人にも適用されなければなりません。認可されたアクセスが今や最も危険なアクセスです。",
                    "es": "La confianza cero debe aplicarse a personas, no solo a sistemas. El acceso autorizado es ahora el acceso más peligroso.",
                    "ar": "يجب تطبيق Zero Trust على الأشخاص، وليس فقط على الأنظمة. الوصول المُصرح به أصبح الآن الوصول الأخطر."
                },

                "BR_CASE7_TAG": {
                    "en": "Internal Tools",
                    "ja": "内部ツール",
                    "es": "Herramientas Internas",
                    "ar": "أدوات داخلية"
                },
                "BR_CASE7_TITLE": {
                    "en": "Nikkei",
                    "ja": "日経",
                    "es": "Nikkei",
                    "ar": "Nikkei"
                },
                "BR_CASE7_SUBTITLE": {
                    "en": "Slack Integration Compromise",
                    "ja": "Slack統合の侵害",
                    "es": "Compromiso de Integración de Slack",
                    "ar": "اختراق تكامل Slack"
                },
                "BR_CASE7_DESC": {
                    "en": "Attackers harvested Slack credentials via malware and leveraged the absence of MFA on internal integrations to impersonate employees and access sensitive financial communications and proprietary editorial plans.",
                    "ja": "攻撃者はマルウェアを介してSlack認証情報を収集し、内部統合におけるMFAの欠如を利用して従業員になりすまし、機密の財務通信と独自の編集計画にアクセスしました。",
                    "es": "Los atacantes recopilaron credenciales de Slack mediante malware y aprovecharon la ausencia de MFA en integraciones internas para suplantar empleados y acceder a comunicaciones financieras sensibles y planes editoriales propietarios.",
                    "ar": "جمع المهاجمون بيانات اعتماد Slack عبر البرمجيات الخبيثة واستغلوا غياب MFA على التكاملات الداخلية لانتحال شخصية الموظفين والوصول إلى اتصالات مالية حساسة وخطط تحريرية خاصة."
                },
                "BR_CASE7_INSIGHT": {
                    "en": "\"Internal\" does not mean \"safe.\" Collaboration tools are intelligence goldmines and must be protected accordingly.",
                    "ja": "「内部」は「安全」を意味しません。コラボレーションツールは情報の宝庫であり、それに応じて保護されなければなりません。",
                    "es": "\"Interno\" no significa \"seguro.\" Las herramientas de colaboración son minas de oro de inteligencia y deben protegerse en consecuencia.",
                    "ar": "\"داخلي\" لا يعني \"آمن\". أدوات التعاون هي مناجم ذهب للمعلومات ويجب حمايتها وفقاً لذلك."
                },

                "BR_CASE8_TAG": {
                    "en": "Nation-State APT",
                    "ja": "国家APT",
                    "es": "APT de Estado-Nación",
                    "ar": "APT دولة-قومية"
                },
                "BR_CASE8_TITLE": {
                    "en": "U.S. Congressional Budget Office",
                    "ja": "米国議会予算局",
                    "es": "Oficina de Presupuesto del Congreso de EE.UU.",
                    "ar": "مكتب الميزانية في الكونغرس الأمريكي"
                },
                "BR_CASE8_SUBTITLE": {
                    "en": "Silk Typhoon APT Espionage",
                    "ja": "Silk Typhoon APTスパイ活動",
                    "es": "Espionaje APT Silk Typhoon",
                    "ar": "تجسس APT Silk Typhoon"
                },
                "BR_CASE8_DESC": {
                    "en": "During a prolonged government shutdown, state-sponsored actors exploited unpatched edge devices and hijacked administrative API keys. Operating undetected for months, they accessed economic forecasts, policy drafts, and legislative strategies.",
                    "ja": "長期にわたる政府機関の閉鎖中、国家支援のアクターが未修正のエッジデバイスを悪用し、管理用APIキーを乗っ取りました。数ヶ月間検出されずに活動し、経済予測、政策草案、立法戦略にアクセスしました。",
                    "es": "Durante un cierre gubernamental prolongado, actores patrocinados por el estado explotaron dispositivos de borde sin parchar y secuestraron claves API administrativas. Operando sin ser detectados durante meses, accedieron a pronósticos económicos, borradores de políticas y estrategias legislativas.",
                    "ar": "خلال إغلاق حكومي مطوّل، استغل ممثلون مدعومون من دولة أجهزة طرفية غير مُصلحة واختطفوا مفاتيح API إدارية. عملوا دون اكتشاف لأشهر، ووصلوا إلى التوقعات الاقتصادية ومسودات السياسات والاستراتيجيات التشريعية."
                },
                "BR_CASE8_INSIGHT": {
                    "en": "Operational strain creates strategic opportunity. APTs time attacks for moments of reduced defensive capacity.",
                    "ja": "運用上の負担は戦略的機会を生み出します。APTは防御能力が低下した瞬間に合わせて攻撃を行います。",
                    "es": "La tensión operativa crea oportunidades estratégicas. Las APT programan los ataques para momentos de capacidad defensiva reducida.",
                    "ar": "الضغط التشغيلي يخلق فرصاً استراتيجية. مجموعات APT تُوقّت هجماتها لحظات انخفاض القدرة الدفاعية."
                },

                "BR_CASE9_TAG": {
                    "en": "Supply Chain",
                    "ja": "サプライチェーン",
                    "es": "Cadena de Suministro",
                    "ar": "سلسلة التوريد"
                },
                "BR_CASE9_TITLE": {
                    "en": "University of Phoenix",
                    "ja": "フェニックス大学",
                    "es": "Universidad de Phoenix",
                    "ar": "جامعة Phoenix"
                },
                "BR_CASE9_SUBTITLE": {
                    "en": "Vendor-Driven Mass PII Exposure",
                    "ja": "ベンダー起因の大量PII露出",
                    "es": "Exposición Masiva de PII Impulsada por Proveedor",
                    "ar": "تعرّض PII جماعي مدفوع بالمورد"
                },
                "BR_CASE9_DESC": {
                    "en": "The Clop ransomware group bypassed university defenses entirely, exploiting a third-party data processor instead. Unencrypted transmission of sensitive PII and reliance on vendor self-attestation resulted in the exposure of SSNs and birthdates for 3.5 million individuals.",
                    "ja": "Clopランサムウェアグループは大学の防御を完全にバイパスし、代わりにサードパーティのデータ処理業者を悪用しました。機密PIIの暗号化されていない送信とベンダーの自己証明への依存により、350万人の社会保障番号と生年月日が露出しました。",
                    "es": "El grupo de ransomware Clop eludió completamente las defensas de la universidad, explotando en su lugar un procesador de datos de terceros. La transmisión sin cifrar de PII sensible y la dependencia en la auto-certificación del proveedor resultaron en la exposición de SSN y fechas de nacimiento de 3.5 millones de individuos.",
                    "ar": "تجاوزت مجموعة Clop لبرمجيات الفدية دفاعات الجامعة بالكامل، مستغلةً بدلاً من ذلك معالج بيانات طرف ثالث. النقل غير المشفر لـ PII الحساسة والاعتماد على التصديق الذاتي للمورد أسفر عن كشف أرقام الضمان الاجتماعي وتواريخ الميلاد لـ 3.5 مليون فرد."
                },
                "BR_CASE9_INSIGHT": {
                    "en": "Supply chain security is no longer secondary risk — it is the risk.",
                    "ja": "サプライチェーンセキュリティはもはや二次的リスクではありません — それがリスクそのものです。",
                    "es": "La seguridad de la cadena de suministro ya no es un riesgo secundario — es el riesgo.",
                    "ar": "أمن سلسلة التوريد لم يعد مخاطرة ثانوية — إنه المخاطرة ذاتها."
                },

                // ---- Conclusion ----
                "BR_CONCLUSION_TITLE": {
                    "en": "Strategic Conclusion",
                    "ja": "戦略的結論",
                    "es": "Conclusión Estratégica",
                    "ar": "الاستنتاج الاستراتيجي"
                },
                "BR_CONCLUSION_QUOTE": {
                    "en": "Security failures are no longer isolated technical events — they are systemic trust failures.",
                    "ja": "セキュリティの失敗はもはや孤立した技術的イベントではありません — それは体系的な信頼の失敗です。",
                    "es": "Las fallas de seguridad ya no son eventos técnicos aislados — son fallas sistémicas de confianza.",
                    "ar": "إخفاقات الأمن لم تعد أحداثاً تقنية معزولة — إنها إخفاقات ثقة نظامية."
                },
                "BR_CONCLUSION_DESC": {
                    "en": "Organizations that focused solely on perimeter defense were consistently outmaneuvered by attackers exploiting vendors, integrations, insiders, APIs, and internal tools. The weakest link was rarely the firewall — it was assumed trust without verification.",
                    "ja": "境界防御だけに焦点を当てた組織は、ベンダー、統合、内部者、API、内部ツールを悪用する攻撃者に一貫して出し抜かれました。最も脆弱なリンクはファイアウォールではなく — 検証なしに前提された信頼でした。",
                    "es": "Las organizaciones que se enfocaron únicamente en la defensa perimetral fueron consistentemente superadas por atacantes que explotaron proveedores, integraciones, insiders, APIs y herramientas internas. El eslabón más débil raramente fue el firewall — fue la confianza asumida sin verificación.",
                    "ar": "المؤسسات التي ركّزت فقط على الدفاع المحيطي تم التغلب عليها باستمرار من قبل مهاجمين استغلوا الموردين والتكاملات والمطلعين وواجهات API والأدوات الداخلية. الحلقة الأضعف نادراً ما كانت جدار الحماية — بل كانت الثقة المفترضة دون تحقق."
                },
                "BR_CONCLUSION_CLOSING": {
                    "en": "Visibility, least privilege, continuous verification, and third-party security enforcement are now survival requirements — not best practices.",
                    "ja": "可視性、最小権限、継続的検証、サードパーティセキュリティの強制は、もはやベストプラクティスではなく生存要件です。",
                    "es": "Visibilidad, privilegio mínimo, verificación continua y aplicación de seguridad de terceros son ahora requisitos de supervivencia — no mejores prácticas.",
                    "ar": "الرؤية، الحد الأدنى من الصلاحيات، التحقق المستمر، وإنفاذ أمن الطرف الثالث أصبحت الآن متطلبات بقاء — وليست أفضل الممارسات."
                },
                "BR_CTA_TITLE": {
                    "en": "Don't become the next case study.",
                    "ja": "次のケーススタディにならないでください。",
                    "es": "No te conviertas en el próximo caso de estudio.",
                    "ar": "لا تصبح دراسة الحالة التالية."
                },
                "BR_CTA_DESC": {
                    "en": "Enbarr detects the attacks that bypass your existing tools — before they become headlines.",
                    "ja": "Enbarrは既存のツールをバイパスする攻撃を、ヘッドラインになる前に検出します。",
                    "es": "Enbarr detecta los ataques que evaden tus herramientas existentes — antes de que se conviertan en titulares.",
                    "ar": "Enbarr يكتشف الهجمات التي تتجاوز أدواتك الحالية — قبل أن تتصدر العناوين."
                },
                "BR_HOME_DESC": {
                    "en": "Explore the 2025 breach landscape — real incidents that reveal systemic trust failures across industries.",
                    "ja": "2025年の侵害の全体像を探る — 業界全体の体系的な信頼の失敗を明らかにする実際のインシデント。",
                    "es": "Explora el panorama de brechas de 2025 — incidentes reales que revelan fallas sistémicas de confianza en todas las industrias.",
                    "ar": "استكشف مشهد الاختراقات لعام 2025 — حوادث حقيقية تكشف إخفاقات الثقة النظامية عبر القطاعات."
                },

                // ---- About Page ----
                "ABOUT_BADGE": {
                    "en": "About Us",
                    "ja": "会社概要",
                    "es": "Sobre nosotros",
                    "ar": "من نحن"
                },
                "ABOUT_TITLE": {
                    "en": "Pioneering the Future of Cybersecurity",
                    "ja": "サイバーセキュリティの未来を切り開く",
                    "es": "Pioneros en el futuro de la ciberseguridad",
                    "ar": "ريادة مستقبل الأمن السيبراني"
                },
                "ABOUT_SUBTITLE": {
                    "en": "Founded in Tokyo, Japan by a team of seasoned engineers and innovators with deep roots in global tech leaders.",
                    "ja": "グローバルテック企業に深いルーツを持つ、経験豊富なエンジニアとイノベーターのチームにより東京で設立。",
                    "es": "Fundada en Tokio, Japón, por un equipo de ingenieros e innovadores experimentados con profundas raíces en líderes tecnológicos globales.",
                    "ar": "تأسست في طوكيو، اليابان على يد فريق من المهندسين والمبتكرين ذوي الخبرة والجذور العميقة في قادة التكنولوجيا العالميين."
                },
                "ABOUT_FOUNDED_TITLE": {
                    "en": "Our Origins",
                    "ja": "私たちの原点",
                    "es": "Nuestros orígenes",
                    "ar": "أصولنا"
                },
                "ABOUT_FOUNDED_DESC": {
                    "en": "Compdeep G.K. was established in Tokyo by former members of Google and Fuji Xerox. Drawing from world-class experience in AI, machine learning, cloud infrastructure, and enterprise systems, our founders identified a critical opportunity: to bridge the widening cybersecurity gaps in the Japanese market with cutting-edge, homegrown deep tech solutions.",
                    "ja": "Compdeep合同会社は、GoogleおよびFuji Xeroxの元メンバーにより東京で設立されました。AI、機械学習、クラウドインフラ、エンタープライズシステムにおけるワールドクラスの経験を活かし、創業者たちは日本市場におけるサイバーセキュリティの格差を、最先端の国産ディープテクノロジーで埋めるという重要な機会を見出しました。",
                    "es": "Compdeep G.K. fue establecida en Tokio por exmiembros de Google y Fuji Xerox. Aprovechando experiencia de clase mundial en IA, aprendizaje automático, infraestructura en la nube y sistemas empresariales, nuestros fundadores identificaron una oportunidad crítica: cerrar las crecientes brechas de ciberseguridad en el mercado japonés con soluciones de tecnología profunda de vanguardia.",
                    "ar": "تأسست Compdeep G.K. في طوكيو على يد أعضاء سابقين في Google وFuji Xerox. بالاستفادة من خبرة عالمية المستوى في الذكاء الاصطناعي والتعلم الآلي والبنية التحتية السحابية وأنظمة المؤسسات، حدد مؤسسونا فرصة حاسمة: سد فجوات الأمن السيبراني المتزايدة في السوق الياباني بحلول تكنولوجيا عميقة متطورة محلية الصنع."
                },
                "ABOUT_CHALLENGE_TITLE": {
                    "en": "The Challenge",
                    "ja": "課題",
                    "es": "El desafío",
                    "ar": "التحدي"
                },
                "ABOUT_CHALLENGE_DESC": {
                    "en": "Japan stands at the forefront of digital transformation — accelerating adoption of cloud computing, IoT, 5G-enabled smart manufacturing, and AI across industries. Yet this rapid evolution has exposed persistent vulnerabilities. With a reported shortage of over 110,000 cybersecurity professionals and increasing sophistication in threats ranging from state-sponsored espionage to ransomware, Japanese organizations face unprecedented risk.",
                    "ja": "日本はデジタルトランスフォーメーションの最前線に立ち、クラウドコンピューティング、IoT、5G対応スマート製造、AIの導入を加速させています。しかし、この急速な進化は根強い脆弱性を露呈させました。11万人以上のサイバーセキュリティ専門家の不足が報告され、国家支援のスパイ活動からランサムウェアまで脅威の高度化が進む中、日本の組織は前例のないリスクに直面しています。",
                    "es": "Japón está a la vanguardia de la transformación digital, acelerando la adopción de la computación en la nube, IoT, manufactura inteligente habilitada por 5G e IA en todas las industrias. Sin embargo, esta rápida evolución ha expuesto vulnerabilidades persistentes. Con una escasez reportada de más de 110,000 profesionales de ciberseguridad y una creciente sofisticación en las amenazas, las organizaciones japonesas enfrentan un riesgo sin precedentes.",
                    "ar": "تقف اليابان في طليعة التحول الرقمي — تسرّع اعتماد الحوسبة السحابية وإنترنت الأشياء والتصنيع الذكي المدعوم بـ 5G والذكاء الاصطناعي عبر القطاعات. لكن هذا التطور السريع كشف عن ثغرات مستمرة. مع نقص مُبلغ عنه يتجاوز 110,000 متخصص في الأمن السيبراني وتزايد تطور التهديدات، تواجه المؤسسات اليابانية مخاطر غير مسبوقة."
                },
                "ABOUT_SOLUTION_TITLE": {
                    "en": "Our Solution",
                    "ja": "私たちのソリューション",
                    "es": "Nuestra solución",
                    "ar": "حلّنا"
                },
                "ABOUT_SOLUTION_DESC": {
                    "en": "Our flagship product, Enbarr — an agentic AI cybersecurity platform — leverages autonomous AI agents to deliver proactive threat detection, intelligent response, and adaptive defense. Built from the ground up for the Japanese enterprise environment, Enbarr combines advanced deep learning models with Japan-specific compliance expertise, enabling organizations to achieve Zero Trust maturity, secure cloud migrations, and resilient operations.",
                    "ja": "当社のフラッグシップ製品Enbarrは、エージェントAIサイバーセキュリティプラットフォームとして、自律型AIエージェントを活用し、プロアクティブな脅威検出、インテリジェントな対応、適応型防御を実現します。日本のエンタープライズ環境のためにゼロから構築されたEnbarrは、先進的なディープラーニングモデルと日本固有のコンプライアンス専門知識を組み合わせ、ゼロトラスト成熟度の達成、安全なクラウド移行、レジリエントな運用を可能にします。",
                    "es": "Nuestro producto insignia, Enbarr — una plataforma de ciberseguridad con IA agéntica — utiliza agentes de IA autónomos para ofrecer detección proactiva de amenazas, respuesta inteligente y defensa adaptativa. Construido desde cero para el entorno empresarial japonés, Enbarr combina modelos avanzados de aprendizaje profundo con experiencia en cumplimiento específico de Japón.",
                    "ar": "منتجنا الرائد Enbarr — منصة أمن سيبراني بالذكاء الاصطناعي الوكيل — يستفيد من وكلاء الذكاء الاصطناعي الذاتيين لتقديم كشف استباقي للتهديدات واستجابة ذكية ودفاع تكيفي. مبني من الصفر لبيئة المؤسسات اليابانية، يجمع Enbarr بين نماذج التعلم العميق المتقدمة وخبرة الامتثال الخاصة باليابان."
                },
                "ABOUT_MISSION_TITLE": {
                    "en": "Our Mission",
                    "ja": "私たちのミッション",
                    "es": "Nuestra misión",
                    "ar": "مهمتنا"
                },
                "ABOUT_MISSION_1": {
                    "en": "Close Japan's cybersecurity talent and capability gaps with AI that augments, rather than replaces, human expertise.",
                    "ja": "人間の専門知識を代替するのではなく強化するAIで、日本のサイバーセキュリティ人材と能力のギャップを解消する。",
                    "es": "Cerrar las brechas de talento y capacidad en ciberseguridad de Japón con IA que aumenta, en lugar de reemplazar, la experiencia humana.",
                    "ar": "سد فجوات المواهب والقدرات في الأمن السيبراني في اليابان بذكاء اصطناعي يعزز الخبرة البشرية بدلاً من استبدالها."
                },
                "ABOUT_MISSION_2": {
                    "en": "Deliver sovereign, high-performance solutions tailored to Japanese regulatory landscapes and industrial needs.",
                    "ja": "日本の規制環境と産業ニーズに合わせた、主権的で高性能なソリューションを提供する。",
                    "es": "Ofrecer soluciones soberanas y de alto rendimiento adaptadas al panorama regulatorio e industrial de Japón.",
                    "ar": "تقديم حلول سيادية عالية الأداء مصممة للمشهد التنظيمي والاحتياجات الصناعية في اليابان."
                },
                "ABOUT_MISSION_3": {
                    "en": "Foster a new era of secure digital growth for enterprises, from Tokyo's financial hubs to Osaka's manufacturing corridors.",
                    "ja": "東京の金融ハブから大阪の製造業の回廊まで、企業のための安全なデジタル成長の新時代を築く。",
                    "es": "Fomentar una nueva era de crecimiento digital seguro para las empresas, desde los centros financieros de Tokio hasta los corredores manufactureros de Osaka.",
                    "ar": "تعزيز عصر جديد من النمو الرقمي الآمن للمؤسسات، من المراكز المالية في طوكيو إلى ممرات التصنيع في أوساكا."
                },
                "ABOUT_HQ_TITLE": {
                    "en": "Headquarters",
                    "ja": "本社",
                    "es": "Sede central",
                    "ar": "المقر الرئيسي"
                },
                "ABOUT_HQ_DESC": {
                    "en": "Headquartered in the heart of Tokyo, Compdeep G.K. combines Silicon Valley speed with Japanese precision and reliability. We partner closely with local enterprises, government initiatives, and global innovators to shape a safer, more intelligent digital future.",
                    "ja": "東京の中心に本社を構えるCompdeep合同会社は、シリコンバレーのスピードと日本の精密さ・信頼性を融合しています。地元企業、政府の取り組み、グローバルなイノベーターと密接に連携し、より安全でインテリジェントなデジタルの未来を形作ります。",
                    "es": "Con sede en el corazón de Tokio, Compdeep G.K. combina la velocidad de Silicon Valley con la precisión y fiabilidad japonesas. Colaboramos estrechamente con empresas locales, iniciativas gubernamentales e innovadores globales para dar forma a un futuro digital más seguro e inteligente.",
                    "ar": "يقع مقرها الرئيسي في قلب طوكيو، تجمع Compdeep G.K. بين سرعة وادي السيليكون والدقة والموثوقية اليابانية. نتشارك عن كثب مع المؤسسات المحلية والمبادرات الحكومية والمبتكرين العالميين لتشكيل مستقبل رقمي أكثر أماناً وذكاءً."
                },

                // ---- Terms Page ----
                "TERMS_BADGE": {
                    "en": "Legal",
                    "ja": "法務",
                    "es": "Legal", "ar": "الشؤون القانونية"
                },
                "TERMS_TITLE": {
                    "en": "Terms of Use",
                    "ja": "利用規約",
                    "es": "Términos de uso", "ar": "شروط الاستخدام"
                },
                "TERMS_SUBTITLE": {
                    "en": "Effective Date: February 08, 2026",
                    "ja": "発効日：2026年2月8日",
                    "es": "Fecha de vigencia: 08 de febrero de 2026", "ar": "تاريخ السريان: 08 فبراير 2026"
                },
                "TERMS_S1_TITLE": {
                    "en": "1. User Accounts and Access",
                    "ja": "1. ユーザーアカウントとアクセス",
                    "es": "1. Cuentas de usuario y acceso", "ar": "1. حسابات المستخدمين والوصول"
                },
                "TERMS_S1_DESC": {
                    "en": "Certain features of Enbarr require creation of an account. You must provide accurate, current, and complete information during registration and keep it updated. Accounts are for individual use only unless otherwise agreed in writing.<br><br>You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account. Notify us immediately at security@compdeep.co.jp of any unauthorized access or security breach.<br><br>We may, in our sole discretion, restrict, suspend, or terminate your access to the Services at any time, for any reason or no reason, with or without notice, and without liability.",
                    "ja": "Enbarrの特定の機能にはアカウントの作成が必要です。登録時に正確で最新の完全な情報を提供し、常に更新する必要があります。書面で別途合意しない限り、アカウントは個人使用のみです。<br><br>アカウント資格情報の機密性を維持し、アカウント下のすべての活動について責任を負います。不正アクセスやセキュリティ侵害があった場合は、security@compdeep.co.jpまで直ちにお知らせください。<br><br>当社は独自の裁量により、理由の有無にかかわらず、通知の有無にかかわらず、いつでもサービスへのアクセスを制限、停止、または終了する場合があります。",
                    "es": "Ciertas funciones de Enbarr requieren la creación de una cuenta. Debe proporcionar información precisa, actual y completa durante el registro y mantenerla actualizada. Las cuentas son de uso individual a menos que se acuerde lo contrario por escrito.", "ar": "بعض ميزات Enbarr تتطلب إنشاء حساب. يجب عليك تقديم معلومات دقيقة وحالية وكاملة أثناء التسجيل والحفاظ على تحديثها. الحسابات للاستخدام الفردي فقط ما لم يُتفق على خلاف ذلك كتابياً."
                },
                "TERMS_S2_TITLE": {
                    "en": "2. Use of the Services",
                    "ja": "2. サービスの利用",
                    "es": "2. Uso de los servicios", "ar": "2. استخدام الخدمات"
                },
                "TERMS_S2_DESC": {
                    "en": "You may use the Services only for lawful purposes and in accordance with these Terms. Enbarr is an agentic AI cybersecurity tool designed to detect, analyze, and respond to threats. Your use must comply with all applicable laws, including export control and data protection regulations.<br><br>You agree not to: use the Services in any way that violates laws or infringes third-party rights; attempt to gain unauthorized access; introduce viruses or harmful code; interfere with the Services; reverse engineer or decompile Enbarr; use the Services for benchmarking or competitive analysis without consent; or engage in spamming, phishing, or abusive activities.",
                    "ja": "サービスは合法的な目的でのみ、本規約に従って利用できます。Enbarrは脅威の検出、分析、対応を目的としたエージェントAIサイバーセキュリティツールです。輸出管理やデータ保護規制を含む、すべての適用法令を遵守する必要があります。<br><br>以下の行為を行わないことに同意するものとします：法律に違反するまたは第三者の権利を侵害する方法でのサービス利用、不正アクセスの試み、ウイルスや有害なコードの導入、サービスへの妨害、Enbarrのリバースエンジニアリングや逆コンパイル、同意なしのベンチマークや競合分析へのサービス利用、スパム、フィッシング、その他の不正行為への関与。",
                    "es": "Puede utilizar los Servicios solo para fines lícitos y de acuerdo con estos Términos. Enbarr es una herramienta de ciberseguridad con IA agéntica diseñada para detectar, analizar y responder a amenazas.", "ar": "يمكنك استخدام الخدمات فقط لأغراض مشروعة ووفقاً لهذه الشروط. Enbarr هي أداة أمن سيبراني بالذكاء الاصطناعي الوكيل مصممة لكشف التهديدات وتحليلها والاستجابة لها."
                },
                "TERMS_S3_TITLE": {
                    "en": "3. Intellectual Property",
                    "ja": "3. 知的財産",
                    "es": "3. Propiedad intelectual", "ar": "3. الملكية الفكرية"
                },
                "TERMS_S3_DESC": {
                    "en": "All content in the Services, including text, graphics, software, APIs, AI models, documentation, logos, and trademarks is owned by Compdeep G.K., our licensors, or other providers and protected by copyright, trademark, and other intellectual property laws.<br><br>We grant you a limited, revocable, non-transferable, non-sublicensable license to access and use the Services solely for your internal business or personal cybersecurity purposes, subject to these Terms.",
                    "ja": "テキスト、グラフィック、ソフトウェア、API、AIモデル、ドキュメント、ロゴ、商標を含むサービスのすべてのコンテンツは、Compdeep合同会社、そのライセンサー、またはその他のプロバイダーが所有し、著作権法、商標法、その他の知的財産法により保護されています。<br><br>本規約に従い、内部業務または個人のサイバーセキュリティ目的でのみサービスにアクセスし使用するための、限定的、取消可能、譲渡不可、再ライセンス不可のライセンスを付与します。",
                    "es": "Todo el contenido de los Servicios es propiedad de Compdeep G.K., nuestros licenciantes u otros proveedores y está protegido por leyes de propiedad intelectual.", "ar": "جميع المحتوى في الخدمات مملوك لـ Compdeep G.K. أو مرخصيها أو مقدميها الآخرين ومحمي بقوانين الملكية الفكرية."
                },
                "TERMS_S4_TITLE": {
                    "en": "4. User Content and Contributions",
                    "ja": "4. ユーザーコンテンツと投稿",
                    "es": "4. Contenido y contribuciones del usuario", "ar": "4. محتوى المستخدم والمساهمات"
                },
                "TERMS_S4_DESC": {
                    "en": "If the Services allow you to upload, submit, or share content, such content remains your property. You grant Compdeep G.K. a worldwide, perpetual, irrevocable, royalty-free license to use, reproduce, modify, and create derivative works from User Content as necessary to provide, maintain, improve, and secure the Services, including for AI training in anonymized or aggregated form where feasible.",
                    "ja": "サービスがコンテンツのアップロード、送信、または共有を許可する場合、そのコンテンツはお客様の所有物です。サービスの提供、維持、改善、セキュリティ確保のために必要な範囲で、匿名化または集約された形式でのAIトレーニングを含め、ユーザーコンテンツの使用、複製、変更、および二次的著作物の作成に関する、世界的、永続的、取消不能、ロイヤリティフリーのライセンスをCompdeep合同会社に付与するものとします。",
                    "es": "Si los Servicios le permiten cargar, enviar o compartir contenido, dicho contenido sigue siendo de su propiedad. Usted otorga a Compdeep G.K. una licencia mundial, perpetua e irrevocable para usar y reproducir el Contenido del Usuario según sea necesario.", "ar": "إذا سمحت لك الخدمات بتحميل أو إرسال أو مشاركة محتوى، فيظل هذا المحتوى ملكاً لك. تمنح Compdeep G.K. ترخيصاً عالمياً ودائماً وغير قابل للإلغاء لاستخدام محتوى المستخدم حسب الحاجة."
                },
                "TERMS_S5_TITLE": {
                    "en": "5. Disclaimers",
                    "ja": "5. 免責事項",
                    "es": "5. Descargos de responsabilidad", "ar": "5. إخلاء المسؤولية"
                },
                "TERMS_S5_DESC": {
                    "en": "THE SERVICES AND ALL CONTENT ARE PROVIDED \"AS IS\" AND \"AS AVAILABLE\" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR ACCURACY. WE DO NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED, ERROR-FREE, SECURE, OR FREE OF VIRUSES.",
                    "ja": "サービスおよびすべてのコンテンツは、商品性、特定目的への適合性、非侵害、正確性に関する保証を含む（ただしこれらに限定されない）、明示または黙示を問わず、いかなる種類の保証もなく「現状のまま」かつ「利用可能な限り」提供されます。サービスが中断なく、エラーなく、安全に、またはウイルスなく提供されることを保証するものではありません。",
                    "es": "LOS SERVICIOS Y TODO EL CONTENIDO SE PROPORCIONAN \"TAL CUAL\" Y \"SEGÚN DISPONIBILIDAD\" SIN GARANTÍAS DE NINGÚN TIPO, EXPRESAS O IMPLÍCITAS."
                },
                "TERMS_S6_TITLE": {
                    "en": "6. Limitation of Liability",
                    "ja": "6. 責任の制限",
                    "es": "6. Limitación de responsabilidad",
                    "ar": "الخدمات وجميع المحتوى مقدمة \"كما هي\" و\"حسب التوفر\" بدون ضمانات من أي نوع، صريحة أو ضمنية."
                },
                "TERMS_S6_DESC": {
                    "en": "TO THE MAXIMUM EXTENT PERMITTED BY LAW, COMPDEEP G.K. SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU PAID US FOR THE SERVICES IN THE TWELVE (12) MONTHS PRECEDING THE CLAIM.",
                    "ja": "法律で認められる最大限の範囲において、Compdeep合同会社は間接的、偶発的、特別、結果的、または懲罰的損害について責任を負いません。当社の総賠償責任は、請求に先立つ12か月間にお客様がサービスに対して支払った金額を超えないものとします。",
                    "es": "EN LA MÁXIMA MEDIDA PERMITIDA POR LA LEY, COMPDEEP G.K. NO SERÁ RESPONSABLE DE DAÑOS INDIRECTOS, INCIDENTALES, ESPECIALES, CONSECUENTES O PUNITIVOS.", "ar": "إلى أقصى حد يسمح به القانون، لا تتحمل Compdeep G.K. المسؤولية عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية."
                },
                "TERMS_S7_TITLE": {
                    "en": "7. Indemnification",
                    "ja": "7. 補償",
                    "es": "7. Indemnización", "ar": "7. التعويض"
                },
                "TERMS_S7_DESC": {
                    "en": "You agree to defend, indemnify, and hold harmless Compdeep G.K., its affiliates, officers, directors, employees, and agents from any claims, damages, losses, liabilities, costs, and expenses arising from or related to: (a) your use of the Services; (b) your breach of these Terms; (c) your User Content; or (d) violation of any law or third-party rights.",
                    "ja": "以下に起因または関連する請求、損害、損失、責任、費用、経費からCompdeep合同会社、その関連会社、役員、取締役、従業員、代理人を防御、補償し、免責することに同意するものとします：(a) お客様によるサービスの利用、(b) 本規約の違反、(c) お客様のユーザーコンテンツ、または (d) 法律もしくは第三者の権利の侵害。",
                    "es": "Usted acepta defender, indemnizar y mantener indemne a Compdeep G.K. de cualquier reclamo, daño, pérdida, responsabilidad, costo y gasto que surja de o esté relacionado con su uso de los Servicios.", "ar": "توافق على الدفاع عن Compdeep G.K. وتعويضها وإبرائها من أي مطالبات أو أضرار أو خسائر ناتجة عن استخدامك للخدمات."
                },
                "TERMS_S8_TITLE": {
                    "en": "8. Termination",
                    "ja": "8. 終了",
                    "es": "8. Terminación", "ar": "8. الإنهاء"
                },
                "TERMS_S8_DESC": {
                    "en": "We may terminate or suspend your access immediately for breach of these Terms or at our discretion. Upon termination, your right to use the Services ceases, but provisions that by nature survive (e.g., IP, disclaimers, limitation of liability, indemnification) continue.",
                    "ja": "本規約の違反またはその裁量により、お客様のアクセスを直ちに終了または停止することがあります。終了時、サービスの利用権は消失しますが、性質上存続する条項（知的財産、免責事項、責任の制限、補償など）は引き続き有効です。",
                    "es": "Podemos terminar o suspender su acceso inmediatamente por incumplimiento de estos Términos. Al terminar, su derecho a usar los Servicios cesa.", "ar": "يجوز لنا إنهاء أو تعليق وصولك فوراً بسبب مخالفة هذه الشروط. عند الإنهاء، ينتهي حقك في استخدام الخدمات."
                },
                "TERMS_S9_TITLE": {
                    "en": "9. Governing Law and Dispute Resolution",
                    "ja": "9. 準拠法と紛争解決",
                    "es": "9. Ley aplicable y resolución de disputas", "ar": "9. القانون الحاكم وحل النزاعات"
                },
                "TERMS_S9_DESC": {
                    "en": "These Terms are governed by the laws of Japan. Any disputes arising from or related to these Terms or the Services shall be resolved exclusively in the courts located in Tokyo, Japan.",
                    "ja": "本規約は日本法に準拠します。本規約またはサービスに起因または関連する紛争は、東京の裁判所において排他的に解決されるものとします。",
                    "es": "Estos Términos se rigen por las leyes de Japón. Cualquier disputa se resolverá exclusivamente en los tribunales de Tokio, Japón.", "ar": "تخضع هذه الشروط لقوانين اليابان. أي نزاعات تُحل حصرياً في محاكم طوكيو، اليابان."
                },
                "TERMS_S10_TITLE": {
                    "en": "10. Changes to These Terms",
                    "ja": "10. 本規約の変更",
                    "es": "10. Cambios a estos términos", "ar": "10. التغييرات على هذه الشروط"
                },
                "TERMS_S10_DESC": {
                    "en": "We may update these Terms at any time. We will post the revised version here with an updated effective date. Continued use of the Services after changes constitutes acceptance.",
                    "ja": "本規約はいつでも更新される場合があります。更新された発効日とともにここに改訂版を掲載します。変更後もサービスを継続して利用することは、変更の承諾を意味します。",
                    "es": "Podemos actualizar estos Términos en cualquier momento. Publicaremos la versión revisada aquí con una fecha de vigencia actualizada.", "ar": "يجوز لنا تحديث هذه الشروط في أي وقت. سننشر النسخة المعدلة هنا مع تاريخ سريان محدث."
                },
                "TERMS_S11_TITLE": {
                    "en": "11. General",
                    "ja": "11. 一般条項",
                    "es": "11. General", "ar": "11. أحكام عامة"
                },
                "TERMS_S11_DESC": {
                    "en": "If any provision is held invalid, the remainder remains in effect. No waiver of any breach constitutes a waiver of subsequent breaches. These Terms, together with any applicable subscription agreements, constitute the entire agreement.",
                    "ja": "いずれかの条項が無効と判断された場合、残りの条項は引き続き有効です。いかなる違反の権利放棄も、その後の違反の権利放棄を構成するものではありません。本規約は、適用される加入契約とともに、完全な合意を構成します。",
                    "es": "Si alguna disposición se considera inválida, el resto permanece en vigor. Estos Términos constituyen el acuerdo completo.", "ar": "إذا اعتُبر أي حكم باطلاً، تبقى بقية الأحكام سارية. هذه الشروط تشكل الاتفاقية الكاملة."
                },
                "TERMS_CONTACT_DEPT": {
                    "en": "Legal Department",
                    "ja": "法務部",
                    "es": "Departamento Legal", "ar": "القسم القانوني"
                },

                // ---- Privacy Page ----
                "PRIVACY_BADGE": {
                    "en": "Privacy",
                    "ja": "プライバシー",
                    "es": "Privacidad", "ar": "الخصوصية"
                },
                "PRIVACY_TITLE": {
                    "en": "Privacy Policy",
                    "ja": "プライバシーポリシー",
                    "es": "Política de privacidad", "ar": "سياسة الخصوصية"
                },
                "PRIVACY_SUBTITLE": {
                    "en": "Effective Date: February 08, 2026",
                    "ja": "発効日：2026年2月8日",
                    "es": "Fecha de vigencia: 08 de febrero de 2026", "ar": "تاريخ السريان: 08 فبراير 2026"
                },
                "PRIVACY_S1_TITLE": {
                    "en": "1. Information We Collect",
                    "ja": "1. 収集する情報",
                    "es": "1. Información que recopilamos", "ar": "1. المعلومات التي نجمعها"
                },
                "PRIVACY_S1_DESC": {
                    "en": "<strong>Information You Provide Directly:</strong> Contact information (name, email, phone number, company, job title, address), account information (username, password), payment information processed through secure third-party providers, and content you submit (feedback, support tickets).<br><br><strong>Information Collected Automatically:</strong> Device and usage data (IP address, browser type, OS, pages viewed), log data for cybersecurity purposes, and cookies and similar technologies for tracking usage and performance.<br><br><strong>Information from Third Parties:</strong> Information from business partners, resellers, or publicly available sources.<br><br>For Enbarr, as an agentic AI cybersecurity product, we may process data from your systems to detect threats, but we minimize collection of personal information and anonymize where possible.",
                    "ja": "<strong>お客様が直接提供する情報：</strong>連絡先情報（氏名、メールアドレス、電話番号、会社名、役職、住所）、アカウント情報（ユーザー名、パスワード）、安全な第三者プロバイダーを通じて処理される決済情報、お客様が提出するコンテンツ（フィードバック、サポートチケット）。<br><br><strong>自動的に収集される情報：</strong>デバイスおよび使用データ（IPアドレス、ブラウザの種類、OS、閲覧ページ）、サイバーセキュリティ目的のログデータ、使用状況とパフォーマンスを追跡するためのCookieおよび類似技術。<br><br><strong>第三者からの情報：</strong>ビジネスパートナー、リセラー、または公開情報源からの情報。<br><br>エージェントAIサイバーセキュリティ製品であるEnbarrでは、脅威を検出するためにお客様のシステムからデータを処理することがありますが、個人情報の収集を最小限に抑え、可能な限り匿名化します。",
                    "es": "Recopilamos información de contacto, información de cuenta, información de pago e información recopilada automáticamente como datos de dispositivo y uso, datos de registro y cookies.", "ar": "نجمع معلومات الاتصال ومعلومات الحساب ومعلومات الدفع والمعلومات المجمعة تلقائياً مثل بيانات الجهاز والاستخدام وبيانات السجل وملفات تعريف الارتباط."
                },
                "PRIVACY_S2_TITLE": {
                    "en": "2. How We Use Your Information",
                    "ja": "2. 情報の利用方法",
                    "es": "2. Cómo usamos su información", "ar": "2. كيف نستخدم معلوماتك"
                },
                "PRIVACY_S2_DESC": {
                    "en": "We use personal information for: providing services (threat detection, AI-driven analysis, cybersecurity features); improving products (analyzing usage, developing features, training AI models with anonymized data); communications (service updates, security alerts, marketing); security and compliance (protecting services, preventing fraud); business operations (billing, auditing); and marketing and events.<br><br>We do not use personal information for automated decision-making that produces legal effects without human oversight.",
                    "ja": "個人情報を以下の目的で使用します：サービスの提供（脅威検出、AI駆動分析、サイバーセキュリティ機能）、製品の改善（使用状況の分析、機能開発、匿名化データによるAIモデルのトレーニング）、コミュニケーション（サービスの更新、セキュリティアラート、マーケティング）、セキュリティとコンプライアンス（サービスの保護、不正防止）、ビジネス運営（請求、監査）、マーケティングとイベント。<br><br>人間の監視なしに法的効果を生む自動意思決定に個人情報を使用することはありません。",
                    "es": "Usamos la información personal para: proporcionar servicios, mejorar productos, comunicaciones, seguridad y cumplimiento, operaciones comerciales y marketing.", "ar": "نستخدم المعلومات الشخصية لتقديم الخدمات وتحسين المنتجات والاتصالات والأمن والامتثال والعمليات التجارية والتسويق."
                },
                "PRIVACY_S3_TITLE": {
                    "en": "3. Sharing Your Information",
                    "ja": "3. 情報の共有",
                    "es": "3. Compartir su información", "ar": "3. مشاركة معلوماتك"
                },
                "PRIVACY_S3_DESC": {
                    "en": "We share personal information only as necessary: with affiliates and subsidiaries for internal operations; with service providers for hosting, analytics, payment processing, and support (bound by confidentiality agreements); with business partners for sales and support; to respond to legal requirements; and in connection with business transfers.<br><br>We do not sell personal information.",
                    "ja": "個人情報は必要な場合にのみ共有します：内部業務のための関連会社・子会社、ホスティング・分析・決済処理・サポートのためのサービスプロバイダー（機密保持契約に基づく）、販売・サポートのためのビジネスパートナー、法的要求への対応、事業譲渡に関連して。<br><br>個人情報の販売は行いません。",
                    "es": "Compartimos información personal solo cuando es necesario: con afiliados, proveedores de servicios, socios comerciales, para requisitos legales y transferencias comerciales. No vendemos información personal.", "ar": "نشارك المعلومات الشخصية فقط عند الضرورة: مع الشركات التابعة ومقدمي الخدمات والشركاء التجاريين وللمتطلبات القانونية وعمليات النقل التجارية. لا نبيع المعلومات الشخصية."
                },
                "PRIVACY_S4_TITLE": {
                    "en": "4. Security Measures",
                    "ja": "4. セキュリティ対策",
                    "es": "4. Medidas de seguridad", "ar": "4. تدابير الأمان"
                },
                "PRIVACY_S4_DESC": {
                    "en": "We implement reasonable administrative, technical, and physical safeguards to protect personal information, including encryption, access controls, and regular audits. For Enbarr, we use advanced AI to monitor for threats. However, no system is completely secure, so we cannot guarantee absolute security.",
                    "ja": "暗号化、アクセス制御、定期的な監査を含む、合理的な管理的、技術的、物理的セーフガードを実施して個人情報を保護しています。Enbarrでは、脅威の監視に先進的なAIを使用しています。ただし、完全に安全なシステムは存在しないため、絶対的なセキュリティを保証することはできません。",
                    "es": "Implementamos salvaguardas administrativas, técnicas y físicas razonables para proteger la información personal.", "ar": "ننفذ ضمانات إدارية وتقنية ومادية معقولة لحماية المعلومات الشخصية."
                },
                "PRIVACY_S5_TITLE": {
                    "en": "5. Data Retention",
                    "ja": "5. データ保持",
                    "es": "5. Retención de datos", "ar": "5. الاحتفاظ بالبيانات"
                },
                "PRIVACY_S5_DESC": {
                    "en": "We store personal information for no longer than necessary for the purposes outlined in this Privacy Policy, or as required by law. Account data is retained while active and for a period after to comply with legal obligations. Log data may be kept for security analysis, typically up to 12 months. When no longer needed, we delete or anonymize data.",
                    "ja": "本プライバシーポリシーに記載された目的に必要な期間、または法律で要求される期間を超えて個人情報を保存することはありません。アカウントデータは有効期間中および法的義務を遵守するためのその後の一定期間保持されます。ログデータは通常最大12か月間、セキュリティ分析のために保存される場合があります。不要になった場合、データを削除または匿名化します。",
                    "es": "Almacenamos información personal solo por el tiempo necesario. Los datos de cuenta se retienen mientras están activos. Los datos de registro se pueden mantener hasta 12 meses.", "ar": "نخزن المعلومات الشخصية فقط للمدة اللازمة. تُحتفظ بيانات الحساب أثناء نشاطها. يمكن الاحتفاظ ببيانات السجل حتى 12 شهراً."
                },
                "PRIVACY_S6_TITLE": {
                    "en": "6. Your Rights and Choices",
                    "ja": "6. お客様の権利と選択肢",
                    "es": "6. Sus derechos y opciones", "ar": "6. حقوقك وخياراتك"
                },
                "PRIVACY_S6_DESC": {
                    "en": "Depending on your location, you may have rights under laws like GDPR, CCPA, or APPI (Japan's Act on the Protection of Personal Information): access and correction of your personal information; deletion (subject to exceptions); opt-out of marketing communications; right to object or restrict processing; and data portability.<br><br>To exercise rights, contact us at privacy@compdeep.com.",
                    "ja": "お住まいの地域に応じて、GDPR、CCPA、またはAPPI（個人情報保護法）などの法律に基づく権利をお持ちの場合があります：個人情報へのアクセスと訂正、削除（例外あり）、マーケティング通信のオプトアウト、処理に対する異議申立てまたは制限、データポータビリティ。<br><br>権利を行使するには、privacy@compdeep.comまでお問い合わせください。",
                    "es": "Dependiendo de su ubicación, puede tener derechos bajo leyes como GDPR, CCPA o APPI: acceso, corrección, eliminación, exclusión y portabilidad de datos.", "ar": "حسب موقعك، قد تكون لديك حقوق بموجب قوانين مثل GDPR أو CCPA أو APPI: الوصول والتصحيح والحذف والانسحاب وقابلية نقل البيانات."
                },
                "PRIVACY_S7_TITLE": {
                    "en": "7. International Data Transfers",
                    "ja": "7. 国際データ移転",
                    "es": "7. Transferencias internacionales de datos", "ar": "7. نقل البيانات الدولي"
                },
                "PRIVACY_S7_DESC": {
                    "en": "Compdeep G.K. is based in Japan, but we may transfer data to other countries, including the US or EU. We use Standard Contractual Clauses or other mechanisms to ensure adequate protection.",
                    "ja": "Compdeep合同会社は日本に拠点を置いていますが、米国やEUを含む他の国にデータを移転することがあります。適切な保護を確保するために、標準契約条項やその他のメカニズムを使用しています。",
                    "es": "Compdeep G.K. tiene su sede en Japón, pero podemos transferir datos a otros países. Utilizamos Cláusulas Contractuales Estándar para garantizar una protección adecuada.", "ar": "يقع مقر Compdeep G.K. في اليابان، لكن قد ننقل البيانات إلى بلدان أخرى. نستخدم البنود التعاقدية القياسية لضمان الحماية الكافية."
                },
                "PRIVACY_S8_TITLE": {
                    "en": "8. Changes to This Privacy Policy",
                    "ja": "8. 本プライバシーポリシーの変更",
                    "es": "8. Cambios a esta política de privacidad", "ar": "8. التغييرات على سياسة الخصوصية هذه"
                },
                "PRIVACY_S8_DESC": {
                    "en": "We may update this Policy to reflect changes in practices or laws. We will post updates here and notify you via email or notice on our site. Continued use constitutes acceptance.",
                    "ja": "慣行や法律の変更を反映するために本ポリシーを更新することがあります。ここに更新を掲載し、メールまたはサイト上の通知でお知らせします。継続的な利用は承諾を意味します。",
                    "es": "Podemos actualizar esta Política para reflejar cambios en prácticas o leyes. Publicaremos actualizaciones aquí y le notificaremos por correo electrónico.", "ar": "قد نحدث هذه السياسة لتعكس التغييرات في الممارسات أو القوانين. سننشر التحديثات هنا ونخطرك عبر البريد الإلكتروني."
                },
                "PRIVACY_S9_TITLE": {
                    "en": "9. Contact Us",
                    "ja": "9. お問い合わせ",
                    "es": "9. Contáctenos", "ar": "9. اتصل بنا"
                },
                "PRIVACY_S9_DESC": {
                    "en": "For questions or requests regarding this Privacy Policy, please contact our Privacy Officer. This Policy is governed by Japanese law.",
                    "ja": "本プライバシーポリシーに関するご質問やご要望は、プライバシー担当者までお問い合わせください。本ポリシーは日本法に準拠します。",
                    "es": "Para preguntas o solicitudes sobre esta Política de Privacidad, comuníquese con nuestro Oficial de Privacidad. Esta Política se rige por la ley japonesa.", "ar": "للأسئلة أو الطلبات المتعلقة بسياسة الخصوصية هذه، يرجى الاتصال بمسؤول الخصوصية لدينا. تخضع هذه السياسة للقانون الياباني."
                },
                "PRIVACY_CONTACT_DEPT": {
                    "en": "Privacy Officer",
                    "ja": "プライバシー担当者",
                    "es": "Oficial de Privacidad",
                    "fr": "Responsable de la Protection des Données",
                    "zh": "隐私官",
                    "zh-TW": "隱私官",
                    "de": "Datenschutzbeauftragter", "ar": "مسؤول الخصوصية"
                },
                "TEXT_BREACHES": {
                    "en": "Breaches",
                    "ja": "侵害事例",
                    "es": "Brechas",
                    "fr": "Violations",
                    "zh": "安全事件",
                    "zh-TW": "安全事件",
                    "de": "Sicherheitsvorfälle", "ar": "الاختراقات"
                },
                "HOME_HERO_SUBTITLE": {
                    "en": "THE FUTURE OF SECOPS",
                    "ja": "次世代のセキュリティ運用",
                    "es": "EL FUTURO DE SECOPS",
                    "fr": "L'AVENIR DU SECOPS",
                    "zh": "安全运营的未来",
                    "zh-TW": "資安維運的未來",
                    "de": "DIE ZUKUNFT VON SECOPS", "ar": "مستقبل العمليات الأمنية"
                },
                "HOME_HERO_TITLE": {
                    "en": "Autonomous Defence.",
                    "ja": "自律型防御",
                    "es": "Defensa Autónoma.",
                    "fr": "Défense Autonome.",
                    "zh": "自主防御",
                    "zh-TW": "自主防禦新時代。",
                    "de": "Autonome Verteidigung.", "ar": "دفاع ذاتي."
                },
                "HOME_HERO_DESC": {
                    "en": "An agentic AI security platform that continuously observes your entire digital ecosystem, reasons, plans, and acts intelligently to protect your organization. Reduce cost, complexity, and operations — replacing your entire SecOps vendor stack.",
                    "ja": "組織全体を自律的に守り続ける、次世代AIセキュリティ・プラットフォーム。デジタル環境の全域を常時監視し、AIが自ら推論・計画・実行。複雑化したSecOpsベンダーのツール群を統合・最適化し、運用コストの削減と効率化を実現します。",
                    "es": "Una plataforma de seguridad con IA agéntica que observa continuamente todo tu ecosistema digital, razona, planifica y actúa inteligentemente para proteger tu organización. Reduce costos, complejidad y operaciones.",
                    "fr": "Une plateforme de sécurité IA agentique qui observe en continu tout votre écosystème numérique, raisonne, planifie et agit intelligemment pour protéger votre organisation. Réduisez les coûts, la complexité et les opérations.",
                    "zh": "一个持续观察整个数字生态系统、推理、规划并智能行动以保护组织的AI安全平台。降低成本、复杂性和运营负担——替换整个安全运营供应商堆栈。",
                    "zh-TW": "一個全天候監控您數位環境、智慧分析威脅並主動採取行動保護組織的AI資安平台。大幅降低成本與複雜度，用一個平台取代多家資安供應商。",
                    "de": "Eine agentische KI-Sicherheitsplattform, die Ihr gesamtes digitales Ökosystem kontinuierlich beobachtet, analysiert, plant und intelligent handelt, um Ihre Organisation zu schützen. Reduzieren Sie Kosten, Komplexität und Betriebsaufwand.", "ar": "منصة أمن بالذكاء الاصطناعي الوكيل تراقب باستمرار نظامك الرقمي بأكمله، وتستدل وتخطط وتتصرف بذكاء لحماية مؤسستك. قلّل التكلفة والتعقيد والعمليات — لتحل محل مجموعة موردي SecOps بأكملها."
                },
                "HOME_ZERO_VALUE_1": {
                    "en": "Zero",
                    "ja": "ゼロ",
                    "es": "Cero",
                    "fr": "Zéro",
                    "zh": "零",
                    "zh-TW": "零",
                    "de": "Null", "ar": "صفر"
                },
                "HOME_ZERO_LABEL_1": {
                    "en": "Third-party dependencies",
                    "ja": "サードパーティ依存",
                    "es": "Dependencias de terceros",
                    "fr": "Dépendances tierces",
                    "zh": "第三方依赖",
                    "zh-TW": "第三方依賴",
                    "de": "Drittanbieter-Abhängigkeiten", "ar": "اعتماد على أطراف ثالثة"
                },
                "HOME_ZERO_VALUE_2": {
                    "en": "Zero",
                    "ja": "ゼロ",
                    "es": "Cero",
                    "fr": "Zéro",
                    "zh": "零",
                    "zh-TW": "零",
                    "de": "Null", "ar": "صفر"
                },
                "HOME_ZERO_LABEL_2": {
                    "en": "Cloud data leakage",
                    "ja": "クラウドデータ漏洩",
                    "es": "Fuga de datos en la nube",
                    "fr": "Fuite de données cloud",
                    "zh": "云数据泄露",
                    "zh-TW": "雲端資料外洩",
                    "de": "Cloud-Datenlecks", "ar": "تسرب بيانات سحابية"
                },
                "HOME_ZERO_VALUE_3": {
                    "en": "Zero",
                    "ja": "ゼロ",
                    "es": "Cero",
                    "fr": "Zéro",
                    "zh": "零",
                    "zh-TW": "零",
                    "de": "Null", "ar": "صفر"
                },
                "HOME_ZERO_LABEL_3": {
                    "en": "Third-party vendors",
                    "ja": "サードパーティベンダー",
                    "es": "Proveedores externos",
                    "fr": "Fournisseurs tiers",
                    "zh": "第三方供应商",
                    "zh-TW": "第三方供應商",
                    "de": "Drittanbieter", "ar": "موردون خارجيون"
                },
                "HOME_ZERO_VALUE_4": {
                    "en": "Zero",
                    "ja": "ゼロ",
                    "es": "Cero",
                    "fr": "Zéro",
                    "zh": "零",
                    "zh-TW": "零",
                    "de": "Null", "ar": "صفر"
                },
                "HOME_ZERO_LABEL_4": {
                    "en": "Single points of failure",
                    "ja": "単一障害点",
                    "es": "Puntos únicos de fallo",
                    "fr": "Points de défaillance uniques",
                    "zh": "单点故障",
                    "zh-TW": "單點故障",
                    "de": "Single Points of Failure", "ar": "نقاط فشل فردية"
                },
                "HOME_IMPACT_BADGE": {
                    "en": "BY THE NUMBERS",
                    "ja": "数字で見る",
                    "es": "EN CIFRAS",
                    "fr": "EN CHIFFRES",
                    "zh": "数据说话",
                    "zh-TW": "數據證明一切",
                    "de": "IN ZAHLEN", "ar": "بالأرقام"
                },
                "HOME_IMPACT_TITLE": {
                    "en": "Business Impact",
                    "ja": "ビジネスインパクト",
                    "es": "Impacto Empresarial",
                    "fr": "Impact Commercial",
                    "zh": "业务影响",
                    "zh-TW": "業務影響",
                    "de": "Geschäftliche Auswirkungen", "ar": "الأثر التجاري"
                },
                "HOME_IMPACT_SUBTITLE": {
                    "en": "Collapse your entire security and management stack into a single autonomous platform.",
                    "ja": "セキュリティと管理スタック全体を単一の自律プラットフォームに統合。",
                    "es": "Consolida toda tu pila de seguridad y gestión en una sola plataforma autónoma.",
                    "fr": "Consolidez toute votre pile de sécurité et de gestion en une seule plateforme autonome.",
                    "zh": "将整个安全和管理堆栈整合为单一自主平台。",
                    "zh-TW": "將所有資安與管理工具整合為單一自主式平台。",
                    "de": "Konsolidieren Sie Ihren gesamten Sicherheits- und Management-Stack in einer einzigen autonomen Plattform.", "ar": "ادمج مجموعة الأمان والإدارة بأكملها في منصة ذاتية واحدة."
                },
                "HOME_STAT_VALUE_1": {
                    "en": "7+",
                    "ja": "7+",
                    "es": "7+",
                    "fr": "7+",
                    "zh": "7+",
                    "zh-TW": "7+",
                    "de": "7+", "ar": "7+"
                },
                "HOME_STAT_LABEL_1": {
                    "en": "Vendors Replaced",
                    "ja": "置き換えたベンダー数",
                    "es": "Proveedores Reemplazados",
                    "fr": "Fournisseurs Remplacés",
                    "zh": "替换的供应商",
                    "zh-TW": "替換的供應商",
                    "de": "Ersetzte Anbieter", "ar": "موردون تم استبدالهم"
                },
                "HOME_STAT_DESC_1": {
                    "en": "EDR, SIEM, RMM, UEM in one platform",
                    "ja": "EDR、SIEM、RMM、UEMをひとつのプラットフォームへ集約",
                    "es": "EDR, SIEM, RMM, UEM en una plataforma",
                    "fr": "EDR, SIEM, RMM, UEM en une plateforme",
                    "zh": "EDR、SIEM、RMM、UEM集于一个平台",
                    "zh-TW": "EDR、SIEM、RMM、UEM 一站整合",
                    "de": "EDR, SIEM, RMM, UEM in einer Plattform", "ar": "EDR وSIEM وRMM وUEM في منصة واحدة"
                },
                "HOME_STAT_VALUE_2": {
                    "en": "-97%",
                    "ja": "-97%",
                    "es": "-97%",
                    "fr": "-97%",
                    "zh": "-97%",
                    "zh-TW": "-97%",
                    "de": "-97%", "ar": "-97%"
                },
                "HOME_STAT_LABEL_2": {
                    "en": "Alert Fatigue",
                    "ja": "アラート疲労",
                    "es": "Fatiga de Alertas",
                    "fr": "Fatigue d'Alertes",
                    "zh": "告警疲劳",
                    "zh-TW": "警示疲勞",
                    "de": "Alarm-Müdigkeit", "ar": "إرهاق التنبيهات"
                },
                "HOME_STAT_DESC_2": {
                    "en": "From thousands of alerts to one narrative",
                    "ja": "大量のアラートを1つのストーリーに集約",
                    "es": "De miles de alertas a una narrativa",
                    "fr": "De milliers d'alertes à un seul récit",
                    "zh": "从数千条告警到一个叙事",
                    "zh-TW": "數千條警示彙整為一份清晰報告",
                    "de": "Von Tausenden Alarmen zu einer Erzählung", "ar": "من آلاف التنبيهات إلى سردية واحدة"
                },
                "HOME_STAT_VALUE_3": {
                    "en": "24/7",
                    "ja": "24/7",
                    "es": "24/7",
                    "fr": "24/7",
                    "zh": "24/7",
                    "zh-TW": "24/7",
                    "de": "24/7", "ar": "24/7"
                },
                "HOME_STAT_LABEL_3": {
                    "en": "Autonomous Coverage",
                    "ja": "自動で常時監視",
                    "es": "Cobertura Autónoma",
                    "fr": "Couverture Autonome",
                    "zh": "自主覆盖",
                    "zh-TW": "全天候自動防護",
                    "de": "Autonome Abdeckung", "ar": "تغطية ذاتية"
                },
                "HOME_STAT_DESC_3": {
                    "en": "No SOC shifts, no weekend gaps",
                    "ja": "SOCシフトも、休日のセキュリティリスクも、もうありません",
                    "es": "Sin turnos SOC, sin brechas de fin de semana",
                    "fr": "Pas de rotation SOC, pas de lacunes le week-end",
                    "zh": "无需SOC轮班，无周末间隙",
                    "zh-TW": "不需SOC排班，週末也不中斷",
                    "de": "Keine SOC-Schichten, keine Wochenend-Lücken", "ar": "لا مناوبات SOC، لا فجوات عطلات نهاية الأسبوع"
                },
                "HOME_STAT_VALUE_4": {
                    "en": "1",
                    "ja": "1",
                    "es": "1",
                    "fr": "1",
                    "zh": "1",
                    "zh-TW": "1",
                    "de": "1", "ar": "1"
                },
                "HOME_STAT_LABEL_4": {
                    "en": "Operator",
                    "ja": "担当者",
                    "es": "Operador",
                    "fr": "Opérateur",
                    "zh": "操作员",
                    "zh-TW": "管理人員",
                    "de": "Operator", "ar": "مشغّل"
                },
                "HOME_STAT_DESC_4": {
                    "en": "Manages entire fleet, not a team of 12",
                    "ja": "12人体制ではなく、1人で全フリート（管理対象）を管理",
                    "es": "Gestiona toda la flota, no un equipo de 12",
                    "fr": "Gère toute la flotte, pas une équipe de 12",
                    "zh": "管理整个设备群，而非12人团队",
                    "zh-TW": "1人即可管理所有裝置，無需12人團隊",
                    "de": "Verwaltet die gesamte Flotte, nicht ein Team von 12", "ar": "يدير الأسطول بأكمله، وليس فريقاً من 12"
                },
                "HOME_COMPARE_BADGE": {
                    "en": "TRANSFORMATION",
                    "ja": "革新的な変化",
                    "es": "TRANSFORMACIÓN",
                    "fr": "TRANSFORMATION",
                    "zh": "转型",
                    "zh-TW": "導入效果",
                    "de": "TRANSFORMATION", "ar": "التحوّل"
                },
                "HOME_COMPARE_TITLE": {
                    "en": "Before & After",
                    "ja": "導入前と、導入後",
                    "es": "Antes y Después",
                    "fr": "Avant et Après",
                    "zh": "前后对比",
                    "zh-TW": "前後對比",
                    "de": "Vorher & Nachher", "ar": "قبل وبعد"
                },
                "HOME_COMPARE_BEFORE_TITLE": {
                    "en": "Before",
                    "ja": "導入前",
                    "es": "Antes",
                    "fr": "Avant",
                    "zh": "之前",
                    "zh-TW": "之前",
                    "de": "Vorher", "ar": "قبل"
                },
                "HOME_COMPARE_AFTER_TITLE": {
                    "en": "With Enbarr",
                    "ja": "Enbarr導入後",
                    "es": "Con Enbarr",
                    "fr": "Avec Enbarr",
                    "zh": "使用Enbarr后",
                    "zh-TW": "使用Enbarr後",
                    "de": "Mit Enbarr", "ar": "مع Enbarr"
                },
                "HOME_COMPARE_BEFORE_1": {
                    "en": "6 vendors, 6 consoles, 6 attack surfaces",
                    "ja": "6つのベンダー、6つの管理コンソール、そして6層の攻撃対象領域",
                    "es": "6 proveedores, 6 consolas, 6 superficies de ataque",
                    "fr": "6 fournisseurs, 6 consoles, 6 surfaces d'attaque",
                    "zh": "6个供应商、6个控制台、6个攻击面",
                    "zh-TW": "6個供應商、6個控制檯、6個攻擊面",
                    "de": "6 Anbieter, 6 Konsolen, 6 Angriffsflächen", "ar": "6 موردين، 6 لوحات تحكم، 6 أسطح هجوم"
                },
                "HOME_COMPARE_BEFORE_2": {
                    "en": "Thousands of alerts per day",
                    "ja": "1日あたり数千件規模のアラート対応",
                    "es": "Miles de alertas por día",
                    "fr": "Des milliers d'alertes par jour",
                    "zh": "每天数千条告警",
                    "zh-TW": "每天數千條警示",
                    "de": "Tausende Alarme pro Tag", "ar": "آلاف التنبيهات يومياً"
                },
                "HOME_COMPARE_BEFORE_3": {
                    "en": "45-minute mean time to investigate",
                    "ja": "脅威の調査に要する平均時間（MTTI）：45分",
                    "es": "45 minutos de tiempo medio de investigación",
                    "fr": "45 minutes de temps moyen d'investigation",
                    "zh": "平均调查时间45分钟",
                    "zh-TW": "平均調查時間45分鐘",
                    "de": "45 Minuten mittlere Untersuchungszeit", "ar": "45 دقيقة متوسط وقت التحقيق"
                },
                "HOME_COMPARE_BEFORE_4": {
                    "en": "72-hour mean time to respond",
                    "ja": "対応完了までの平均時間（MTTR）：72時間",
                    "es": "72 horas de tiempo medio de respuesta",
                    "fr": "72 heures de temps moyen de réponse",
                    "zh": "平均响应时间72小时",
                    "zh-TW": "平均響應時間72小時",
                    "de": "72 Stunden mittlere Reaktionszeit", "ar": "72 ساعة متوسط وقت الاستجابة"
                },
                "HOME_COMPARE_BEFORE_5": {
                    "en": "Multi-million annual spend",
                    "ja": "年間数百万ドルにのぼるセキュリティ支出",
                    "es": "Gasto anual multimillonario",
                    "fr": "Dépenses annuelles de plusieurs millions",
                    "zh": "每年数百万美元支出",
                    "zh-TW": "每年數百萬美元支出",
                    "de": "Jährliche Ausgaben in Millionenhöhe", "ar": "إنفاق سنوي بالملايين"
                },
                "HOME_COMPARE_BEFORE_6": {
                    "en": "5-person SOC minimum",
                    "ja": "最低5名以上のSOC要員",
                    "es": "SOC de mínimo 5 personas",
                    "fr": "SOC de minimum 5 personnes",
                    "zh": "至少5人SOC团队",
                    "zh-TW": "至少5人SOC團隊",
                    "de": "Mindestens 5-köpfiges SOC-Team", "ar": "فريق SOC بحد أدنى 5 أشخاص"
                },
                "HOME_COMPARE_AFTER_1": {
                    "en": "1 platform, zero vendor dependencies",
                    "ja": "基盤を一つに統合、特定ベンダーへの依存を排除",
                    "es": "1 plataforma, cero dependencias de proveedores",
                    "fr": "1 plateforme, zéro dépendances fournisseurs",
                    "zh": "1个平台，零供应商依赖",
                    "zh-TW": "1個平台，零供應商依賴",
                    "de": "1 Plattform, null Anbieter-Abhängigkeiten", "ar": "منصة واحدة، صفر اعتماد على موردين"
                },
                "HOME_COMPARE_AFTER_2": {
                    "en": "Narratives, not alert flood",
                    "ja": "アラートの嵐から解放。事象の全容を伝える「一連の報告」へ",
                    "es": "Narrativas, no inundación de alertas",
                    "fr": "Récits, pas d'inondation d'alertes",
                    "zh": "叙事而非告警洪流",
                    "zh-TW": "清晰報告取代警示轟炸",
                    "de": "Erzählungen, keine Alarm-Flut", "ar": "سرديات، وليس طوفان تنبيهات"
                },
                "HOME_COMPARE_AFTER_3": {
                    "en": "< 90 second investigation",
                    "ja": "調査完了まで90秒以内",
                    "es": "Investigación en menos de 90 segundos",
                    "fr": "Investigation en moins de 90 secondes",
                    "zh": "不到90秒完成调查",
                    "zh-TW": "不到90秒完成調查",
                    "de": "Untersuchung in unter 90 Sekunden", "ar": "تحقيق في أقل من 90 ثانية"
                },
                "HOME_COMPARE_AFTER_4": {
                    "en": "< 3 minute containment",
                    "ja": "封じ込め完了まで3分以内",
                    "es": "Contención en menos de 3 minutos",
                    "fr": "Confinement en moins de 3 minutes",
                    "zh": "不到3分钟完成遏制",
                    "zh-TW": "不到3分鐘完成封鎖控制",
                    "de": "Eindämmung in unter 3 Minuten", "ar": "احتواء في أقل من 3 دقائق"
                },
                "HOME_COMPARE_AFTER_5": {
                    "en": "Licence or on-demand flexible billing",
                    "ja": "選べるライセンス・従量課金、柔軟な料金体系",
                    "es": "Licencia o facturación flexible bajo demanda",
                    "fr": "Licence ou facturation flexible à la demande",
                    "zh": "许可证或按需灵活计费",
                    "zh-TW": "授權制或按需計費，彈性選擇",
                    "de": "Lizenz oder flexible On-Demand-Abrechnung", "ar": "ترخيص أو فوترة مرنة عند الطلب"
                },
                "HOME_COMPARE_AFTER_6": {
                    "en": "1 operator",
                    "ja": "たった1名の担当者",
                    "es": "1 operador",
                    "fr": "1 opérateur",
                    "zh": "1名操作员",
                    "zh-TW": "僅需1名管理人員",
                    "de": "1 Operator", "ar": "مشغّل واحد"
                },
                "HOME_SIMPLE_BADGE": {
                    "en": "ZERO COMPLEXITY",
                    "ja": "複雑性ゼロ",
                    "es": "POR QUÉ IMPORTA",
                    "fr": "POURQUOI C'EST IMPORTANT",
                    "zh": "为何重要",
                    "zh-TW": "化繁為簡",
                    "de": "WARUM DAS WICHTIG IST", "ar": "صفر تعقيد"
                },
                "HOME_SIMPLE_TITLE": {
                    "en": "Simplicity Is Security",
                    "ja": "「シンプルさ」こそが、最強のセキュリティ",
                    "es": "La Simplicidad Es Seguridad",
                    "fr": "La Simplicité, C'est la Sécurité",
                    "zh": "简洁即安全",
                    "zh-TW": "簡單就是最好的防禦",
                    "de": "Einfachheit ist Sicherheit", "ar": "البساطة هي الأمان"
                },
                "HOME_SIMPLE_LEAD": {
                    "en": "The average enterprise relies on 7+ security and management tools from different vendors. That complexity has a real cost — not just in licensing and operations, but in risk. Every vendor you remove is an attack surface closed.",
                    "ja": "一般的な企業では、7つ以上の異なるベンダーによるセキュリティ・管理ツールが混在しています。しかし、その「複雑さ」には実質的なコストが伴います。それは単なるライセンス料や運用負荷にとどまらず、「リスク」という形でも跳ね返ってきます。ベンダーを一つ減らすことは、単なるコスト削減ではありません。それは「攻撃対象領域（アタックサーフェス）を一つ閉じる」ことに他ならないのです。",
                    "es": "La empresa promedio depende de más de 7 herramientas de seguridad y gestión de diferentes proveedores. Esa complejidad tiene un costo real — no solo en licencias y operaciones, sino en riesgo. Cada proveedor que eliminas es una superficie de ataque cerrada.",
                    "fr": "L'entreprise moyenne s'appuie sur plus de 7 outils de sécurité et de gestion de différents fournisseurs. Cette complexité a un coût réel — pas seulement en licences et opérations, mais en risque. Chaque fournisseur supprimé est une surface d'attaque fermée.",
                    "zh": "普通企业依赖来自不同供应商的7+安全和管理工具。这种复杂性有真实的成本——不仅是许可和运营方面，还有风险方面。每移除一个供应商就关闭一个攻击面。",
                    "zh-TW": "一般企業平均使用7家以上供應商的資安與管理工具。這種複雜度帶來的不只是授權與維運成本，更是實質的安全風險。每減少一家供應商，就少一個攻擊入口。",
                    "de": "Das durchschnittliche Unternehmen verlässt sich auf 7+ Sicherheits- und Management-Tools verschiedener Anbieter. Diese Komplexität hat reale Kosten — nicht nur bei Lizenzen und Betrieb, sondern beim Risiko. Jeder entfernte Anbieter schließt eine Angriffsfläche.", "ar": "المؤسسة المتوسطة تعتمد على 7+ أدوات أمن وإدارة من موردين مختلفين. هذا التعقيد له تكلفة حقيقية — ليس فقط في التراخيص والعمليات، بل في المخاطر. كل مورد تزيله هو سطح هجوم مغلق."
                },
                "HOME_SIMPLE_POINT_1": {
                    "en": "Fewer tools means fewer attack surfaces and fewer things that break at 2am",
                    "ja": "ツールの削減は、攻撃対象領域（アタックサーフェス）の縮小だけでなく、深夜に及ぶシステム障害への対応を減らすことにも繋がります",
                    "es": "Menos herramientas significa menos superficies de ataque y menos cosas que fallan a las 2am",
                    "fr": "Moins d'outils signifie moins de surfaces d'attaque et moins de pannes à 2h du matin",
                    "zh": "更少的工具意味着更少的攻击面和凌晨2点的故障",
                    "zh-TW": "工具越少，攻擊面越小，半夜被叫起來處理的機會也越少",
                    "de": "Weniger Tools bedeutet weniger Angriffsflächen und weniger Ausfälle um 2 Uhr nachts", "ar": "أدوات أقل تعني أسطح هجوم أقل وأشياء أقل تتعطل في الساعة الثانية صباحاً"
                },
                "HOME_SIMPLE_POINT_2": {
                    "en": "Each vendor removed eliminates support contracts, integration maintenance, and specialist staff",
                    "ja": "ベンダーを一つ減らすたびに、保守契約やシステム連携の維持、そして専門スタッフの確保といった負担が解消されます",
                    "es": "Cada proveedor eliminado elimina contratos de soporte, mantenimiento de integración y personal especializado",
                    "fr": "Chaque fournisseur supprimé élimine les contrats de support, la maintenance d'intégration et le personnel spécialisé",
                    "zh": "每移除一个供应商就消除了支持合同、集成维护和专业人员",
                    "zh-TW": "每減少一家供應商，就省下維護合約、系統整合與專業人力的成本",
                    "de": "Jeder entfernte Anbieter eliminiert Support-Verträge, Integrationswartung und Fachpersonal", "ar": "كل مورد يُزال يلغي عقود الدعم وصيانة التكامل والموظفين المتخصصين"
                },
                "HOME_SIMPLE_POINT_3": {
                    "en": "The answer isn't more tools — it's fewer dependencies and AI that acts before a human SOC can triage",
                    "ja": "解決策は、ツールの増設ではありません。依存を最小限に抑え、人間のSOCが優先順位を判断するよりも前に、AIが自律的に対処することにあります",
                    "es": "La respuesta no son más herramientas — son menos dependencias e IA que actúa antes de que un SOC humano pueda triagear",
                    "fr": "La réponse n'est pas plus d'outils — c'est moins de dépendances et une IA qui agit avant qu'un SOC humain puisse trier",
                    "zh": "答案不是更多工具——而是更少的依赖和在人类SOC分诊之前就能行动的AI",
                    "zh-TW": "解答不是更多工具，而是減少依賴，讓AI在SOC人員還在判斷時就已經採取行動",
                    "de": "Die Antwort sind nicht mehr Tools — sondern weniger Abhängigkeiten und KI, die handelt, bevor ein menschliches SOC triagieren kann", "ar": "الإجابة ليست المزيد من الأدوات — إنها اعتماد أقل وذكاء اصطناعي يتصرف قبل أن يتمكن SOC بشري من الفرز"
                },
                "HOME_CAP_BADGE": {
                    "en": "PLATFORM CAPABILITIES",
                    "ja": "プラットフォーム機能",
                    "es": "CAPACIDADES DE LA PLATAFORMA",
                    "fr": "CAPACITÉS DE LA PLATEFORME",
                    "zh": "平台能力",
                    "zh-TW": "平台功能",
                    "de": "PLATTFORM-FÄHIGKEITEN", "ar": "قدرات المنصة"
                },
                "HOME_CAP_TITLE": {
                    "en": "What Enbarr Delivers",
                    "ja": "Enbarrがもたらす価値",
                    "es": "Lo Que Enbarr Ofrece",
                    "fr": "Ce Qu'Enbarr Offre",
                    "zh": "Enbarr提供什么",
                    "zh-TW": "Enbarr 能為您做什麼",
                    "de": "Was Enbarr Liefert", "ar": "ما يقدمه Enbarr"
                },
                "HOME_CAP_SUBTITLE": {
                    "en": "One platform that replaces an entire vendor stack, giving your team leverage instead of complexity.",
                    "ja": "複数ベンダーのツールを1つに統合。複雑さの代わりに、チームの力を最大化する基盤を提供します。",
                    "es": "Una plataforma que reemplaza toda la pila de proveedores, dando a tu equipo apalancamiento en lugar de complejidad.",
                    "fr": "Une plateforme qui remplace toute la pile de fournisseurs, donnant à votre équipe un levier au lieu de la complexité.",
                    "zh": "一个替换整个供应商堆栈的平台，为团队提供杠杆而非复杂性。",
                    "zh-TW": "一個取代多家供應商的平台，讓團隊事半功倍，而非疲於奔命。",
                    "de": "Eine Plattform, die den gesamten Anbieter-Stack ersetzt und Ihrem Team Hebelwirkung statt Komplexität bietet.", "ar": "منصة واحدة تحل محل مجموعة الموردين بأكملها، مانحةً فريقك القوة بدلاً من التعقيد."
                },
                "HOME_CAP_DETECT_TITLE": {
                    "en": "Behavioral Detection",
                    "ja": "ふるまい検知",
                    "es": "Detección Conductual",
                    "fr": "Détection Comportementale",
                    "zh": "行为检测",
                    "zh-TW": "行為檢測",
                    "de": "Verhaltensbasierte Erkennung", "ar": "الكشف السلوكي"
                },
                "HOME_CAP_DETECT_DESC": {
                    "en": "Signatureless analysis at the OS kernel level. No cloud round-trips needed — works fully offline.",
                    "ja": "OSカーネルレベルでのシグネチャレス解析を実行。クラウドへの照会（ラウンドトリップ）を必要とせず、完全オフラインであらゆる環境を保護します。",
                    "es": "Análisis sin firmas a nivel del kernel del SO. Sin viajes de ida y vuelta a la nube — funciona completamente offline.",
                    "fr": "Analyse sans signatures au niveau du noyau de l'OS. Aucun aller-retour cloud nécessaire — fonctionne entièrement hors ligne.",
                    "zh": "操作系统内核级别的无签名分析。无需云端往返——完全离线运行。",
                    "zh-TW": "在作業系統核心層進行行為分析，無需特徵碼。不必連雲端——完全離線運作。",
                    "de": "Signaturlose Analyse auf OS-Kernel-Ebene. Keine Cloud-Roundtrips nötig — funktioniert vollständig offline.", "ar": "تحليل بدون توقيعات على مستوى نواة نظام التشغيل. لا حاجة لرحلات سحابية — يعمل بالكامل بدون اتصال."
                },
                "HOME_CAP_AI_TITLE": {
                    "en": "Intelligent AI Engine",
                    "ja": "インテリジェントAIエンジン",
                    "es": "Motor de IA Inteligente",
                    "fr": "Moteur IA Intelligent",
                    "zh": "智能AI引擎",
                    "zh-TW": "智慧AI引擎",
                    "de": "Intelligente KI-Engine", "ar": "محرك الذكاء الاصطناعي الذكي"
                },
                "HOME_CAP_AI_DESC": {
                    "en": "Investigates, correlates, and explains threats in plain language. Makes graduated decisions autonomously.",
                    "ja": "脅威の背後にある関連性を分析し、自然な言葉で状況を説明。脅威のレベルに合わせ、最適な対処を自律的に判断・実行します。",
                    "es": "Investiga, correlaciona y explica amenazas en lenguaje simple. Toma decisiones graduadas de forma autónoma.",
                    "fr": "Enquête, corrèle et explique les menaces en langage clair. Prend des décisions graduées de manière autonome.",
                    "zh": "用通俗语言调查、关联和解释威胁。自主做出渐进式决策。",
                    "zh-TW": "自動調查、關聯分析威脅，並用淺顯易懂的語言說明。AI自主進行漸進式判斷。",
                    "de": "Untersucht, korreliert und erklärt Bedrohungen in einfacher Sprache. Trifft abgestufte Entscheidungen autonom.", "ar": "يحقق ويربط ويشرح التهديدات بلغة بسيطة. يتخذ قرارات متدرجة بشكل ذاتي."
                },
                "HOME_CAP_NETWORK_TITLE": {
                    "en": "Distributed Network",
                    "ja": "分散ネットワーク",
                    "es": "Red Distribuida",
                    "fr": "Réseau Distribué",
                    "zh": "分布式网络",
                    "zh-TW": "分散式網路",
                    "de": "Verteiltes Netzwerk", "ar": "شبكة موزّعة"
                },
                "HOME_CAP_NETWORK_DESC": {
                    "en": "Nodes gossip and coordinate threat signals, making autonomous collective decisions. No central server, no single point of failure.",
                    "ja": "各ノードが相互に通信し、脅威の予兆を共有。組織全体で一つの知能のように、自律的な判断を下します。中央サーバーを介さないため、単一障害点（システムの急所）が存在しません。",
                    "es": "Los nodos intercambian y coordinan señales de amenazas, tomando decisiones colectivas autónomas. Sin servidor central, sin punto único de fallo.",
                    "fr": "Les nœuds échangent et coordonnent les signaux de menaces, prenant des décisions collectives autonomes. Pas de serveur central, pas de point de défaillance unique.",
                    "zh": "节点通过gossip协议协调威胁信号，进行自主集体决策。无中央服务器，无单点故障。",
                    "zh-TW": "各端點自動共享威脅情報並協同決策。不需要中央伺服器，沒有單點故障風險。",
                    "de": "Knoten tauschen Bedrohungssignale aus und koordinieren sich, treffen autonome kollektive Entscheidungen. Kein zentraler Server, kein Single Point of Failure.", "ar": "العُقد تتبادل وتنسق إشارات التهديد، وتتخذ قرارات جماعية ذاتية. لا خادم مركزي، لا نقطة فشل فردية."
                },
                "HOME_CAP_STACK_TITLE": {
                    "en": "Replaces Your Stack",
                    "ja": "セキュリティ環境の統合",
                    "es": "Reemplaza Tu Stack",
                    "fr": "Remplace Votre Stack",
                    "zh": "替换您的技术栈",
                    "zh-TW": "取代現有工具組合",
                    "de": "Ersetzt Ihren Stack", "ar": "يحل محل مجموعتك التقنية"
                },
                "HOME_CAP_STACK_DESC": {
                    "en": "One platform replaces EDR, SIEM, RMM, and UEM. Every vendor removed is an attack surface closed.",
                    "ja": "EDR、SIEM、RMM、UEMの機能を一つのプラットフォームへ。管理するツール（ベンダー）を絞り込むことは、攻撃の隙（アタックサーフェス）を最小限に抑えることにつながります。",
                    "es": "Una plataforma reemplaza EDR, SIEM, RMM y UEM. Cada proveedor eliminado es una superficie de ataque cerrada.",
                    "fr": "Une plateforme remplace EDR, SIEM, RMM et UEM. Chaque fournisseur supprimé est une surface d'attaque fermée.",
                    "zh": "一个平台替换EDR、SIEM、RMM和UEM。每移除一个供应商就关闭一个攻击面。",
                    "zh-TW": "一個平台整合 EDR、SIEM、RMM、UEM。每少一家供應商，就少一個攻擊入口。",
                    "de": "Eine Plattform ersetzt EDR, SIEM, RMM und UEM. Jeder entfernte Anbieter schließt eine Angriffsfläche.", "ar": "منصة واحدة تحل محل EDR وSIEM وRMM وUEM. كل مورد يُزال هو سطح هجوم مغلق."
                },
                "HOME_CAP_SOVEREIGNTY_TITLE": {
                    "en": "Complete Data Sovereignty",
                    "ja": "完全なデータ主権の維持",
                    "es": "Soberanía Total de Datos",
                    "fr": "Souveraineté Totale des Données",
                    "zh": "完全数据主权",
                    "zh-TW": "完全資料主權",
                    "de": "Vollständige Datensouveränität", "ar": "سيادة بيانات كاملة"
                },
                "HOME_CAP_SOVEREIGNTY_DESC": {
                    "en": "Your data stays yours. Deploy on-premise or in the cloud — zero-knowledge architecture with no external callbacks.",
                    "ja": "お客様のデータは、常にお客様のものです。オンプレミス、クラウドのいずれでも展開可能。秘密情報を外部に持ち出さない、強固な機密保持設計です。",
                    "es": "Tus datos son tuyos. Despliega on-premise o en la nube — arquitectura de conocimiento cero sin callbacks externos.",
                    "fr": "Vos données restent les vôtres. Déployez sur site ou dans le cloud — architecture à connaissance zéro sans rappels externes.",
                    "zh": "您的数据属于您。本地或云端部署——零知识架构，无外部回调。",
                    "zh-TW": "資料永遠屬於您。可選擇本地或雲端部署——零外部連線的安全架構。",
                    "de": "Ihre Daten bleiben Ihre. Bereitstellung vor Ort oder in der Cloud — Zero-Knowledge-Architektur ohne externe Callbacks.", "ar": "بياناتك تبقى ملكك. انشر محلياً أو في السحابة — هندسة معرفة صفرية بدون مكالمات خارجية."
                },
                "HOME_CAP_RESPONSE_TITLE": {
                    "en": "Instant Response",
                    "ja": "リアルタイムな自動防衛",
                    "es": "Respuesta Instantánea",
                    "fr": "Réponse Instantanée",
                    "zh": "即时响应",
                    "zh-TW": "即時響應",
                    "de": "Sofortige Reaktion", "ar": "استجابة فورية"
                },
                "HOME_CAP_RESPONSE_DESC": {
                    "en": "Detect in under 10 seconds, investigate in under 90 seconds, contain in under 3 minutes. No SOC queue, no human bottleneck.",
                    "ja": "10秒で検知、90秒で分析、3分で封じ込めを完了。24時間365日、人間の判断を待つことなくAIが自律的に対処するため、被害の拡大を最小限に抑えます。",
                    "es": "Detecta en menos de 10 segundos, investiga en menos de 90 segundos, contiene en menos de 3 minutos. Sin cola SOC, sin cuello de botella humano.",
                    "fr": "Détection en moins de 10 secondes, investigation en moins de 90 secondes, confinement en moins de 3 minutes. Pas de file d'attente SOC, pas de goulot d'étranglement humain.",
                    "zh": "10秒内检测、90秒内调查、3分钟内遏制。无SOC队列，无人工瓶颈。",
                    "zh-TW": "10秒內偵測、90秒內調查、3分鐘內封鎖。無需SOC排隊等候，沒有人力瓶頸。",
                    "de": "Erkennung in unter 10 Sekunden, Untersuchung in unter 90 Sekunden, Eindämmung in unter 3 Minuten. Keine SOC-Warteschlange, kein menschlicher Engpass.", "ar": "كشف في أقل من 10 ثوانٍ، تحقيق في أقل من 90 ثانية، احتواء في أقل من 3 دقائق. لا طابور SOC، لا عنق زجاجة بشري."
                },
                "HOME_DIFF_BADGE": {
                    "en": "DIFFERENTIATION",
                    "ja": "比較",
                    "es": "DIFERENCIACIÓN",
                    "fr": "DIFFÉRENCIATION",
                    "zh": "差异化",
                    "zh-TW": "比較",
                    "de": "DIFFERENZIERUNG", "ar": "التمايز"
                },
                "HOME_DIFF_TITLE": {
                    "en": "Traditional EDR vs. Enbarr",
                    "ja": "従来のEDR vs. Enbarr",
                    "es": "EDR Tradicional vs. Enbarr",
                    "fr": "EDR Traditionnel vs. Enbarr",
                    "zh": "传统EDR vs. Enbarr",
                    "zh-TW": "傳統EDR vs. Enbarr",
                    "de": "Traditionelles EDR vs. Enbarr", "ar": "EDR التقليدي مقابل Enbarr"
                },
                "HOME_DIFF_TRADITIONAL": {
                    "en": "Traditional EDR",
                    "ja": "従来のEDR",
                    "es": "EDR Tradicional",
                    "fr": "EDR Traditionnel",
                    "zh": "传统EDR",
                    "zh-TW": "傳統EDR",
                    "de": "Traditionelles EDR", "ar": "EDR التقليدي"
                },
                "HOME_DIFF_ENBARR": {
                    "en": "Enbarr",
                    "ja": "Enbarr",
                    "es": "Enbarr",
                    "fr": "Enbarr",
                    "zh": "Enbarr",
                    "zh-TW": "Enbarr",
                    "de": "Enbarr", "ar": "Enbarr"
                },
                "HOME_DIFF_ROW_1_FEATURE": {
                    "en": "Detection",
                    "ja": "検出",
                    "es": "Detección",
                    "fr": "Détection",
                    "zh": "检测",
                    "zh-TW": "檢測",
                    "de": "Erkennung", "ar": "الكشف"
                },
                "HOME_DIFF_ROW_1_TRAD": {
                    "en": "Signatures + cloud ML",
                    "ja": "定義ファイル + クラウドML",
                    "es": "Firmas + ML en la nube",
                    "fr": "Signatures + ML cloud",
                    "zh": "签名 + 云ML",
                    "zh-TW": "特徵碼 + 雲ML",
                    "de": "Signaturen + Cloud-ML", "ar": "توقيعات + تعلم آلي سحابي"
                },
                "HOME_DIFF_ROW_1_ENBARR": {
                    "en": "Behavioral kernel analysis. Zero signatures",
                    "ja": "振る舞い分析。定義ファイル不要",
                    "es": "Análisis conductual del kernel. Cero firmas",
                    "fr": "Analyse comportementale du noyau. Zéro signatures",
                    "zh": "行为内核分析。零签名",
                    "zh-TW": "行為分析偵測，不需特徵碼",
                    "de": "Verhaltens-Kernel-Analyse. Null Signaturen", "ar": "تحليل سلوكي للنواة. صفر توقيعات"
                },
                "HOME_DIFF_ROW_2_FEATURE": {
                    "en": "Cloud",
                    "ja": "クラウド",
                    "es": "Nube",
                    "fr": "Cloud",
                    "zh": "云",
                    "zh-TW": "雲",
                    "de": "Cloud", "ar": "السحابة"
                },
                "HOME_DIFF_ROW_2_TRAD": {
                    "en": "Cloud round-trip required. Offline = blind",
                    "ja": "クラウド接続が必須。オフライン時は無防備",
                    "es": "Viaje a la nube requerido. Offline = ciego",
                    "fr": "Aller-retour cloud requis. Hors ligne = aveugle",
                    "zh": "需要云往返。离线=盲目",
                    "zh-TW": "必須連線雲端。離線等於失去防護",
                    "de": "Cloud-Roundtrip erforderlich. Offline = blind", "ar": "رحلة سحابية مطلوبة. بدون اتصال = أعمى"
                },
                "HOME_DIFF_ROW_2_ENBARR": {
                    "en": "Fully autonomous offline. Zero callbacks",
                    "ja": "完全オフライン動作。外部通信ゼロ",
                    "es": "Totalmente autónomo offline. Cero callbacks",
                    "fr": "Entièrement autonome hors ligne. Zéro rappels",
                    "zh": "完全自主离线。零回调",
                    "zh-TW": "完全離線自主運作。零外部連線",
                    "de": "Vollständig autonom offline. Null Callbacks", "ar": "ذاتي بالكامل بدون اتصال. صفر مكالمات خارجية"
                },
                "HOME_DIFF_ROW_3_FEATURE": {
                    "en": "Response",
                    "ja": "対応",
                    "es": "Respuesta",
                    "fr": "Réponse",
                    "zh": "响应",
                    "zh-TW": "響應",
                    "de": "Reaktion", "ar": "الاستجابة"
                },
                "HOME_DIFF_ROW_3_TRAD": {
                    "en": "Playbook scripts. Fixed if/then rules",
                    "ja": "定型スクリプト。固定ルールに依存",
                    "es": "Scripts de playbook. Reglas fijas if/then",
                    "fr": "Scripts de playbook. Règles if/then fixes",
                    "zh": "剧本脚本。固定的if/then规则",
                    "zh-TW": "固定腳本，制式化的規則判斷",
                    "de": "Playbook-Skripte. Feste if/then-Regeln", "ar": "نصوص جاهزة. قواعد if/then ثابتة"
                },
                "HOME_DIFF_ROW_3_ENBARR": {
                    "en": "Agentic AI. Plans, reflects, and acts",
                    "ja": "自律型AI。計画・検証・実行",
                    "es": "IA Agéntica. Planifica, reflexiona y actúa",
                    "fr": "IA Agentique. Planifie, réfléchit et agit",
                    "zh": "智能体AI。规划、反思、行动",
                    "zh-TW": "自主式AI——規劃、驗證、行動",
                    "de": "Agentische KI. Plant, reflektiert und handelt", "ar": "ذكاء اصطناعي وكيل. يخطط ويتأمل ويتصرف"
                },
                "HOME_DIFF_ROW_4_FEATURE": {
                    "en": "Data",
                    "ja": "データ",
                    "es": "Datos",
                    "fr": "Données",
                    "zh": "数据",
                    "zh-TW": "資料",
                    "de": "Daten", "ar": "البيانات"
                },
                "HOME_DIFF_ROW_4_TRAD": {
                    "en": "Telemetry shipped to vendor cloud",
                    "ja": "監視データがベンダーのクラウドへ送信",
                    "es": "Telemetría enviada a la nube del proveedor",
                    "fr": "Télémétrie envoyée au cloud du fournisseur",
                    "zh": "遥测数据发送到供应商云",
                    "zh-TW": "監控資料傳送至供應商的雲端",
                    "de": "Telemetrie an Anbieter-Cloud gesendet", "ar": "القياس عن بُعد يُرسل لسحابة المورد"
                },
                "HOME_DIFF_ROW_4_ENBARR": {
                    "en": "Zero-knowledge. On-prem option",
                    "ja": "データ外部送信なし。自社環境設置可",
                    "es": "Conocimiento cero. Opción on-premise",
                    "fr": "Connaissance zéro. Option sur site",
                    "zh": "零知识。本地选项",
                    "zh-TW": "零外洩設計，可本地部署",
                    "de": "Zero-Knowledge. On-Premise-Option", "ar": "معرفة صفرية. خيار محلي"
                },
                "HOME_DIFF_ROW_5_FEATURE": {
                    "en": "Vendors",
                    "ja": "ベンダー",
                    "es": "Proveedores",
                    "fr": "Fournisseurs",
                    "zh": "供应商",
                    "zh-TW": "供應商",
                    "de": "Anbieter", "ar": "الموردون"
                },
                "HOME_DIFF_ROW_5_TRAD": {
                    "en": "4-7 products, 4-7 attack surfaces",
                    "ja": "4〜7製品、4〜7つの攻撃リスク",
                    "es": "4-7 productos, 4-7 superficies de ataque",
                    "fr": "4-7 produits, 4-7 surfaces d'attaque",
                    "zh": "4-7个产品，4-7个攻击面",
                    "zh-TW": "4-7個產品，4-7個攻擊面",
                    "de": "4-7 Produkte, 4-7 Angriffsflächen", "ar": "4-7 منتجات، 4-7 أسطح هجوم"
                },
                "HOME_DIFF_ROW_5_ENBARR": {
                    "en": "Single platform. Surface closed",
                    "ja": "1つの基盤。攻撃の入口を封鎖",
                    "es": "Plataforma única. Superficie cerrada",
                    "fr": "Plateforme unique. Surface fermée",
                    "zh": "单一平台。攻击面关闭",
                    "zh-TW": "單一平台，封閉攻擊面",
                    "de": "Eine Plattform. Angriffsfläche geschlossen", "ar": "منصة واحدة. سطح مغلق"
                },
                "HOME_DIFF_ROW_6_FEATURE": {
                    "en": "AI",
                    "ja": "AI",
                    "es": "IA",
                    "fr": "IA",
                    "zh": "AI",
                    "zh-TW": "AI",
                    "de": "KI", "ar": "الذكاء الاصطناعي"
                },
                "HOME_DIFF_ROW_6_TRAD": {
                    "en": "Pattern matching. Static models",
                    "ja": "パターン照合。固定モデル",
                    "es": "Coincidencia de patrones. Modelos estáticos",
                    "fr": "Correspondance de motifs. Modèles statiques",
                    "zh": "模式匹配。静态模型",
                    "zh-TW": "模式匹配。靜態模型",
                    "de": "Mustererkennung. Statische Modelle", "ar": "مطابقة أنماط. نماذج ثابتة"
                },
                "HOME_DIFF_ROW_6_ENBARR": {
                    "en": "Parallel investigation. Bring your own AI",
                    "ja": "並列調査。お手持ちのAIも利用可能",
                    "es": "Investigación paralela. Trae tu propia IA",
                    "fr": "Investigation parallèle. Apportez votre propre IA",
                    "zh": "并行调查。自带AI",
                    "zh-TW": "平行調查，可自帶AI模型",
                    "de": "Parallele Untersuchung. Eigene KI mitbringen", "ar": "تحقيق متوازٍ. أحضر ذكاءك الاصطناعي"
                },
                "HOME_DIFF_ROW_7_FEATURE": {
                    "en": "Deploy",
                    "ja": "導入方式",
                    "es": "Despliegue",
                    "fr": "Déploiement",
                    "zh": "部署",
                    "zh-TW": "部署",
                    "de": "Bereitstellung", "ar": "النشر"
                },
                "HOME_DIFF_ROW_7_TRAD": {
                    "en": "Agent + cloud console + VPN",
                    "ja": "エージェント + クラウドコンソール + VPN",
                    "es": "Agente + consola cloud + VPN",
                    "fr": "Agent + console cloud + VPN",
                    "zh": "代理 + 云控制台 + VPN",
                    "zh-TW": "代理程式 + 雲端主控台 + VPN",
                    "de": "Agent + Cloud-Konsole + VPN", "ar": "وكيل + لوحة تحكم سحابية + VPN"
                },
                "HOME_DIFF_ROW_7_ENBARR": {
                    "en": "Encrypted P2P mesh. Air-gapped capable",
                    "ja": "暗号化P2P接続。閉域ネットワーク対応",
                    "es": "Malla P2P cifrada. Capaz de aislamiento",
                    "fr": "Maillage P2P chiffré. Compatible air-gap",
                    "zh": "加密P2P网格。支持气隙部署",
                    "zh-TW": "加密P2P網路，支援離線環境部署",
                    "de": "Verschlüsseltes P2P-Mesh. Air-Gap-fähig", "ar": "شبكة P2P مشفرة. قابل للعزل الهوائي"
                },
                "HOME_DEPLOY_BADGE": {
                    "en": "INFRASTRUCTURE",
                    "ja": "導入環境",
                    "es": "INFRAESTRUCTURA",
                    "fr": "INFRASTRUCTURE",
                    "zh": "基础设施",
                    "zh-TW": "基礎設施",
                    "de": "INFRASTRUKTUR", "ar": "البنية التحتية"
                },
                "HOME_DEPLOY_TITLE": {
                    "en": "Deployment & Sovereignty",
                    "ja": "柔軟な導入形態とデータ主権",
                    "es": "Despliegue y Soberanía",
                    "fr": "Déploiement et Souveraineté",
                    "zh": "部署与主权",
                    "zh-TW": "部署與主權",
                    "de": "Bereitstellung & Souveränität", "ar": "النشر والسيادة"
                },
                "HOME_DEPLOY_SUBTITLE": {
                    "en": "Your infrastructure, your rules. Deploy in the way that fits your compliance requirements.",
                    "ja": "お客様の既存インフラを活かし、自社基準に則った運用を実現。厳しいコンプライアンス基準が求められる環境でも、柔軟に適応・導入が可能です。",
                    "es": "Tu infraestructura, tus reglas. Despliega de la manera que se adapte a tus requisitos de cumplimiento.",
                    "fr": "Votre infrastructure, vos règles. Déployez de la manière qui correspond à vos exigences de conformité.",
                    "zh": "您的基础设施，您的规则。以符合合规要求的方式部署。",
                    "zh-TW": "您的基礎架構，您的規則。依照合規要求自由選擇部署方式。",
                    "de": "Ihre Infrastruktur, Ihre Regeln. Bereitstellung nach Ihren Compliance-Anforderungen.", "ar": "بنيتك التحتية، قواعدك. انشر بالطريقة التي تناسب متطلبات الامتثال الخاصة بك."
                },
                "HOME_DEPLOY_CLOUD_TITLE": {
                    "en": "Cloud Managed",
                    "ja": "クラウド管理",
                    "es": "Gestionado en la Nube",
                    "fr": "Géré dans le Cloud",
                    "zh": "云托管",
                    "zh-TW": "雲託管",
                    "de": "Cloud-Verwaltet", "ar": "مُدار سحابياً"
                },
                "HOME_DEPLOY_CLOUD_DESC": {
                    "en": "The fastest path to autonomous security. Zero infrastructure to provision, automatic updates. Fully operational in hours.",
                    "ja": "自律型セキュリティへの最短ルート。インフラ構築の手間は一切不要、アップデートも完全自動。導入からわずか数時間で運用を開始できます。",
                    "es": "El camino más rápido hacia la seguridad autónoma. Cero infraestructura que aprovisionar, actualizaciones automáticas. Totalmente operativo en horas.",
                    "fr": "Le chemin le plus rapide vers la sécurité autonome. Zéro infrastructure à provisionner, mises à jour automatiques. Pleinement opérationnel en quelques heures.",
                    "zh": "通往自主安全的最快路径。零基础设施配置，自动更新。数小时内完全运行。",
                    "zh-TW": "最快速的導入路徑。免建基礎架構，自動更新，數小時即可上線運作。",
                    "de": "Der schnellste Weg zu autonomer Sicherheit. Null Infrastruktur bereitzustellen, automatische Updates. In Stunden voll betriebsbereit.", "ar": "أسرع طريق للأمان الذاتي. صفر بنية تحتية للتجهيز، تحديثات تلقائية. يعمل بالكامل في ساعات."
                },
                "HOME_DEPLOY_ONPREM_TITLE": {
                    "en": "On-Premise / Air-Gapped",
                    "ja": "オンプレミス・物理隔離環境への対応",
                    "es": "On-Premise / Air-Gapped",
                    "fr": "Sur Site / Air-Gap",
                    "zh": "本地部署 / 气隙隔离",
                    "zh-TW": "本地部署 / 離線隔離",
                    "de": "On-Premise / Air-Gapped", "ar": "محلي / معزول هوائياً"
                },
                "HOME_DEPLOY_ONPREM_DESC": {
                    "en": "Complete data sovereignty. Host your own inference, manage your own enrollment. Every byte stays behind your perimeter.",
                    "ja": "外部と遮断された環境でも、高度な自律型防御を実現。AIによる推論処理も、デバイス登録の管理も、すべて自社環境内で完結。1バイトのデータたりとも、組織の境界線の外へ出ることはありません。",
                    "es": "Soberanía total de datos. Aloja tu propia inferencia, gestiona tu propia inscripción. Cada byte permanece dentro de tu perímetro.",
                    "fr": "Souveraineté totale des données. Hébergez votre propre inférence, gérez votre propre enrôlement. Chaque octet reste derrière votre périmètre.",
                    "zh": "完全数据主权。托管自己的推理，管理自己的注册。每个字节都留在您的边界内。",
                    "zh-TW": "資料完全由您掌控。自行運行AI推論與裝置管理，所有資料都留在您的環境內。",
                    "de": "Vollständige Datensouveränität. Hosten Sie Ihre eigene Inferenz, verwalten Sie Ihre eigene Registrierung. Jedes Byte bleibt innerhalb Ihres Perimeters.", "ar": "سيادة بيانات كاملة. استضف استدلالك الخاص، أدر تسجيلك الخاص. كل بايت يبقى خلف محيطك."
                },
                "HOME_DEPLOY_HYBRID_TITLE": {
                    "en": "Hybrid",
                    "ja": "柔軟なハイブリッド運用",
                    "es": "Híbrido",
                    "fr": "Hybride",
                    "zh": "混合",
                    "zh-TW": "混合",
                    "de": "Hybrid", "ar": "هجين"
                },
                "HOME_DEPLOY_HYBRID_DESC": {
                    "en": "Mix cloud governance with on-premise collectors. Configure the architecture that fits your compliance requirements.",
                    "ja": "クラウドによる一元管理と、オンプレミスでのデータ収集を自在に組み合わせ。組織独自のコンプライアンス要件に合わせ、最適なインフラ構成を柔軟にカスタマイズ可能です。",
                    "es": "Combina gobernanza en la nube con recopiladores on-premise. Configura la arquitectura que se adapte a tus requisitos de cumplimiento.",
                    "fr": "Mélangez gouvernance cloud et collecteurs sur site. Configurez l'architecture qui correspond à vos exigences de conformité.",
                    "zh": "将云治理与本地收集器混合。配置符合合规要求的架构。",
                    "zh-TW": "將雲治理與本地收集器混合。配置符合合規要求的架構。",
                    "de": "Mischen Sie Cloud-Governance mit On-Premise-Kollektoren. Konfigurieren Sie die Architektur nach Ihren Compliance-Anforderungen.", "ar": "اجمع بين حوكمة السحابة وجامعي البيانات المحليين. هيّئ البنية التي تناسب متطلبات الامتثال الخاصة بك."
                },
                "HOME_CTA_TITLE": {
                    "en": "The Future of SecOps Is Autonomous.",
                    "ja": "セキュリティ運用の未来は、自律型AIにあります。",
                    "es": "El Futuro de SecOps Es Autónomo.",
                    "fr": "L'Avenir du SecOps Est Autonome.",
                    "zh": "安全运营的未来是自主的。",
                    "zh-TW": "資安維運的未來，是自主式AI。",
                    "de": "Die Zukunft von SecOps ist autonom.", "ar": "مستقبل SecOps ذاتي."
                },
                "HOME_CTA_QUOTE": {
                    "en": "Think of Enbarr as a living security system that continuously observes your entire digital ecosystem, reasons about potential threats, and takes intelligent action to protect your organization.",
                    "ja": "Enbarrは、お客様のデジタル環境全体を常に見守り、脅威の兆候を読み取り、組織を守るために最適な行動をとる「生きたセキュリティシステム」です。",
                    "es": "Piensa en Enbarr como un sistema de seguridad vivo que observa continuamente todo tu ecosistema digital, razona sobre amenazas potenciales y toma acciones inteligentes para proteger tu organización.",
                    "fr": "Pensez à Enbarr comme un système de sécurité vivant qui observe en continu tout votre écosystème numérique, raisonne sur les menaces potentielles et prend des actions intelligentes pour protéger votre organisation.",
                    "zh": "将Enbarr视为一个持续观察整个数字生态系统、推理潜在威胁并采取智能行动保护组织的活体安全系统。",
                    "zh-TW": "Enbarr 是一套持續監控您整個數位環境、智慧判斷威脅並主動採取行動的活體資安系統。",
                    "de": "Denken Sie an Enbarr als ein lebendes Sicherheitssystem, das Ihr gesamtes digitales Ökosystem kontinuierlich beobachtet, über potenzielle Bedrohungen nachdenkt und intelligente Maßnahmen zum Schutz Ihrer Organisation ergreift.", "ar": "فكّر في Enbarr كنظام أمان حي يراقب باستمرار نظامك الرقمي بأكمله، ويستدل حول التهديدات المحتملة، ويتخذ إجراءات ذكية لحماية مؤسستك."
                },
                "HOME_CTA_BUTTON": {
                    "en": "Request a Demo",
                    "ja": "デモを予約する",
                    "es": "Solicitar Demo",
                    "fr": "Demander une Démo",
                    "zh": "申请演示",
                    "zh-TW": "預約產品展示",
                    "de": "Demo Anfordern", "ar": "اطلب عرضاً توضيحياً"
                },
                "HOME_CTA_BUTTON_AUDIT": {
                    "en": "Request a Red Team Audit",
                    "ja": "レッドチーム診断を依頼する",
                    "es": "Solicitar una Auditoría Red Team",
                    "fr": "Demander un Audit Red Team",
                    "zh": "申请红队安全审计",
                    "zh-TW": "申請紅隊資安檢測",
                    "de": "Red-Team-Audit Anfordern", "ar": "اطلب تدقيق الفريق الأحمر"
                },
                "HOME_CTA_HINT_DEMO": {
                    "en": "Autonomous detection & response",
                    "ja": "自律型の検知・対応",
                    "es": "Detección y respuesta autónomas",
                    "fr": "Détection et réponse autonomes",
                    "zh": "自主检测与响应",
                    "zh-TW": "自主偵測與回應",
                    "de": "Autonome Erkennung & Reaktion", "ar": "كشف واستجابة ذاتيان"
                },
                "HOME_CTA_HINT_AUDIT": {
                    "en": "AI agent red team · real-world infiltration",
                    "ja": "AIエージェント・レッドチーム｜実戦的侵入手法",
                    "es": "Red team de agentes IA · infiltración real",
                    "fr": "Red team d'agents IA · infiltration réelle",
                    "zh": "AI代理红队 · 真实入侵手法",
                    "zh-TW": "AI 代理紅隊 · 真實入侵手法",
                    "de": "KI-Agenten-Red-Team · reale Infiltration", "ar": "فريق أحمر بوكلاء الذكاء الاصطناعي · اختراق واقعي"
                },
                "HOME_CTA_REVEAL_DEMO": {
                    "en": "Watch Enbarr's autonomous agents detect, triage and contain live threats across your own endpoints — no rip-and-replace, no agent fatigue.",
                    "ja": "Enbarrの自律型エージェントが、お客様の端末環境で脅威をリアルタイムに検知・トリアージ・封じ込める様子をご覧ください。既存環境の入れ替えは不要です。",
                    "es": "Observa cómo los agentes autónomos de Enbarr detectan, clasifican y contienen amenazas reales en tus propios endpoints, sin reemplazar tu infraestructura.",
                    "fr": "Voyez les agents autonomes d'Enbarr détecter, trier et contenir des menaces réelles sur vos propres endpoints, sans remplacer votre infrastructure.",
                    "zh": "观看Enbarr的自主代理在您自己的终端上实时检测、分诊并遏制威胁——无需推倒重建。",
                    "zh-TW": "觀看 Enbarr 的自主代理在您自己的端點上即時偵測、分流並遏制威脅 —— 無需汰換既有架構。",
                    "de": "Sehen Sie, wie Enbarrs autonome Agenten echte Bedrohungen auf Ihren eigenen Endpoints erkennen, priorisieren und eindämmen — ohne Systemwechsel.", "ar": "شاهد وكلاء Enbarr الذاتيين وهم يكتشفون التهديدات الحية ويصنّفونها ويحتوونها على أجهزتك — دون استبدال بنيتك."
                },
                "HOME_CTA_REVEAL_AUDIT": {
                    "en": "Enroll our AI agent red team to comprehensively audit your organization's entire security surface — using the same real-world infiltration techniques a live adversary would.",
                    "ja": "AIエージェント・レッドチームを導入し、実際の攻撃者と同じ侵入手法で組織全体のセキュリティ・アタックサーフェスを網羅的に診断します。",
                    "es": "Contrata nuestro red team de agentes IA para auditar exhaustivamente toda la superficie de seguridad de tu organización, con las mismas técnicas de infiltración que usaría un adversario real.",
                    "fr": "Engagez notre red team d'agents IA pour auditer de façon exhaustive toute la surface de sécurité de votre organisation, avec les techniques d'infiltration d'un véritable adversaire.",
                    "zh": "启用我们的AI代理红队，以真实攻击者的入侵手法，全面审计您组织的整个安全暴露面。",
                    "zh-TW": "啟用我們的 AI 代理紅隊，以真實攻擊者的入侵手法，全面檢測您組織的整體資安暴露面。",
                    "de": "Beauftragen Sie unser KI-Agenten-Red-Team, die gesamte Sicherheitsoberfläche Ihrer Organisation umfassend zu prüfen — mit den realen Infiltrationstechniken eines echten Angreifers.", "ar": "استعن بفريقنا الأحمر بوكلاء الذكاء الاصطناعي لتدقيق كامل سطح الأمان في مؤسستك بالتقنيات الواقعية التي يستخدمها مهاجم حقيقي."
                },
                "AUDIT_BADGE": {
                    "en": "AI AGENT RED TEAM",
                    "ja": "AIエージェント・レッドチーム",
                    "es": "RED TEAM DE AGENTES IA",
                    "fr": "RED TEAM D'AGENTS IA",
                    "zh": "AI代理红队",
                    "zh-TW": "AI 代理紅隊",
                    "de": "KI-AGENTEN-RED-TEAM", "ar": "الفريق الأحمر بوكلاء الذكاء الاصطناعي"
                },
                "AUDIT_TITLE": {
                    "en": "Penetration Testing Form",
                    "ja": "ペネトレーションテスト依頼フォーム",
                    "es": "Formulario de Pruebas de Penetración",
                    "fr": "Formulaire de Test d'Intrusion",
                    "zh": "渗透测试申请表",
                    "zh-TW": "滲透測試申請表",
                    "de": "Penetrationstest-Formular", "ar": "نموذج اختبار الاختراق"
                },
                "AUDIT_SUBTITLE": {
                    "en": "Autonomous AI agents attempt intrusion using exactly the same techniques as real attackers, assessing your organization's entire security surface comprehensively and in real time.",
                    "ja": "自律型AIエージェントが、実際の攻撃者と全く同じ手法で侵入を試み、組織全体のセキュリティ・アタックサーフェスを網羅的かつリアルタイムに診断します。",
                    "es": "Agentes de IA autónomos intentan la intrusión con exactamente las mismas técnicas que emplean los atacantes reales, evaluando toda la superficie de seguridad de tu organización de forma exhaustiva y en tiempo real.",
                    "fr": "Des agents IA autonomes tentent l'intrusion avec exactement les mêmes techniques que les attaquants réels, évaluant l'ensemble de votre surface de sécurité de manière exhaustive et en temps réel.",
                    "zh": "自主AI代理以与真实攻击者完全相同的手法尝试入侵，全面且实时地评估您组织的整个安全暴露面。",
                    "zh-TW": "自主 AI 代理以與真實攻擊者完全相同的手法嘗試入侵，全面且即時地評估您組織的整體資安暴露面。",
                    "de": "Autonome KI-Agenten versuchen den Einbruch mit exakt denselben Techniken wie reale Angreifer und prüfen die gesamte Sicherheitsoberfläche Ihrer Organisation umfassend und in Echtzeit.", "ar": "وكلاء ذكاء اصطناعي ذاتيون يحاولون الاختراق بالتقنيات نفسها تماماً التي يستخدمها المهاجمون الحقيقيون، ويقيّمون كامل سطح الأمان في مؤسستك بشكل شامل وفي الوقت الفعلي."
                },
                "AUDIT_PRIVACY": {
                    "en": "Information provided in this form is not stored or used by CompDeep for any purpose other than this assessment. It is treated with strict confidentiality in accordance with the laws of Japan. The purpose of this form is to understand your organization's security risk and attack surface so that we can propose the most appropriate services.",
                    "ja": "本フォームでご入力いただいた情報は、本診断の目的以外でCompDeepが保存・利用することはありません。日本国の法令に従い、厳格な機密として取り扱います。本フォームは、貴組織のセキュリティリスクと攻撃対象領域を把握し、最適なサービスをご提案するためのものです。",
                    "es": "CompDeep no almacena ni utiliza la información facilitada en este formulario para ningún fin distinto de esta evaluación. Se trata con estricta confidencialidad conforme a las leyes de Japón. La finalidad de este formulario es comprender el riesgo de seguridad y la superficie de ataque de su organización para poder proponerle los servicios más adecuados.",
                    "fr": "Les informations fournies dans ce formulaire ne sont ni conservées ni utilisées par CompDeep à d'autres fins que cette évaluation. Elles sont traitées en stricte confidentialité conformément au droit japonais. Ce formulaire a pour objet de comprendre le risque de sécurité et la surface d'attaque de votre organisation afin de vous proposer les services les plus adaptés.",
                    "zh": "本表单中提供的信息，CompDeep 不会出于本次评估以外的任何目的加以存储或使用，并依据日本法律严格保密处理。本表单旨在了解贵组织的安全风险与攻击面，以便为您提供最合适的服务建议。",
                    "zh-TW": "本表單中提供的資訊，CompDeep 不會出於本次評估以外的任何目的加以儲存或使用，並依據日本法律嚴格保密處理。本表單旨在瞭解貴組織的資安風險與攻擊面，以便為您提供最合適的服務建議。",
                    "de": "Die in diesem Formular angegebenen Informationen werden von CompDeep zu keinem anderen Zweck als dieser Bewertung gespeichert oder verwendet. Sie werden nach japanischem Recht streng vertraulich behandelt. Zweck dieses Formulars ist es, das Sicherheitsrisiko und die Angriffsfläche Ihrer Organisation zu verstehen, um Ihnen die passenden Leistungen vorschlagen zu können.", "ar": "لا تقوم CompDeep بتخزين أو استخدام المعلومات المقدَّمة في هذا النموذج لأي غرض غير هذا التقييم، وتُعامل بسرية تامة وفقاً لقوانين اليابان. الغرض من هذا النموذج هو فهم المخاطر الأمنية وسطح الهجوم في مؤسستك حتى نتمكن من اقتراح الخدمات الأنسب لك."
                },
                "AUDIT_PRIVACY_ASK": {
                    "en": "If you have any questions, please contact us at",
                    "ja": "ご不明な点がございましたら、こちらまでお問い合わせください。",
                    "es": "Si tiene alguna consulta, puede escribirnos a",
                    "fr": "Pour toute question, vous pouvez nous contacter à",
                    "zh": "如有任何疑问，请通过以下方式与我们联系",
                    "zh-TW": "如有任何疑問，請透過以下方式與我們聯繫",
                    "de": "Bei Fragen erreichen Sie uns unter", "ar": "لأي استفسار، يمكنكم التواصل معنا عبر"
                },
                "AUDIT_STEP_OF": {
                    "en": "Step {0} of {1}", "ja": "ステップ {0}／{1}", "es": "Paso {0} de {1}", "fr": "Étape {0} sur {1}",
                    "zh": "第 {0} 步，共 {1} 步", "zh-TW": "第 {0} 步，共 {1} 步", "de": "Schritt {0} von {1}", "ar": "الخطوة {0} من {1}"
                },
                "AUDIT_NEXT": {
                    "en": "Continue", "ja": "次へ", "es": "Continuar", "fr": "Continuer",
                    "zh": "下一步", "zh-TW": "下一步", "de": "Weiter", "ar": "متابعة"
                },
                "AUDIT_BACK": {
                    "en": "Back", "ja": "戻る", "es": "Atrás", "fr": "Retour",
                    "zh": "上一步", "zh-TW": "上一步", "de": "Zurück", "ar": "رجوع"
                },
                "AUDIT_SELECT": {
                    "en": "Select...", "ja": "選択してください", "es": "Seleccionar...", "fr": "Sélectionner...",
                    "zh": "请选择...", "zh-TW": "請選擇...", "de": "Auswählen...", "ar": "اختر..."
                },
                "AUDIT_OPTIONAL": {
                    "en": "Optional", "ja": "任意", "es": "Opcional", "fr": "Facultatif",
                    "zh": "选填", "zh-TW": "選填", "de": "Optional", "ar": "اختياري"
                },
                "AUDIT_REQUIRED": {
                    "en": "Please complete the highlighted fields before continuing.",
                    "ja": "ハイライトされた必須項目をご入力ください。",
                    "es": "Completa los campos resaltados antes de continuar.",
                    "fr": "Veuillez compléter les champs surlignés avant de continuer.",
                    "zh": "请先填写高亮显示的必填项。",
                    "zh-TW": "請先填寫醒目標示的必填項目。",
                    "de": "Bitte füllen Sie die markierten Felder aus.", "ar": "يرجى إكمال الحقول المميّزة قبل المتابعة."
                },
                "AUDIT_CONSENT_REQUIRED": {
                    "en": "Please confirm the authorization note before submitting.",
                    "ja": "送信前に、実施許可に関する確認事項へのご同意をお願いします。",
                    "es": "Confirma la nota de autorización antes de enviar.",
                    "fr": "Veuillez confirmer la note d'autorisation avant d'envoyer.",
                    "zh": "提交前请确认授权说明。",
                    "zh-TW": "提交前請確認授權說明。",
                    "de": "Bitte bestätigen Sie den Autorisierungshinweis vor dem Senden.", "ar": "يرجى تأكيد إشعار التفويض قبل الإرسال."
                },
                "AUDIT_FORM_SUBMIT": {
                    "en": "Submit", "ja": "送信する", "es": "Enviar", "fr": "Envoyer",
                    "zh": "提交", "zh-TW": "提交", "de": "Senden", "ar": "إرسال"
                },
                "AUDIT_FORM_SENDING": {
                    "en": "Sending...", "ja": "送信中...", "es": "Enviando...", "fr": "Envoi...",
                    "zh": "发送中...", "zh-TW": "傳送中...", "de": "Wird gesendet...", "ar": "جارٍ الإرسال..."
                },
                "AUDIT_FORM_SUCCESS": {
                    "en": "Request received. Our team will be in touch shortly.",
                    "ja": "送信が完了しました。担当者より追ってご連絡いたします。",
                    "es": "Solicitud recibida. Nuestro equipo se pondrá en contacto en breve.",
                    "fr": "Demande reçue. Notre équipe vous recontactera rapidement.",
                    "zh": "已收到您的申请，我们的团队将尽快与您联系。",
                    "zh-TW": "已收到您的申請，我們的團隊將盡快與您聯繫。",
                    "de": "Anfrage erhalten. Unser Team meldet sich in Kürze.", "ar": "تم استلام طلبك. سيتواصل فريقنا معك قريباً."
                },
                "AUDIT_FORM_ERROR": {
                    "en": "Something went wrong. Please try again or email contact@compdeep.com directly.",
                    "ja": "送信に失敗しました。時間をおいて再度お試しいただくか、contact@compdeep.com までご連絡ください。",
                    "es": "Algo salió mal. Inténtalo de nuevo o escribe directamente a contact@compdeep.com.",
                    "fr": "Une erreur est survenue. Réessayez ou écrivez directement à contact@compdeep.com.",
                    "zh": "提交失败，请重试或直接发送邮件至 contact@compdeep.com。",
                    "zh-TW": "提交失敗，請重試或直接寄信至 contact@compdeep.com。",
                    "de": "Etwas ist schiefgelaufen. Bitte erneut versuchen oder direkt an contact@compdeep.com schreiben.", "ar": "حدث خطأ ما. يرجى المحاولة مجدداً أو مراسلتنا على contact@compdeep.com."
                },
                "TEXT_AUDIT": {
                    "en": "Red Team Audit",
                    "ja": "レッドチーム診断",
                    "es": "Auditoría Red Team",
                    "fr": "Audit Red Team",
                    "zh": "红队安全审计",
                    "zh-TW": "紅隊資安檢測",
                    "de": "Red-Team-Audit", "ar": "تدقيق الفريق الأحمر"
                },
                "TECH_BADGE": {
                    "en": "PLATFORM ARCHITECTURE",
                    "ja": "基盤アーキテクチャ",
                    "es": "ARQUITECTURA DE PLATAFORMA",
                    "fr": "ARCHITECTURE DE PLATEFORME",
                    "zh": "平台架构",
                    "zh-TW": "平台架構",
                    "de": "PLATTFORM-ARCHITEKTUR", "ar": "هندسة المنصة"
                },
                "TECH_TITLE": {
                    "en": "Built for Autonomous Security",
                    "ja": "自律型セキュリティのための設計",
                    "es": "Construido para Seguridad Autónoma",
                    "fr": "Conçu pour la Sécurité Autonome",
                    "zh": "为自主安全而构建",
                    "zh-TW": "專為自主式資安打造",
                    "de": "Gebaut für Autonome Sicherheit", "ar": "مبني للأمان الذاتي"
                },
                "TECH_SUBTITLE": {
                    "en": "Open source, distributed, and AI-native. A self-contained security platform that operates independently — no cloud dependencies, no vendor lock-in, no compromise.",
                    "ja": "オープンソース、分散型、AI前提の設計。クラウド依存なし、ベンダーロックインなし、妥協なし。単独で完結する自律型セキュリティ基盤です。",
                    "es": "Código abierto, distribuido y nativo de IA. Una plataforma de seguridad autónoma que opera independientemente — sin dependencias de nube, sin bloqueo de proveedor, sin compromisos.",
                    "fr": "Open source, distribué et natif IA. Une plateforme de sécurité autonome qui opère indépendamment — aucune dépendance cloud, aucun verrouillage fournisseur, aucun compromis.",
                    "zh": "开源、分布式、AI原生。一个独立运行的自包含安全平台——无云依赖、无供应商锁定、无妥协。",
                    "zh-TW": "開源、分散式、AI原生設計。一個獨立運作的完整資安平台——不依賴雲端、不綁定供應商、毫不妥協。",
                    "de": "Open Source, verteilt und KI-nativ. Eine eigenständige Sicherheitsplattform, die unabhängig arbeitet — keine Cloud-Abhängigkeiten, kein Vendor Lock-in, kein Kompromiss.", "ar": "مفتوح المصدر، موزّع، وأصيل للذكاء الاصطناعي. منصة أمان مكتفية ذاتياً تعمل بشكل مستقل — لا اعتماد على السحابة، لا حبس مورد، لا تنازل."
                },
                "TECH_ARCH_BADGE": {
                    "en": "CORE ARCHITECTURE",
                    "ja": "基本アーキテクチャ",
                    "es": "ARQUITECTURA CENTRAL",
                    "fr": "ARCHITECTURE PRINCIPALE",
                    "zh": "核心架构",
                    "zh-TW": "核心架構",
                    "de": "KERNARCHITEKTUR", "ar": "الهندسة الأساسية"
                },
                "TECH_ARCH_HEADING": {
                    "en": "Three Pillars of Defense",
                    "ja": "防御の3つの柱",
                    "es": "Tres Pilares de Defensa",
                    "fr": "Trois Piliers de Défense",
                    "zh": "防御三大支柱",
                    "zh-TW": "三大防禦支柱",
                    "de": "Drei Säulen der Verteidigung", "ar": "ثلاث ركائز للدفاع"
                },
                "TECH_ARCH_DETECT_TITLE": {
                    "en": "Behavioral Detection Engine",
                    "ja": "行動検知エンジン",
                    "es": "Motor de Detección Conductual",
                    "fr": "Moteur de Détection Comportementale",
                    "zh": "行为检测引擎",
                    "zh-TW": "行為檢測引擎",
                    "de": "Verhaltensbasierte Erkennungs-Engine", "ar": "محرك الكشف السلوكي"
                },
                "TECH_ARCH_DETECT_MONO": {
                    "en": "SIGNATURELESS KERNEL TELEMETRY",
                    "ja": "定義ファイル不要のカーネル監視",
                    "es": "TELEMETRÍA DE KERNEL SIN FIRMAS",
                    "fr": "TÉLÉMÉTRIE NOYAU SANS SIGNATURES",
                    "zh": "无签名内核遥测",
                    "zh-TW": "無需特徵碼的核心監控",
                    "de": "SIGNATURLOSE KERNEL-TELEMETRIE", "ar": "قياس عن بُعد للنواة بدون توقيعات"
                },
                "TECH_ARCH_DETECT_DESC": {
                    "en": "Monitors at the OS kernel level without signatures or cloud round-trips. Detects based on behavior, not patterns.",
                    "ja": "定義ファイルやクラウド接続なしでOSの中核レベルから監視。既知のパターンではなく、振る舞いで脅威を検出します。",
                    "es": "Monitorea a nivel del kernel del SO sin firmas ni viajes a la nube. Detecta basándose en comportamiento, no en patrones.",
                    "fr": "Surveille au niveau du noyau de l'OS sans signatures ni allers-retours cloud. Détecte sur la base du comportement, pas des motifs.",
                    "zh": "在操作系统内核级别监控，无需签名或云端往返。基于行为而非模式进行检测。",
                    "zh-TW": "在作業系統核心層監控，不需特徵碼也不必連線雲端。依據行為而非模式進行偵測。",
                    "de": "Überwacht auf OS-Kernel-Ebene ohne Signaturen oder Cloud-Roundtrips. Erkennt basierend auf Verhalten, nicht auf Mustern.", "ar": "يراقب على مستوى نواة نظام التشغيل بدون توقيعات أو رحلات سحابية. يكتشف بناءً على السلوك، وليس الأنماط."
                },
                "TECH_ARCH_DETECT_1": {
                    "en": "Injection chain analysis and entropy mapping",
                    "ja": "攻撃チェーン分析とエントロピー解析",
                    "es": "Análisis de cadenas de inyección y mapeo de entropía",
                    "fr": "Analyse de chaînes d'injection et cartographie d'entropie",
                    "zh": "注入链分析和熵映射",
                    "zh-TW": "注入鏈分析和熵對映",
                    "de": "Injektionsketten-Analyse und Entropie-Mapping", "ar": "تحليل سلاسل الحقن ورسم خرائط الإنتروبيا"
                },
                "TECH_ARCH_DETECT_2": {
                    "en": "Behavioral profiling across process lifecycle",
                    "ja": "プロセスの起動から終了まで振る舞いを分析",
                    "es": "Perfilado conductual a lo largo del ciclo de vida del proceso",
                    "fr": "Profilage comportemental sur tout le cycle de vie du processus",
                    "zh": "跨进程生命周期的行为分析",
                    "zh-TW": "跨程序生命週期的行為分析",
                    "de": "Verhaltensprofilierung über den gesamten Prozesslebenszyklus", "ar": "تنميط سلوكي عبر دورة حياة العملية"
                },
                "TECH_ARCH_DETECT_3": {
                    "en": "Real-time ETW kernel event stream processing",
                    "ja": "リアルタイムETWカーネルイベントストリーム処理",
                    "es": "Procesamiento de flujo de eventos del kernel ETW en tiempo real",
                    "fr": "Traitement en temps réel du flux d'événements noyau ETW",
                    "zh": "实时ETW内核事件流处理",
                    "zh-TW": "實時ETW核心事件流處理",
                    "de": "Echtzeit-ETW-Kernel-Eventstream-Verarbeitung", "ar": "معالجة تدفق أحداث نواة ETW في الوقت الفعلي"
                },
                "TECH_ARCH_AI_TITLE": {
                    "en": "Agentic AI Engine",
                    "ja": "自律型AIエンジン",
                    "es": "Motor de IA Agéntica",
                    "fr": "Moteur IA Agentique",
                    "zh": "智能体AI引擎",
                    "zh-TW": "自主式AI引擎",
                    "de": "Agentische KI-Engine", "ar": "محرك الذكاء الاصطناعي الوكيل"
                },
                "TECH_ARCH_AI_MONO": {
                    "en": "INVESTIGATION LOOP WITH PARALLEL EXECUTION",
                    "ja": "並列実行による調査ループ",
                    "es": "BUCLE DE INVESTIGACIÓN CON EJECUCIÓN PARALELA",
                    "fr": "BOUCLE D'INVESTIGATION AVEC EXÉCUTION PARALLÈLE",
                    "zh": "并行执行的调查循环",
                    "zh-TW": "平行調查引擎",
                    "de": "UNTERSUCHUNGSSCHLEIFE MIT PARALLELER AUSFÜHRUNG", "ar": "حلقة تحقيق بتنفيذ متوازٍ"
                },
                "TECH_ARCH_AI_DESC": {
                    "en": "Builds investigation plans as directed graphs, runs parallel probes, reflects on evidence, and makes graduated decisions.",
                    "ja": "調査計画を自動構築し、複数の検査を同時実行。証拠を総合的に評価した上で、段階的な判断を行います。",
                    "es": "Construye planes de investigación como grafos dirigidos, ejecuta sondeos paralelos, reflexiona sobre la evidencia y toma decisiones graduadas.",
                    "fr": "Construit des plans d'investigation sous forme de graphes dirigés, lance des sondes parallèles, réfléchit sur les preuves et prend des décisions graduées.",
                    "zh": "将调查计划构建为有向图，运行并行探测，反思证据，做出渐进式决策。",
                    "zh-TW": "自動規劃調查流程，同時執行多項檢測，綜合分析證據後做出漸進式判斷。",
                    "de": "Erstellt Untersuchungspläne als gerichtete Graphen, führt parallele Sonden aus, reflektiert über Beweise und trifft abgestufte Entscheidungen.", "ar": "يبني خطط تحقيق كرسوم بيانية موجهة، يشغّل فحوصات متوازية، يتأمل في الأدلة، ويتخذ قرارات متدرجة."
                },
                "TECH_ARCH_AI_1": {
                    "en": "Memory, connections, IP reputation, and telemetry probes",
                    "ja": "メモリ・通信・IP評価・システム監視を多角的に検査",
                    "es": "Sondeos de memoria, conexiones, reputación IP y telemetría",
                    "fr": "Sondes de mémoire, connexions, réputation IP et télémétrie",
                    "zh": "内存、连接、IP信誉和遥测探测",
                    "zh-TW": "同步檢測記憶體、連線、IP信譽及系統監控",
                    "de": "Speicher-, Verbindungs-, IP-Reputations- und Telemetrie-Sonden", "ar": "فحوصات الذاكرة والاتصالات وسمعة IP والقياس عن بُعد"
                },
                "TECH_ARCH_AI_2": {
                    "en": "Reflection checkpoints before escalation",
                    "ja": "判断を上位に委ねる前に、AIが自ら再確認",
                    "es": "Puntos de control de reflexión antes de la escalación",
                    "fr": "Points de contrôle de réflexion avant l'escalade",
                    "zh": "升级前的反思检查点",
                    "zh-TW": "通報前的自我驗證機制",
                    "de": "Reflexions-Checkpoints vor der Eskalation", "ar": "نقاط تفتيش تأمّلية قبل التصعيد"
                },
                "TECH_ARCH_AI_3": {
                    "en": "Explains findings in plain language",
                    "ja": "分析結果をわかりやすい言葉で報告",
                    "es": "Explica hallazgos en lenguaje simple",
                    "fr": "Explique les découvertes en langage clair",
                    "zh": "用通俗语言解释发现",
                    "zh-TW": "以淺顯易懂的語言說明分析結果",
                    "de": "Erklärt Befunde in einfacher Sprache", "ar": "يشرح النتائج بلغة بسيطة"
                },
                "TECH_ARCH_MESH_TITLE": {
                    "en": "Distributed Mesh Network",
                    "ja": "分散メッシュネットワーク",
                    "es": "Red Mesh Distribuida",
                    "fr": "Réseau Maillé Distribué",
                    "zh": "分布式网格网络",
                    "zh-TW": "分散式網格網路",
                    "de": "Verteiltes Mesh-Netzwerk", "ar": "شبكة Mesh موزّعة"
                },
                "TECH_ARCH_MESH_MONO": {
                    "en": "ENCRYPTED PEER-TO-PEER COMMUNICATION",
                    "ja": "暗号化ピアツーピア通信",
                    "es": "COMUNICACIÓN PEER-TO-PEER CIFRADA",
                    "fr": "COMMUNICATION PAIR-À-PAIR CHIFFRÉE",
                    "zh": "加密点对点通信",
                    "zh-TW": "加密點對點通訊",
                    "de": "VERSCHLÜSSELTE PEER-TO-PEER-KOMMUNIKATION", "ar": "اتصالات نظير إلى نظير مشفرة"
                },
                "TECH_ARCH_MESH_DESC": {
                    "en": "Nodes gossip and coordinate threat signals across a role-based topology. Autonomous collective decisions with no central server.",
                    "ja": "役割ごとに分担された端末が脅威情報を自動で共有・連携。中央サーバーなしで組織全体が自律的に判断します。",
                    "es": "Los nodos intercambian y coordinan señales de amenazas a través de una topología basada en roles. Decisiones colectivas autónomas sin servidor central.",
                    "fr": "Les nœuds échangent et coordonnent les signaux de menaces via une topologie basée sur les rôles. Décisions collectives autonomes sans serveur central.",
                    "zh": "节点通过基于角色的拓扑结构交换和协调威胁信号。无中央服务器的自主集体决策。",
                    "zh-TW": "節點透過基於角色的拓撲結構交換和協調威脅訊號。無中央伺服器的自主集體決策。",
                    "de": "Knoten tauschen und koordinieren Bedrohungssignale über eine rollenbasierte Topologie. Autonome kollektive Entscheidungen ohne zentralen Server.", "ar": "العُقد تتبادل وتنسق إشارات التهديد عبر طوبولوجيا قائمة على الأدوار. قرارات جماعية ذاتية بدون خادم مركزي."
                },
                "TECH_ARCH_MESH_1": {
                    "en": "Coordinator, investigator, and sentinel node roles",
                    "ja": "統括・調査・監視の3つの役割を端末に割り当て",
                    "es": "Roles de nodo coordinador, investigador y centinela",
                    "fr": "Rôles de nœud coordinateur, investigateur et sentinelle",
                    "zh": "协调者、调查者和哨兵节点角色",
                    "zh-TW": "協調者、調查者和哨兵節點角色",
                    "de": "Koordinator-, Ermittler- und Wächter-Knotenrollen", "ar": "أدوار عُقد المنسق والمحقق والحارس"
                },
                "TECH_ARCH_MESH_2": {
                    "en": "Encrypted gossip protocol with cryptographic enrollment",
                    "ja": "暗号化された通信プロトコルと証明書ベースの端末登録",
                    "es": "Protocolo gossip cifrado con inscripción criptográfica",
                    "fr": "Protocole gossip chiffré avec enrôlement cryptographique",
                    "zh": "带加密注册的加密gossip协议",
                    "zh-TW": "帶加密註冊的加密gossip協議",
                    "de": "Verschlüsseltes Gossip-Protokoll mit kryptographischer Registrierung", "ar": "بروتوكول gossip مشفر مع تسجيل تشفيري"
                },
                "TECH_ARCH_MESH_3": {
                    "en": "Alert broadcast to all peers in seconds",
                    "ja": "数秒で全端末にアラートを一斉配信",
                    "es": "Difusión de alertas a todos los pares en segundos",
                    "fr": "Diffusion d'alertes à tous les pairs en quelques secondes",
                    "zh": "几秒内向所有对等节点广播警报",
                    "zh-TW": "幾秒內向所有對等節點廣播警報",
                    "de": "Alarm-Broadcast an alle Peers in Sekunden", "ar": "بث التنبيهات لجميع النظراء في ثوانٍ"
                },
                "TECH_FLOW_BADGE": {
                    "en": "ANATOMY OF A RESPONSE",
                    "ja": "対応の流れ",
                    "es": "ANATOMÍA DE UNA RESPUESTA",
                    "fr": "ANATOMIE D'UNE RÉPONSE",
                    "zh": "响应剖析",
                    "zh-TW": "響應剖析",
                    "de": "ANATOMIE EINER REAKTION", "ar": "تشريح الاستجابة"
                },
                "TECH_FLOW_HEADING": {
                    "en": "Detection Pipeline",
                    "ja": "検出の流れ",
                    "es": "Pipeline de Detección",
                    "fr": "Pipeline de Détection",
                    "zh": "检测管道",
                    "zh-TW": "檢測管道",
                    "de": "Erkennungs-Pipeline", "ar": "خط أنابيب الكشف"
                },
                "TECH_FLOW_S1_TITLE": {
                    "en": "Kernel Telemetry",
                    "ja": "カーネル監視",
                    "es": "Telemetría del Kernel",
                    "fr": "Télémétrie Noyau",
                    "zh": "内核遥测",
                    "zh-TW": "核心監控資料",
                    "de": "Kernel-Telemetrie", "ar": "قياس عن بُعد للنواة"
                },
                "TECH_FLOW_S1_TIMING": {
                    "en": "< 1s",
                    "ja": "< 1秒",
                    "es": "< 1s",
                    "fr": "< 1s",
                    "zh": "< 1秒",
                    "zh-TW": "< 1秒",
                    "de": "< 1s", "ar": "< 1 ثانية"
                },
                "TECH_FLOW_S1_DESC": {
                    "en": "OS-level event stream catches process creation, registry writes, and network connections instantly.",
                    "ja": "OSレベルのイベントを常時監視し、プロセスの起動、レジストリ変更、ネットワーク通信を即座に検出。",
                    "es": "El flujo de eventos a nivel de SO captura creación de procesos, escrituras de registro y conexiones de red al instante.",
                    "fr": "Le flux d'événements au niveau de l'OS capture instantanément la création de processus, les écritures de registre et les connexions réseau.",
                    "zh": "操作系统级事件流即时捕获进程创建、注册表写入和网络连接。",
                    "zh-TW": "作業系統級事件流即時捕獲程序建立、登錄檔寫入和網路連線。",
                    "de": "Event-Stream auf OS-Ebene erfasst sofort Prozesserstellung, Registry-Schreibvorgänge und Netzwerkverbindungen.", "ar": "تدفق أحداث على مستوى نظام التشغيل يلتقط إنشاء العمليات وكتابات السجل واتصالات الشبكة فوراً."
                },
                "TECH_FLOW_S2_TITLE": {
                    "en": "Behavioral Scoring",
                    "ja": "行動スコアリング",
                    "es": "Puntuación Conductual",
                    "fr": "Scoring Comportemental",
                    "zh": "行为评分",
                    "zh-TW": "行為評分",
                    "de": "Verhaltens-Scoring", "ar": "التقييم السلوكي"
                },
                "TECH_FLOW_S2_TIMING": {
                    "en": "< 3s",
                    "ja": "< 3秒",
                    "es": "< 3s",
                    "fr": "< 3s",
                    "zh": "< 3秒",
                    "zh-TW": "< 3秒",
                    "de": "< 3s", "ar": "< 3 ثوانٍ"
                },
                "TECH_FLOW_S2_DESC": {
                    "en": "Novelty scoring and severity scoring produce a combined threat score. Events above threshold trigger alerts.",
                    "ja": "異常度と重大度を組み合わせた脅威スコアを自動算出。基準値を超えた場合に即座にアラートを発行。",
                    "es": "La puntuación de novedad y severidad producen una puntuación de amenaza combinada. Los eventos por encima del umbral activan alertas.",
                    "fr": "Les scores de nouveauté et de gravité produisent un score de menace combiné. Les événements au-dessus du seuil déclenchent des alertes.",
                    "zh": "新颖性评分和严重性评分产生综合威胁分数。超过阈值的事件触发警报。",
                    "zh-TW": "新穎性評分和嚴重性評分產生綜合威脅分數。超過閾值的事件觸發警報。",
                    "de": "Neuheits- und Schweregrad-Scoring erzeugen einen kombinierten Bedrohungswert. Ereignisse über dem Schwellenwert lösen Alarme aus.", "ar": "تقييم الجدة وتقييم الخطورة ينتجان درجة تهديد مجمعة. الأحداث فوق العتبة تُطلق تنبيهات."
                },
                "TECH_FLOW_S3_TITLE": {
                    "en": "Injection Chain Analysis",
                    "ja": "攻撃チェーン分析",
                    "es": "Análisis de Cadena de Inyección",
                    "fr": "Analyse de Chaîne d'Injection",
                    "zh": "注入链分析",
                    "zh-TW": "注入鏈分析",
                    "de": "Injektionsketten-Analyse", "ar": "تحليل سلسلة الحقن"
                },
                "TECH_FLOW_S3_TIMING": {
                    "en": "< 5s",
                    "ja": "< 5秒",
                    "es": "< 5s",
                    "fr": "< 5s",
                    "zh": "< 5秒",
                    "zh-TW": "< 5秒",
                    "de": "< 5s", "ar": "< 5 ثوانٍ"
                },
                "TECH_FLOW_S3_DESC": {
                    "en": "Pattern detection for classic injection techniques. Target process identification and shellcode entropy measurement.",
                    "ja": "代表的な攻撃手法のパターンを検出。標的プロセスの特定と不正コードの解析を実行します。",
                    "es": "Detección de patrones para técnicas de inyección clásicas. Identificación de proceso objetivo y medición de entropía de shellcode.",
                    "fr": "Détection de motifs pour les techniques d'injection classiques. Identification du processus cible et mesure de l'entropie du shellcode.",
                    "zh": "经典注入技术的模式检测。目标进程识别和shellcode熵测量。",
                    "zh-TW": "經典注入技術的模式檢測。目標程序識別和shellcode熵測量。",
                    "de": "Mustererkennung für klassische Injektionstechniken. Zielprozess-Identifikation und Shellcode-Entropie-Messung.", "ar": "كشف الأنماط لتقنيات الحقن الكلاسيكية. تحديد العملية المستهدفة وقياس إنتروبيا الشيفرة."
                },
                "TECH_FLOW_S4_TITLE": {
                    "en": "Threat Classification",
                    "ja": "脅威分類",
                    "es": "Clasificación de Amenazas",
                    "fr": "Classification des Menaces",
                    "zh": "威胁分类",
                    "zh-TW": "威脅分類",
                    "de": "Bedrohungsklassifizierung", "ar": "تصنيف التهديد"
                },
                "TECH_FLOW_S4_TIMING": {
                    "en": "< 8s",
                    "ja": "< 8秒",
                    "es": "< 8s",
                    "fr": "< 8s",
                    "zh": "< 8秒",
                    "zh-TW": "< 8秒",
                    "de": "< 8s", "ar": "< 8 ثوانٍ"
                },
                "TECH_FLOW_S4_DESC": {
                    "en": "Deterministic classification maps to MITRE ATT&CK. 98 techniques across 12 tactics mapped at the telemetry layer.",
                    "ja": "MITRE ATT&CKフレームワークに自動対応。12戦術・98技法を監視レイヤーで網羅。",
                    "es": "Clasificación determinista mapeada a MITRE ATT&CK. 98 técnicas en 12 tácticas mapeadas en la capa de telemetría.",
                    "fr": "Classification déterministe mappée sur MITRE ATT&CK. 98 techniques sur 12 tactiques mappées au niveau de la télémétrie.",
                    "zh": "确定性分类映射到MITRE ATT&CK。遥测层映射12个战术的98种技术。",
                    "zh-TW": "確定性分類對映到MITRE ATT&CK。監控資料層對映12個戰術的98種技術。",
                    "de": "Deterministische Klassifizierung auf MITRE ATT&CK abgebildet. 98 Techniken über 12 Taktiken auf der Telemetrie-Ebene.", "ar": "تصنيف حتمي يُربط بـ MITRE ATT&CK. 98 تقنية عبر 12 تكتيكاً مُربطة على طبقة القياس عن بُعد."
                },
                "TECH_FLOW_S5_TITLE": {
                    "en": "Mesh Broadcast",
                    "ja": "ネットワーク全体に通知",
                    "es": "Difusión Mesh",
                    "fr": "Diffusion Maillée",
                    "zh": "网格广播",
                    "zh-TW": "網格廣播",
                    "de": "Mesh-Broadcast", "ar": "بث Mesh"
                },
                "TECH_FLOW_S5_TIMING": {
                    "en": "< 10s",
                    "ja": "< 10秒",
                    "es": "< 10s",
                    "fr": "< 10s",
                    "zh": "< 10秒",
                    "zh-TW": "< 10秒",
                    "de": "< 10s", "ar": "< 10 ثوانٍ"
                },
                "TECH_FLOW_S5_DESC": {
                    "en": "Alert compressed and broadcast across the gossip network to every connected node in seconds.",
                    "ja": "アラートを圧縮し、分散ネットワーク経由で数秒以内にすべての端末に一斉配信。",
                    "es": "Alerta comprimida y difundida a través de la red gossip a cada nodo conectado en segundos.",
                    "fr": "Alerte compressée et diffusée sur le réseau gossip à chaque nœud connecté en quelques secondes.",
                    "zh": "警报压缩后通过gossip网络在几秒内广播到每个连接的节点。",
                    "zh-TW": "警報壓縮後透過gossip網路在幾秒內廣播到每個連線的節點。",
                    "de": "Alarm komprimiert und über das Gossip-Netzwerk in Sekunden an jeden verbundenen Knoten gesendet.", "ar": "يُضغط التنبيه ويُبث عبر شبكة gossip إلى كل عقدة متصلة في ثوانٍ."
                },
                "TECH_RESPONSE_BADGE": {
                    "en": "INVESTIGATION & CONTAINMENT",
                    "ja": "調査と封じ込め",
                    "es": "INVESTIGACIÓN Y CONTENCIÓN",
                    "fr": "INVESTIGATION ET CONFINEMENT",
                    "zh": "调查与遏制",
                    "zh-TW": "調查與封鎖控制",
                    "de": "UNTERSUCHUNG & EINDÄMMUNG", "ar": "التحقيق والاحتواء"
                },
                "TECH_RESPONSE_HEADING": {
                    "en": "Response Pipeline",
                    "ja": "対応の流れ",
                    "es": "Pipeline de Respuesta",
                    "fr": "Pipeline de Réponse",
                    "zh": "响应管道",
                    "zh-TW": "響應管道",
                    "de": "Reaktions-Pipeline", "ar": "خط أنابيب الاستجابة"
                },
                "TECH_RESP_S1_TITLE": {
                    "en": "Agent Triggered",
                    "ja": "AI起動",
                    "es": "Agente Activado",
                    "fr": "Agent Déclenché",
                    "zh": "代理触发",
                    "zh-TW": "代理觸發",
                    "de": "Agent Ausgelöst", "ar": "تنشيط الوكيل"
                },
                "TECH_RESP_S1_TIMING": {
                    "en": "Automatic",
                    "ja": "自動",
                    "es": "Automático",
                    "fr": "Automatique",
                    "zh": "自动",
                    "zh-TW": "自動",
                    "de": "Automatisch", "ar": "تلقائي"
                },
                "TECH_RESP_S1_DESC": {
                    "en": "The alert arrives and the investigator agent picks it up automatically. No human trigger needed.",
                    "ja": "アラートを受信すると、調査AIが自動的に起動。人の操作は不要です。",
                    "es": "La alerta llega y el agente investigador la recoge automáticamente. Sin necesidad de activación humana.",
                    "fr": "L'alerte arrive et l'agent investigateur la prend en charge automatiquement. Aucun déclenchement humain nécessaire.",
                    "zh": "警报到达后调查代理自动接手。无需人工触发。",
                    "zh-TW": "警報到達後調查代理自動接手。無需人工觸發。",
                    "de": "Der Alarm kommt an und der Ermittler-Agent nimmt ihn automatisch auf. Kein menschlicher Auslöser nötig.", "ar": "يصل التنبيه ويلتقطه وكيل التحقيق تلقائياً. لا حاجة لتشغيل بشري."
                },
                "TECH_RESP_S2_TITLE": {
                    "en": "Investigation Plan",
                    "ja": "調査計画",
                    "es": "Plan de Investigación",
                    "fr": "Plan d'Investigation",
                    "zh": "调查计划",
                    "zh-TW": "調查計劃",
                    "de": "Untersuchungsplan", "ar": "خطة التحقيق"
                },
                "TECH_RESP_S2_TIMING": {
                    "en": "< 5s",
                    "ja": "< 5秒",
                    "es": "< 5s",
                    "fr": "< 5s",
                    "zh": "< 5秒",
                    "zh-TW": "< 5秒",
                    "de": "< 5s", "ar": "< 5 ثوانٍ"
                },
                "TECH_RESP_S2_DESC": {
                    "en": "The AI builds a directed graph: parallel probes for memory, connections, IP reputation, and telemetry.",
                    "ja": "AIが調査計画を自動作成。メモリ・通信・IP評価・システム監視を同時並行で検査開始。",
                    "es": "La IA construye un grafo dirigido: sondeos paralelos para memoria, conexiones, reputación IP y telemetría.",
                    "fr": "L'IA construit un graphe dirigé : sondes parallèles pour la mémoire, les connexions, la réputation IP et la télémétrie.",
                    "zh": "AI构建有向图：内存、连接、IP信誉和遥测的并行探测。",
                    "zh-TW": "AI構建有向圖：記憶體、連線、IP信譽和監控資料的並行探測。",
                    "de": "Die KI erstellt einen gerichteten Graphen: parallele Sonden für Speicher, Verbindungen, IP-Reputation und Telemetrie.", "ar": "يبني الذكاء الاصطناعي رسماً بيانياً موجهاً: فحوصات متوازية للذاكرة والاتصالات وسمعة IP والقياس عن بُعد."
                },
                "TECH_RESP_S3_TITLE": {
                    "en": "Parallel Execution",
                    "ja": "並列実行",
                    "es": "Ejecución Paralela",
                    "fr": "Exécution Parallèle",
                    "zh": "并行执行",
                    "zh-TW": "並行執行",
                    "de": "Parallele Ausführung", "ar": "التنفيذ المتوازي"
                },
                "TECH_RESP_S3_TIMING": {
                    "en": "< 30s",
                    "ja": "< 30秒",
                    "es": "< 30s",
                    "fr": "< 30s",
                    "zh": "< 30秒",
                    "zh-TW": "< 30秒",
                    "de": "< 30s", "ar": "< 30 ثانية"
                },
                "TECH_RESP_S3_DESC": {
                    "en": "Multiple probes fire simultaneously. Shellcode confirmed in memory, active C2 beacon traced to known threat infrastructure.",
                    "ja": "複数の検査を同時実行。メモリ上で不正コードを確認、遠隔操作の通信先を既知の攻撃インフラまで追跡。",
                    "es": "Múltiples sondeos se ejecutan simultáneamente. Shellcode confirmado en memoria, beacon C2 activo rastreado a infraestructura de amenazas conocida.",
                    "fr": "Plusieurs sondes se déclenchent simultanément. Shellcode confirmé en mémoire, balise C2 active tracée vers une infrastructure de menaces connue.",
                    "zh": "多个探测同时触发。内存中确认shellcode，活跃C2信标追踪到已知威胁基础设施。",
                    "zh-TW": "多個探測同時觸發。記憶體中確認shellcode，活躍C2信標追蹤到已知威脅基礎設施。",
                    "de": "Mehrere Sonden feuern gleichzeitig. Shellcode im Speicher bestätigt, aktives C2-Beacon zur bekannten Bedrohungsinfrastruktur zurückverfolgt.", "ar": "فحوصات متعددة تُطلق في وقت واحد. تأكيد الشيفرة في الذاكرة، تتبع إشارة C2 نشطة إلى بنية تحتية تهديد معروفة."
                },
                "TECH_RESP_S4_TITLE": {
                    "en": "Reflection",
                    "ja": "再確認",
                    "es": "Reflexión",
                    "fr": "Réflexion",
                    "zh": "反思",
                    "zh-TW": "反思",
                    "de": "Reflexion", "ar": "التأمّل"
                },
                "TECH_RESP_S4_TIMING": {
                    "en": "< 60s",
                    "ja": "< 60秒",
                    "es": "< 60s",
                    "fr": "< 60s",
                    "zh": "< 60秒",
                    "zh-TW": "< 60秒",
                    "de": "< 60s", "ar": "< 60 ثانية"
                },
                "TECH_RESP_S4_DESC": {
                    "en": "The agent pauses to reason: strong injection evidence plus active C2. Decision — continue, hash lookup needed before escalating.",
                    "ja": "AIが立ち止まって判断。攻撃の証拠と遠隔操作通信を確認。対処を進める前にハッシュ照合で裏付けを取ります。",
                    "es": "El agente se detiene para razonar: evidencia fuerte de inyección más C2 activo. Decisión — continuar, búsqueda de hash necesaria antes de escalar.",
                    "fr": "L'agent fait une pause pour raisonner : preuves d'injection fortes plus C2 actif. Décision — continuer, recherche de hash nécessaire avant l'escalade.",
                    "zh": "代理暂停推理：强有力的注入证据加上活跃的C2。决策——继续，在升级之前需要哈希查找。",
                    "zh-TW": "代理暫停推理：強有力的注入證據加上活躍的C2。決策——繼續，在升級之前需要雜湊查詢。",
                    "de": "Der Agent hält inne zum Nachdenken: starke Injektionsbeweise plus aktives C2. Entscheidung — fortfahren, Hash-Lookup vor Eskalation erforderlich.", "ar": "الوكيل يتوقف للاستدلال: أدلة حقن قوية بالإضافة إلى C2 نشط. القرار — المتابعة، البحث عن التجزئة مطلوب قبل التصعيد."
                },
                "TECH_RESP_S5_TITLE": {
                    "en": "Safety Gate → Isolate",
                    "ja": "セーフティゲート → 隔離",
                    "es": "Puerta de Seguridad → Aislar",
                    "fr": "Porte de Sécurité → Isoler",
                    "zh": "安全门 → 隔离",
                    "zh-TW": "安全門 → 隔離",
                    "de": "Sicherheitstor → Isolieren", "ar": "بوابة الأمان ← العزل"
                },
                "TECH_RESP_S5_TIMING": {
                    "en": "< 90s",
                    "ja": "< 90秒",
                    "es": "< 90s",
                    "fr": "< 90s",
                    "zh": "< 90秒",
                    "zh-TW": "< 90秒",
                    "de": "< 90s", "ar": "< 90 ثانية"
                },
                "TECH_RESP_S5_DESC": {
                    "en": "Hash matches known RAT. Threat score exceeds threshold. Process killed, C2 IP blocked, alert broadcast to all peer nodes.",
                    "ja": "ハッシュが既知の遠隔操作ツールと一致。脅威スコアが基準を超過。プロセス停止、攻撃元IPをブロック、全端末にアラートを配信。",
                    "es": "Hash coincide con RAT conocido. Puntuación de amenaza excede el umbral. Proceso eliminado, IP C2 bloqueada, alerta difundida a todos los nodos pares.",
                    "fr": "Le hash correspond à un RAT connu. Le score de menace dépasse le seuil. Processus tué, IP C2 bloquée, alerte diffusée à tous les nœuds pairs.",
                    "zh": "哈希匹配已知RAT。威胁分数超过阈值。进程终止，C2 IP被阻止，警报广播到所有对等节点。",
                    "zh-TW": "雜湊匹配已知RAT。威脅分數超過閾值。程序終止，C2 IP被阻止，警報廣播到所有對等節點。",
                    "de": "Hash stimmt mit bekanntem RAT überein. Bedrohungswert überschreitet Schwellenwert. Prozess beendet, C2-IP blockiert, Alarm an alle Peer-Knoten gesendet.", "ar": "التجزئة تتطابق مع RAT معروف. درجة التهديد تتجاوز العتبة. إنهاء العملية، حظر IP C2، بث التنبيه لجميع العُقد."
                },
                "TECH_MITRE_BADGE": {
                    "en": "THREAT COVERAGE",
                    "ja": "脅威対応範囲",
                    "es": "COBERTURA DE AMENAZAS",
                    "fr": "COUVERTURE DES MENACES",
                    "zh": "威胁覆盖",
                    "zh-TW": "威脅覆蓋",
                    "de": "BEDROHUNGSABDECKUNG", "ar": "تغطية التهديدات"
                },
                "TECH_MITRE_HEADING": {
                    "en": "MITRE ATT&CK Coverage",
                    "ja": "MITRE ATT&CK対応範囲",
                    "es": "Cobertura MITRE ATT&CK",
                    "fr": "Couverture MITRE ATT&CK",
                    "zh": "MITRE ATT&CK覆盖",
                    "zh-TW": "MITRE ATT&CK覆蓋",
                    "de": "MITRE ATT&CK-Abdeckung", "ar": "تغطية MITRE ATT&CK"
                },
                "TECH_MITRE_V1": {
                    "en": "98",
                    "ja": "98",
                    "es": "98",
                    "fr": "98",
                    "zh": "98",
                    "zh-TW": "98",
                    "de": "98", "ar": "98"
                },
                "TECH_MITRE_L1": {
                    "en": "Techniques Covered",
                    "ja": "対応する攻撃技法",
                    "es": "Técnicas Cubiertas",
                    "fr": "Techniques Couvertes",
                    "zh": "覆盖技术数",
                    "zh-TW": "覆蓋技術數",
                    "de": "Abgedeckte Techniken", "ar": "التقنيات المغطاة"
                },
                "TECH_MITRE_V2": {
                    "en": "48",
                    "ja": "48",
                    "es": "48",
                    "fr": "48",
                    "zh": "48",
                    "zh-TW": "48",
                    "de": "48", "ar": "48"
                },
                "TECH_MITRE_L2": {
                    "en": "Sub-technique Classifications",
                    "ja": "サブテクニック分類",
                    "es": "Clasificaciones de Sub-técnicas",
                    "fr": "Classifications de Sous-techniques",
                    "zh": "子技术分类",
                    "zh-TW": "子技術分類",
                    "de": "Untertechnik-Klassifikationen", "ar": "تصنيفات التقنيات الفرعية"
                },
                "TECH_MITRE_V3": {
                    "en": "12",
                    "ja": "12",
                    "es": "12",
                    "fr": "12",
                    "zh": "12",
                    "zh-TW": "12",
                    "de": "12", "ar": "12"
                },
                "TECH_MITRE_L3": {
                    "en": "Tactic Coverage",
                    "ja": "戦術の網羅数",
                    "es": "Cobertura de Tácticas",
                    "fr": "Couverture Tactique",
                    "zh": "战术覆盖",
                    "zh-TW": "戰術覆蓋",
                    "de": "Taktik-Abdeckung", "ar": "تغطية التكتيكات"
                },
                "TECH_MITRE_V4": {
                    "en": "20+",
                    "ja": "20+",
                    "es": "20+",
                    "fr": "20+",
                    "zh": "20+",
                    "zh-TW": "20+",
                    "de": "20+", "ar": "20+"
                },
                "TECH_MITRE_L4": {
                    "en": "Autonomous Agent Skills",
                    "ja": "AIの自律対応スキル",
                    "es": "Habilidades de Agente Autónomo",
                    "fr": "Compétences d'Agent Autonome",
                    "zh": "自主代理技能",
                    "zh-TW": "自主代理技能",
                    "de": "Autonome Agenten-Fähigkeiten", "ar": "مهارات الوكيل الذاتي"
                },
                "TECH_ZK_BADGE": {
                    "en": "DATA ARCHITECTURE",
                    "ja": "データアーキテクチャ",
                    "es": "ARQUITECTURA DE DATOS",
                    "fr": "ARCHITECTURE DES DONNÉES",
                    "zh": "数据架构",
                    "zh-TW": "資料架構",
                    "de": "DATENARCHITEKTUR", "ar": "هندسة البيانات"
                },
                "TECH_ZK_HEADING": {
                    "en": "Zero-Knowledge Architecture",
                    "ja": "ゼロ知識アーキテクチャ",
                    "es": "Arquitectura de Conocimiento Cero",
                    "fr": "Architecture à Connaissance Zéro",
                    "zh": "零知识架构",
                    "zh-TW": "零信任架構",
                    "de": "Zero-Knowledge-Architektur", "ar": "هندسة المعرفة الصفرية"
                },
                "TECH_ZK_TITLE": {
                    "en": "Behavioral Signals Only",
                    "ja": "振る舞い情報のみ使用",
                    "es": "Solo Señales de Comportamiento",
                    "fr": "Signaux Comportementaux Uniquement",
                    "zh": "仅行为信号",
                    "zh-TW": "僅行為訊號",
                    "de": "Nur Verhaltenssignale", "ar": "إشارات سلوكية فقط"
                },
                "TECH_ZK_DESC_1": {
                    "en": "Enbarr processes only behavioral signals — never content, never PII. Your data never leaves your perimeter.",
                    "ja": "Enbarrが扱うのは振る舞い情報のみ。ファイルの中身や個人情報には一切触れません。データが社外に出ることはありません。",
                    "es": "Enbarr procesa solo señales de comportamiento — nunca contenido, nunca PII. Tus datos nunca salen de tu perímetro.",
                    "fr": "Enbarr ne traite que des signaux comportementaux — jamais de contenu, jamais de PII. Vos données ne quittent jamais votre périmètre.",
                    "zh": "Enbarr仅处理行为信号——不涉及内容，不涉及PII。您的数据永远不会离开您的边界。",
                    "zh-TW": "Enbarr僅處理行為訊號——不涉及內容，不涉及PII。您的資料永遠不會離開您的邊界。",
                    "de": "Enbarr verarbeitet nur Verhaltenssignale — niemals Inhalte, niemals PII. Ihre Daten verlassen niemals Ihren Perimeter.", "ar": "يعالج Enbarr الإشارات السلوكية فقط — لا محتوى، لا معلومات شخصية. بياناتك لا تغادر محيطك أبداً."
                },
                "TECH_ZK_DESC_2": {
                    "en": "Deploy cloud or on-premise with complete data sovereignty. Bring your own LLM — any OpenAI-compatible endpoint.",
                    "ja": "クラウドでも自社環境でも導入可能で、データの完全な管理権を維持。お手持ちのLLMも利用できます（OpenAI互換エンドポイント対応）。",
                    "es": "Despliega en la nube o on-premise con soberanía total de datos. Trae tu propio LLM — cualquier endpoint compatible con OpenAI.",
                    "fr": "Déployez dans le cloud ou sur site avec une souveraineté totale des données. Apportez votre propre LLM — tout endpoint compatible OpenAI.",
                    "zh": "云端或本地部署，享有完全数据主权。自带LLM——任何OpenAI兼容端点。",
                    "zh-TW": "雲端或本地部署，享有完全資料主權。自帶LLM——任何OpenAI相容端點裝置。",
                    "de": "Cloud- oder On-Premise-Bereitstellung mit vollständiger Datensouveränität. Bringen Sie Ihr eigenes LLM mit — jeder OpenAI-kompatible Endpoint.", "ar": "انشر سحابياً أو محلياً مع سيادة بيانات كاملة. أحضر LLM الخاص بك — أي نقطة نهاية متوافقة مع OpenAI."
                },
                "TECH_ZK_FEAT_1": {
                    "en": "No content inspection — behavioral signals only",
                    "ja": "ファイルの中身は検査しない——振る舞い情報のみ使用",
                    "es": "Sin inspección de contenido — solo señales de comportamiento",
                    "fr": "Aucune inspection de contenu — signaux comportementaux uniquement",
                    "zh": "无内容检查——仅行为信号",
                    "zh-TW": "無內容檢查——僅行為訊號",
                    "de": "Keine Inhaltsprüfung — nur Verhaltenssignale", "ar": "لا فحص محتوى — إشارات سلوكية فقط"
                },
                "TECH_ZK_FEAT_2": {
                    "en": "No PII collection or processing",
                    "ja": "個人情報の収集・処理は一切なし",
                    "es": "Sin recopilación ni procesamiento de PII",
                    "fr": "Aucune collecte ni traitement de PII",
                    "zh": "不收集或处理PII",
                    "zh-TW": "不收集或處理PII",
                    "de": "Keine PII-Erfassung oder -Verarbeitung", "ar": "لا جمع أو معالجة PII"
                },
                "TECH_ZK_FEAT_3": {
                    "en": "Full audit trail stays within your infrastructure",
                    "ja": "すべての監査ログがお客様のインフラ内に保管",
                    "es": "Rastro de auditoría completo dentro de tu infraestructura",
                    "fr": "Piste d'audit complète dans votre infrastructure",
                    "zh": "完整审计跟踪保留在您的基础设施内",
                    "zh-TW": "完整審計跟蹤保留在您的基礎設施內",
                    "de": "Vollständiger Audit-Trail bleibt in Ihrer Infrastruktur", "ar": "مسار تدقيق كامل يبقى داخل بنيتك التحتية"
                },
                "TECH_DEPLOY_BADGE": {
                    "en": "INFRASTRUCTURE",
                    "ja": "導入環境",
                    "es": "INFRAESTRUCTURA",
                    "fr": "INFRASTRUCTURE",
                    "zh": "基础设施",
                    "zh-TW": "基礎設施",
                    "de": "INFRASTRUKTUR", "ar": "البنية التحتية"
                },
                "TECH_DEPLOY_HEADING": {
                    "en": "Deployment Options",
                    "ja": "導入オプション",
                    "es": "Opciones de Despliegue",
                    "fr": "Options de Déploiement",
                    "zh": "部署选项",
                    "zh-TW": "部署選項",
                    "de": "Bereitstellungsoptionen", "ar": "خيارات النشر"
                },
                "TECH_DEPLOY_CLOUD_TITLE": {
                    "en": "Cloud Managed",
                    "ja": "クラウドマネージド",
                    "es": "Gestionado en la Nube",
                    "fr": "Géré dans le Cloud",
                    "zh": "云托管",
                    "zh-TW": "雲託管",
                    "de": "Cloud-Verwaltet", "ar": "مُدار سحابياً"
                },
                "TECH_DEPLOY_CLOUD_DESC": {
                    "en": "Connect endpoints to our hosted coordinator node. Zero infrastructure to provision, automatic updates, managed inference. Operational in hours.",
                    "ja": "当社のクラウド管理サーバーに端末を接続するだけ。インフラ構築不要、自動更新、AI推論もおまかせ。数時間で稼働開始。",
                    "es": "Conecta endpoints a nuestro nodo coordinador alojado. Cero infraestructura que aprovisionar, actualizaciones automáticas, inferencia gestionada. Operativo en horas.",
                    "fr": "Connectez les endpoints à notre nœud coordinateur hébergé. Zéro infrastructure à provisionner, mises à jour automatiques, inférence gérée. Opérationnel en quelques heures.",
                    "zh": "将端点连接到我们的托管协调节点。零基础设施配置，自动更新，托管推理。数小时内运行。",
                    "zh-TW": "將端點裝置連線至我們的雲端管理節點。免建基礎架構、自動更新、AI推論由我們代管。數小時即可上線。",
                    "de": "Endpoints mit unserem gehosteten Koordinator-Knoten verbinden. Null Infrastruktur bereitzustellen, automatische Updates, verwaltete Inferenz. In Stunden betriebsbereit.", "ar": "اربط نقاط النهاية بعقدة المنسق المستضافة لدينا. صفر بنية تحتية للتجهيز، تحديثات تلقائية، استدلال مُدار. يعمل في ساعات."
                },
                "TECH_DEPLOY_ONPREM_TITLE": {
                    "en": "On-Premise / Air-Gapped",
                    "ja": "自社環境 / 閉域ネットワーク",
                    "es": "On-Premise / Air-Gapped",
                    "fr": "Sur Site / Air-Gap",
                    "zh": "本地部署 / 气隙隔离",
                    "zh-TW": "本地部署 / 離線隔離",
                    "de": "On-Premise / Air-Gapped", "ar": "محلي / معزول هوائياً"
                },
                "TECH_DEPLOY_ONPREM_DESC": {
                    "en": "Host your own inference with our models and fine-tuning. Run your own coordinator nodes. Every byte of telemetry behind your perimeter. No external callbacks.",
                    "ja": "当社のAIモデルを使って自社内でAI推論を実行。管理サーバーも自社運用。すべてのデータが社内に留まり、外部への通信は一切ありません。",
                    "es": "Aloja tu propia inferencia con nuestros modelos y fine-tuning. Ejecuta tus propios nodos coordinadores. Cada byte de telemetría dentro de tu perímetro. Sin callbacks externos.",
                    "fr": "Hébergez votre propre inférence avec nos modèles et le fine-tuning. Exécutez vos propres nœuds coordinateurs. Chaque octet de télémétrie derrière votre périmètre. Aucun rappel externe.",
                    "zh": "使用我们的模型和微调托管自己的推理。运行自己的协调节点。每个遥测字节都在您的边界内。无外部回调。",
                    "zh-TW": "使用我們提供的模型在本地運行AI推論。自行管理所有節點，資料不會離開您的網路，零外部連線。",
                    "de": "Hosten Sie Ihre eigene Inferenz mit unseren Modellen und Feinabstimmung. Betreiben Sie Ihre eigenen Koordinator-Knoten. Jedes Byte Telemetrie hinter Ihrem Perimeter. Keine externen Callbacks.", "ar": "استضف استدلالك الخاص بنماذجنا والضبط الدقيق. شغّل عُقد المنسق الخاصة بك. كل بايت من القياس عن بُعد خلف محيطك. لا مكالمات خارجية."
                },
                "TECH_DEPLOY_HYBRID_TITLE": {
                    "en": "Hybrid",
                    "ja": "ハイブリッド",
                    "es": "Híbrido",
                    "fr": "Hybride",
                    "zh": "混合",
                    "zh-TW": "混合",
                    "de": "Hybrid", "ar": "هجين"
                },
                "TECH_DEPLOY_HYBRID_DESC": {
                    "en": "Mix cloud governance with on-premise collectors. Or run everything locally with cloud-hosted inference. You define the boundary.",
                    "ja": "クラウド管理と自社内データ収集の組み合わせ、または自社内運用＋クラウドAI推論の組み合わせなど、お客様の要件に応じて自由に設計できます。",
                    "es": "Combina gobernanza en la nube con recopiladores on-premise. O ejecuta todo localmente con inferencia alojada en la nube. Tú defines el límite.",
                    "fr": "Mélangez gouvernance cloud et collecteurs sur site. Ou exécutez tout localement avec inférence hébergée dans le cloud. Vous définissez la frontière.",
                    "zh": "将云治理与本地收集器混合。或在本地运行一切，使用云端推理。由您定义边界。",
                    "zh-TW": "雲端管理搭配本地資料收集，或本地運行搭配雲端AI推論。邊界由您自己定義。",
                    "de": "Mischen Sie Cloud-Governance mit On-Premise-Kollektoren. Oder betreiben Sie alles lokal mit Cloud-gehosteter Inferenz. Sie definieren die Grenze.", "ar": "اجمع بين حوكمة السحابة وجامعي البيانات المحليين. أو شغّل كل شيء محلياً مع استدلال مستضاف سحابياً. أنت تحدد الحدود."
                },
                "TECH_DEPLOY_BYOAI_TITLE": {
                    "en": "Bring Your Own AI Model",
                    "ja": "お手持ちのAIモデルを利用可能",
                    "es": "Trae Tu Propio Modelo de IA",
                    "fr": "Apportez Votre Propre Modèle IA",
                    "zh": "自带AI模型",
                    "zh-TW": "自備AI模型",
                    "de": "Eigenes KI-Modell Mitbringen", "ar": "أحضر نموذج الذكاء الاصطناعي الخاص بك"
                },
                "TECH_DEPLOY_BYOAI_DESC": {
                    "en": "Model-agnostic inference layer. Self-hosted, commercial APIs, or custom models fine-tuned on your organization's threat landscape.",
                    "ja": "特定のモデルに依存しない設計。自社運用、商用API、または自組織の脅威に合わせて調整したカスタムモデルが利用できます。",
                    "es": "Capa de inferencia agnóstica de modelo. Autoalojado, APIs comerciales, o modelos personalizados fine-tuned en el panorama de amenazas de tu organización.",
                    "fr": "Couche d'inférence agnostique de modèle. Auto-hébergé, APIs commerciales, ou modèles personnalisés affinés sur le paysage de menaces de votre organisation.",
                    "zh": "模型无关的推理层。自托管、商业API或根据组织威胁环境微调的自定义模型。",
                    "zh-TW": "不綁定特定模型的推論架構。可使用自行部署、商用API或針對貴組織威脅調整過的自訂模型。",
                    "de": "Modellagnostische Inferenzschicht. Selbst gehostet, kommerzielle APIs oder benutzerdefinierte Modelle, die auf Ihre Bedrohungslandschaft abgestimmt sind.", "ar": "طبقة استدلال محايدة للنموذج. مستضافة ذاتياً، واجهات API تجارية، أو نماذج مخصصة مضبوطة على مشهد التهديدات لمؤسستك."
                },
                "TECH_OSS_BADGE": {
                    "en": "EXTENSIBLE FRAMEWORK",
                    "ja": "拡張可能なフレームワーク",
                    "es": "MARCO EXTENSIBLE",
                    "fr": "CADRE EXTENSIBLE",
                    "zh": "可扩展框架",
                    "zh-TW": "開放式框架",
                    "de": "ERWEITERBARES FRAMEWORK", "ar": "إطار عمل قابل للتوسيع"
                },
                "TECH_OSS_HEADING": {
                    "en": "Build on Enbarr. Scale Without Limits.",
                    "ja": "Enbarrを基盤に、自由に拡張。",
                    "es": "Construye sobre Enbarr. Escala sin límites.",
                    "fr": "Construisez sur Enbarr. Évoluez sans limites.",
                    "zh": "基于Enbarr构建。无限扩展。",
                    "zh-TW": "以Enbarr為基礎，無限延伸。",
                    "de": "Auf Enbarr aufbauen. Grenzenlos skalieren.", "ar": "ابنِ على Enbarr. وسّع بلا حدود."
                },
                "TECH_OSS_DESC_1": {
                    "en": "The network stack is open source — a distributed computing framework with security as its first application.",
                    "ja": "ネットワーク基盤はオープンソース。セキュリティを第一の用途として設計された分散コンピューティングフレームワークです。",
                    "es": "El stack de red es de código abierto — un marco de computación distribuida con la seguridad como primera aplicación.",
                    "fr": "La pile réseau est open source — un cadre de calcul distribué avec la sécurité comme première application.",
                    "zh": "网络栈是开源的——以安全为第一应用的分布式计算框架。",
                    "zh-TW": "網路層完全開源——以資安為首要用途的分散式運算框架。",
                    "de": "Der Netzwerk-Stack ist Open Source — ein verteiltes Computing-Framework mit Sicherheit als erster Anwendung.", "ar": "مجموعة الشبكة مفتوحة المصدر — إطار حوسبة موزّعة مع الأمان كأول تطبيق له."
                },
                "TECH_OSS_DESC_2": {
                    "en": "The entire mesh layer — encrypted transport, gossip protocol, cryptographic enrollment, role-based topology — is available for your engineering team to extend.",
                    "ja": "暗号化通信、分散プロトコル、証明書ベースの登録、役割ベースの構成を含むネットワーク層すべてを、お客様の開発チームが自由に拡張できます。",
                    "es": "Toda la capa mesh — transporte cifrado, protocolo gossip, inscripción criptográfica, topología basada en roles — está disponible para que tu equipo de ingeniería la extienda.",
                    "fr": "Toute la couche mesh — transport chiffré, protocole gossip, enrôlement cryptographique, topologie basée sur les rôles — est disponible pour votre équipe d'ingénierie.",
                    "zh": "整个网格层——加密传输、gossip协议、加密注册、基于角色的拓扑——都可供您的工程团队扩展。",
                    "zh-TW": "整個網路層——加密傳輸、分散通訊協議、憑證註冊、角色式拓撲——均可由您的工程團隊自由擴充。",
                    "de": "Die gesamte Mesh-Schicht — verschlüsselter Transport, Gossip-Protokoll, kryptographische Registrierung, rollenbasierte Topologie — steht Ihrem Engineering-Team zur Erweiterung zur Verfügung.", "ar": "طبقة الشبكة بأكملها — النقل المشفر، بروتوكول gossip، التسجيل التشفيري، الطوبولوجيا القائمة على الأدوار — متاحة لفريق الهندسة الخاص بك للتوسيع."
                },
                "TECH_OSS_EXTEND_LABEL": {
                    "en": "Build on Enbarr:",
                    "ja": "Enbarrで実現できること：",
                    "es": "Construye sobre Enbarr:",
                    "fr": "Construisez sur Enbarr :",
                    "zh": "基于Enbarr构建：",
                    "zh-TW": "在Enbarr上可以建構：",
                    "de": "Auf Enbarr aufbauen:", "ar": "ابنِ على Enbarr:"
                },
                "TECH_OSS_EXT_1": {
                    "en": "Fleet Configuration Management",
                    "ja": "全端末の構成管理",
                    "es": "Gestión de Configuración de Flota",
                    "fr": "Gestion de Configuration de Flotte",
                    "zh": "设备群配置管理",
                    "zh-TW": "全機群組態管理",
                    "de": "Flotten-Konfigurationsmanagement", "ar": "إدارة تكوين الأسطول"
                },
                "TECH_OSS_EXT_2": {
                    "en": "Compliance Auditing",
                    "ja": "コンプライアンス監査",
                    "es": "Auditoría de Cumplimiento",
                    "fr": "Audit de Conformité",
                    "zh": "合规审计",
                    "zh-TW": "合規審計",
                    "de": "Compliance-Auditing", "ar": "تدقيق الامتثال"
                },
                "TECH_OSS_EXT_3": {
                    "en": "Distributed Log Aggregation",
                    "ja": "分散ログ集約",
                    "es": "Agregación de Logs Distribuida",
                    "fr": "Agrégation de Logs Distribuée",
                    "zh": "分布式日志聚合",
                    "zh-TW": "分散式日誌聚合",
                    "de": "Verteilte Log-Aggregation", "ar": "تجميع السجلات الموزّع"
                },
                "TECH_OSS_EXT_4": {
                    "en": "Custom Telemetry Pipelines",
                    "ja": "カスタム監視データ処理",
                    "es": "Pipelines de Telemetría Personalizados",
                    "fr": "Pipelines de Télémétrie Personnalisés",
                    "zh": "自定义遥测管道",
                    "zh-TW": "自訂監控資料流程",
                    "de": "Benutzerdefinierte Telemetrie-Pipelines", "ar": "خطوط أنابيب القياس عن بُعد المخصصة"
                },
                "TECH_OSS_TAG_1": {
                    "en": "Encrypted Transport",
                    "ja": "暗号化通信",
                    "es": "Transporte Cifrado",
                    "fr": "Transport Chiffré",
                    "zh": "加密传输",
                    "zh-TW": "加密傳輸",
                    "de": "Verschlüsselter Transport", "ar": "نقل مشفر"
                },
                "TECH_OSS_TAG_2": {
                    "en": "Gossip Protocol",
                    "ja": "分散通信プロトコル",
                    "es": "Protocolo Gossip",
                    "fr": "Protocole Gossip",
                    "zh": "Gossip协议",
                    "zh-TW": "Gossip協議",
                    "de": "Gossip-Protokoll", "ar": "بروتوكول Gossip"
                },
                "TECH_OSS_TAG_3": {
                    "en": "Cryptographic Enrollment",
                    "ja": "証明書ベースの登録",
                    "es": "Inscripción Criptográfica",
                    "fr": "Enrôlement Cryptographique",
                    "zh": "加密注册",
                    "zh-TW": "加密註冊",
                    "de": "Kryptographische Registrierung", "ar": "تسجيل تشفيري"
                },
                "TECH_OSS_TAG_4": {
                    "en": "Role-Based Topology",
                    "ja": "役割ベースのトポロジー",
                    "es": "Topología Basada en Roles",
                    "fr": "Topologie Basée sur les Rôles",
                    "zh": "基于角色的拓扑",
                    "zh-TW": "基於角色的拓撲",
                    "de": "Rollenbasierte Topologie", "ar": "طوبولوجيا قائمة على الأدوار"
                },
                "TECH_OSS_TAG_5": {
                    "en": "Zero Trust",
                    "ja": "ゼロトラスト",
                    "es": "Zero Trust",
                    "fr": "Zero Trust",
                    "zh": "零信任",
                    "zh-TW": "零信任",
                    "de": "Zero Trust", "ar": "Zero Trust"
                },
                "TECH_OSS_TAG_6": {
                    "en": "Parallel Execution",
                    "ja": "並列実行",
                    "es": "Ejecución Paralela",
                    "fr": "Exécution Parallèle",
                    "zh": "并行执行",
                    "zh-TW": "並行執行",
                    "de": "Parallele Ausführung", "ar": "تنفيذ متوازٍ"
                },
                "TECH_PERF_BADGE": {
                    "en": "PERFORMANCE",
                    "ja": "パフォーマンス",
                    "es": "RENDIMIENTO",
                    "fr": "PERFORMANCES",
                    "zh": "性能",
                    "zh-TW": "效能",
                    "de": "LEISTUNG", "ar": "الأداء"
                },
                "TECH_PERF_HEADING": {
                    "en": "Response Metrics",
                    "ja": "対応スピード",
                    "es": "Métricas de Respuesta",
                    "fr": "Métriques de Réponse",
                    "zh": "响应指标",
                    "zh-TW": "回應速度指標",
                    "de": "Reaktions-Metriken", "ar": "مقاييس الاستجابة"
                },
                "TECH_PERF_V1": {
                    "en": "< 10s",
                    "ja": "< 10秒",
                    "es": "< 10s",
                    "fr": "< 10s",
                    "zh": "< 10秒",
                    "zh-TW": "< 10秒",
                    "de": "< 10s", "ar": "< 10 ثوانٍ"
                },
                "TECH_PERF_L1": {
                    "en": "Mean Time to Detect",
                    "ja": "平均検出時間",
                    "es": "Tiempo Medio de Detección",
                    "fr": "Temps Moyen de Détection",
                    "zh": "平均检测时间",
                    "zh-TW": "平均檢測時間",
                    "de": "Mittlere Erkennungszeit", "ar": "متوسط وقت الكشف"
                },
                "TECH_PERF_D1": {
                    "en": "Real-time kernel telemetry. Behavioral rules fire as events stream.",
                    "ja": "カーネルからのリアルタイム監視。イベント発生と同時に振る舞いルールが即座に反応。",
                    "es": "Telemetría del kernel en tiempo real. Las reglas de comportamiento se activan al transmitir los eventos.",
                    "fr": "Télémétrie noyau en temps réel. Les règles comportementales se déclenchent au fil des événements.",
                    "zh": "实时内核遥测。行为规则随事件流触发。",
                    "zh-TW": "即時核心層監控，行為規則隨事件即時觸發。",
                    "de": "Echtzeit-Kernel-Telemetrie. Verhaltensregeln feuern, während Events gestreamt werden.", "ar": "قياس عن بُعد للنواة في الوقت الفعلي. القواعد السلوكية تُطلق مع تدفق الأحداث."
                },
                "TECH_PERF_V2": {
                    "en": "< 90s",
                    "ja": "< 90秒",
                    "es": "< 90s",
                    "fr": "< 90s",
                    "zh": "< 90秒",
                    "zh-TW": "< 90秒",
                    "de": "< 90s", "ar": "< 90 ثانية"
                },
                "TECH_PERF_L2": {
                    "en": "Mean Time to Investigate",
                    "ja": "平均調査時間",
                    "es": "Tiempo Medio de Investigación",
                    "fr": "Temps Moyen d'Investigation",
                    "zh": "平均调查时间",
                    "zh-TW": "平均調查時間",
                    "de": "Mittlere Untersuchungszeit", "ar": "متوسط وقت التحقيق"
                },
                "TECH_PERF_D2": {
                    "en": "AI agent investigation loop with concurrent parallel execution. Fully autonomous.",
                    "ja": "AIが複数の調査を同時並行で実行。人の介入なく完全自動で完了。",
                    "es": "Bucle de investigación del agente IA con ejecución paralela concurrente. Totalmente autónomo.",
                    "fr": "Boucle d'investigation de l'agent IA avec exécution parallèle concurrente. Entièrement autonome.",
                    "zh": "AI代理调查循环与并发并行执行。完全自主。",
                    "zh-TW": "AI自主調查引擎同步執行多項檢測。全程自動，無需人力。",
                    "de": "KI-Agent-Untersuchungsschleife mit paralleler Ausführung. Vollständig autonom.", "ar": "حلقة تحقيق وكيل الذكاء الاصطناعي مع تنفيذ متوازٍ متزامن. ذاتي بالكامل."
                },
                "TECH_PERF_V3": {
                    "en": "< 3 min",
                    "ja": "< 3分",
                    "es": "< 3 min",
                    "fr": "< 3 min",
                    "zh": "< 3分钟",
                    "zh-TW": "< 3分鐘",
                    "de": "< 3 Min", "ar": "< 3 دقائق"
                },
                "TECH_PERF_L3": {
                    "en": "Mean Time to Contain",
                    "ja": "平均封じ込め時間",
                    "es": "Tiempo Medio de Contención",
                    "fr": "Temps Moyen de Confinement",
                    "zh": "平均遏制时间",
                    "zh-TW": "平均封鎖控制時間",
                    "de": "Mittlere Eindämmungszeit", "ar": "متوسط وقت الاحتواء"
                },
                "TECH_PERF_D3": {
                    "en": "Automated isolation before lateral movement. No SOC queue, no human bottleneck.",
                    "ja": "攻撃が他の端末に広がる前に自動で隔離。SOCの順番待ちも人手による遅延もありません。",
                    "es": "Aislamiento automatizado antes del movimiento lateral. Sin cola SOC, sin cuello de botella humano.",
                    "fr": "Isolation automatisée avant le mouvement latéral. Pas de file d'attente SOC, pas de goulot d'étranglement humain.",
                    "zh": "在横向移动前自动隔离。无SOC队列，无人工瓶颈。",
                    "zh-TW": "在威脅橫向擴散前自動隔離。不必等SOC處理，沒有人力瓶頸。",
                    "de": "Automatisierte Isolation vor lateraler Bewegung. Keine SOC-Warteschlange, kein menschlicher Engpass.", "ar": "عزل آلي قبل الحركة الجانبية. لا طابور SOC، لا عنق زجاجة بشري."
                },
                // ---- Breaches Page ----
                "BREACH_BADGE": { "en": "CASE STUDIES", "ja": "事例研究", "es": "ESTUDIOS DE CASO", "fr": "ÉTUDES DE CAS", "zh": "案例研究", "zh-TW": "案例研究", "de": "FALLSTUDIEN", "ar": "دراسات حالة" },
                "BREACH_TITLE": { "en": "When Third Parties Fail", "ja": "外部ベンダーが破綻するとき", "es": "Cuando los Terceros Fallan", "fr": "Quand les Tiers Échouent", "zh": "当第三方失败时", "zh-TW": "當第三方供應商出事時", "de": "Wenn Drittanbieter Versagen", "ar": "عندما يفشل الأطراف الثالثة" },
                "BREACH_SUBTITLE": { "en": "Every major breach in recent years shares a common thread: third-party vendor dependencies. Here's how Enbarr eliminates that risk.", "ja": "近年の大規模情報漏洩に共通する原因は、外部ベンダーへの依存です。Enbarrがそのリスクをどのように根本から解消するかをご紹介します。", "es": "Cada brecha importante comparte un hilo común: dependencias de proveedores externos.", "fr": "Chaque violation majeure partage un fil conducteur commun: les dépendances aux fournisseurs tiers.", "zh": "近年来每次重大数据泄露都有一个共同点：第三方供应商依赖。", "zh-TW": "近年每次重大資安事件都有共同原因：對第三方供應商的過度依賴。看看 Enbarr 如何消除這個風險。", "de": "Jeder große Sicherheitsvorfall teilt einen gemeinsamen Faden: Abhängigkeiten von Drittanbietern.", "ar": "كل اختراق كبير في السنوات الأخيرة يشترك في خيط مشترك: الاعتماد على موردين خارجيين. إليك كيف يزيل Enbarr هذا الخطر." },
                "BREACH_STAT_1_VALUE": { "en": "$4.45M", "ja": "$4.45M", "es": "$4.45M", "fr": "4,45M$", "zh": "$4.45M", "zh-TW": "$4.45M", "de": "4,45M$", "ar": "$4.45M" },
                "BREACH_STAT_1_LABEL": { "en": "Average breach cost (2023)", "ja": "情報漏洩1件あたりの平均コスト（2023年）", "es": "Costo promedio de brecha (2023)", "fr": "Coût moyen d'une violation (2023)", "zh": "平均数据泄露成本（2023年）", "zh-TW": "每次資料外洩平均損失（2023年）", "de": "Durchschnittliche Breach-Kosten (2023)", "ar": "متوسط تكلفة الاختراق (2023)" },
                "BREACH_STAT_2_VALUE": { "en": "62%", "ja": "62%", "es": "62%", "fr": "62%", "zh": "62%", "zh-TW": "62%", "de": "62%", "ar": "62%" },
                "BREACH_STAT_2_LABEL": { "en": "Breaches via third-party vectors", "ja": "外部ベンダー経由の情報漏洩", "es": "Brechas vía vectores de terceros", "fr": "Violations via des vecteurs tiers", "zh": "通过第三方向量的数据泄露", "zh-TW": "經由第三方管道造成的外洩", "de": "Breaches über Drittanbieter-Vektoren", "ar": "الاختراقات عبر نواقل أطراف ثالثة" },
                "BREACH_STAT_3_VALUE": { "en": "277 days", "ja": "277日", "es": "277 días", "fr": "277 jours", "zh": "277天", "zh-TW": "277天", "de": "277 Tage", "ar": "277 يوماً" },
                "BREACH_STAT_3_LABEL": { "en": "Average time to identify a breach", "ja": "漏洩の発見までにかかる平均日数", "es": "Tiempo promedio para identificar una brecha", "fr": "Temps moyen pour identifier une violation", "zh": "识别数据泄露的平均时间", "zh-TW": "發現外洩事件的平均天數", "de": "Durchschnittliche Zeit zur Erkennung", "ar": "متوسط الوقت لتحديد الاختراق" },
                "BREACH_STAT_4_VALUE": { "en": "< 3 min", "ja": "< 3分", "es": "< 3 min", "fr": "< 3 min", "zh": "< 3分钟", "zh-TW": "< 3分鐘", "de": "< 3 Min", "ar": "< 3 دقائق" },
                "BREACH_STAT_4_LABEL": { "en": "Enbarr containment time", "ja": "Enbarrの封じ込め時間", "es": "Tiempo de contención de Enbarr", "fr": "Temps de confinement Enbarr", "zh": "Enbarr遏制时间", "zh-TW": "Enbarr封鎖控制時間", "de": "Enbarr-Eindämmungszeit", "ar": "وقت احتواء Enbarr" },
                "BREACH_CASES_BADGE": { "en": "REAL-WORLD INCIDENTS", "ja": "実際のインシデント", "es": "INCIDENTES REALES", "fr": "INCIDENTS RÉELS", "zh": "真实事件", "zh-TW": "真實事件", "de": "REALE VORFÄLLE", "ar": "حوادث واقعية" },
                "BREACH_CASES_TITLE": { "en": "Anatomy of Modern Breaches", "ja": "最新の情報漏洩事例を分析", "es": "Anatomía de las Brechas Modernas", "fr": "Anatomie des Violations Modernes", "zh": "现代数据泄露的解剖", "zh-TW": "解析近年重大資安事件", "de": "Anatomie Moderner Sicherheitsvorfälle", "ar": "تشريح الاختراقات الحديثة" },
                "BREACH_CASES_DESC": { "en": "These incidents reveal how vendor dependencies create catastrophic risk — and how autonomous, vendor-free security would have changed the outcome.", "ja": "これらの事例が示すのは、外部ベンダーへの依存がいかに深刻なリスクを生むか。そしてEnbarrのようなベンダー非依存のセキュリティなら、結果をどう変えられたかということです。", "es": "Estos incidentes revelan cómo las dependencias de proveedores crean riesgos catastróficos.", "fr": "Ces incidents révèlent comment les dépendances fournisseurs créent des risques catastrophiques.", "zh": "这些事件揭示了供应商依赖如何造成灾难性风险。", "zh-TW": "這些事件揭示了供應商依賴如何造成災難性風險。", "de": "Diese Vorfälle zeigen, wie Anbieter-Abhängigkeiten katastrophale Risiken schaffen.", "ar": "هذه الحوادث تكشف كيف تخلق تبعيات الموردين مخاطر كارثية — وكيف كان الأمان الذاتي الخالي من الموردين سيغير النتيجة." },
                "BREACH_REGION_JAPAN": { "en": "Japan", "ja": "日本", "es": "Japón", "fr": "Japon", "zh": "日本", "zh-TW": "日本", "de": "Japan", "ar": "اليابان" },
                "BREACH_JP_HOSPITAL_NAME": { "en": "Osaka Hospital Ransomware", "ja": "大阪急性期総合医療センター ランサムウェア", "es": "Ransomware Hospital de Osaka", "fr": "Ransomware Hôpital d'Osaka", "zh": "大阪医院勒索软件", "zh-TW": "大阪醫院勒索軟體", "de": "Osaka Krankenhaus Ransomware", "ar": "فيروس الفدية في مستشفى أوساكا" },
                "BREACH_JP_HOSPITAL_DATE": { "en": "October 2022", "ja": "2022年10月", "es": "Octubre 2022", "fr": "Octobre 2022", "zh": "2022年10月", "zh-TW": "2022年10月", "de": "Oktober 2022", "ar": "أكتوبر 2022" },
                "BREACH_JP_HOSPITAL_SECTOR": { "en": "Healthcare", "ja": "医療", "es": "Salud", "fr": "Santé", "zh": "医疗", "zh-TW": "醫療", "de": "Gesundheitswesen", "ar": "الرعاية الصحية" },
                "BREACH_JP_HOSPITAL_RECORDS": { "en": "Electronic medical records for 800+ bed hospital", "ja": "800床以上の病院の電子カルテ", "es": "Registros médicos electrónicos de hospital de 800+ camas", "fr": "Dossiers médicaux électroniques d'un hôpital de 800+ lits", "zh": "800+床位医院的电子病历", "zh-TW": "800+床位醫院的電子病歷", "de": "Elektronische Patientenakten eines 800+ Betten-Krankenhauses", "ar": "سجلات طبية إلكترونية لمستشفى بأكثر من 800 سرير" },
                "BREACH_JP_HOSPITAL_WHAT": { "en": "Ransomware entered via a third-party food supplier's VPN. Encrypted the entire EMR system, forcing the hospital back to paper records for months.", "ja": "サードパーティの食品供給業者のVPN経由でランサムウェアが侵入。EMRシステム全体を暗号化し、数ヶ月間紙のカルテに逆戻り。", "es": "El ransomware entró a través de la VPN de un proveedor de alimentos externo.", "fr": "Le ransomware est entré via le VPN d'un fournisseur alimentaire tiers.", "zh": "勒索软件通过第三方食品供应商的VPN进入。", "zh-TW": "勒索軟體透過第三方食品供應商的VPN進入。", "de": "Ransomware gelangte über das VPN eines Drittanbieter-Lebensmittellieferanten ein.", "ar": "دخل فيروس الفدية عبر VPN مورد غذاء خارجي. شفّر نظام السجلات الطبية بالكامل، مما أجبر المستشفى على العودة للسجلات الورقية لأشهر." },
                "BREACH_JP_HOSPITAL_VENDOR": { "en": "The food supplier's compromised VPN credentials provided the initial access vector. Traditional perimeter security didn't monitor third-party network segments.", "ja": "食品供給業者の侵害されたVPN資格情報が初期アクセスベクトルを提供。従来の境界セキュリティはサードパーティのネットワークセグメントを監視していませんでした。", "es": "Las credenciales VPN comprometidas del proveedor de alimentos proporcionaron el vector de acceso inicial.", "fr": "Les identifiants VPN compromis du fournisseur alimentaire ont fourni le vecteur d'accès initial.", "zh": "食品供应商被泄露的VPN凭证提供了初始访问向量。", "zh-TW": "食品供應商被洩露的VPN憑證提供了初始訪問向量。", "de": "Die kompromittierten VPN-Zugangsdaten des Lebensmittellieferanten boten den initialen Angriffsvektor.", "ar": "بيانات اعتماد VPN المخترقة لمورد الغذاء وفّرت ناقل الوصول الأولي. الأمان المحيطي التقليدي لم يراقب قطاعات شبكة الطرف الثالث." },
                "BREACH_JP_HOSPITAL_PREVENT": { "en": "Enbarr's kernel-level detection would have identified anomalous lateral movement from the food supplier's network segment within seconds, triggering autonomous containment before encryption began.", "ja": "Enbarrのカーネルレベル検知は、食品供給業者のネットワークセグメントからの異常な横方向移動を数秒以内に識別し、暗号化が始まる前に自律的な封じ込めをトリガーしていたでしょう。", "es": "La detección a nivel de kernel de Enbarr habría identificado el movimiento lateral anómalo en segundos.", "fr": "La détection au niveau du noyau d'Enbarr aurait identifié le mouvement latéral anormal en quelques secondes.", "zh": "Enbarr的内核级检测会在几秒内识别出异常横向移动。", "zh-TW": "Enbarr的核心層級檢測會在幾秒內識別出異常橫向移動。", "de": "Enbarrs Kernel-Level-Erkennung hätte die anomale Seitwärtsbewegung innerhalb von Sekunden identifiziert.", "ar": "كشف Enbarr على مستوى النواة كان سيحدد الحركة الجانبية الشاذة من قطاع شبكة مورد الغذاء في ثوانٍ، مُطلقاً الاحتواء الذاتي قبل بدء التشفير." },
                "BREACH_JP_TOYOTA_NAME": { "en": "Toyota Supply Chain Breach", "ja": "トヨタ サプライチェーン侵害", "es": "Brecha en la Cadena de Suministro de Toyota", "fr": "Violation de la Chaîne d'Approvisionnement Toyota", "zh": "丰田供应链泄露", "zh-TW": "豐田供應鏈洩露", "de": "Toyota Lieferketten-Breach", "ar": "اختراق سلسلة توريد Toyota" },
                "BREACH_JP_TOYOTA_DATE": { "en": "March 2022", "ja": "2022年3月", "es": "Marzo 2022", "fr": "Mars 2022", "zh": "2022年3月", "zh-TW": "2022年3月", "de": "März 2022", "ar": "مارس 2022" },
                "BREACH_JP_TOYOTA_SECTOR": { "en": "Manufacturing", "ja": "製造業", "es": "Manufactura", "fr": "Fabrication", "zh": "制造业", "zh-TW": "製造業", "de": "Fertigung", "ar": "التصنيع" },
                "BREACH_JP_TOYOTA_RECORDS": { "en": "All 14 factories shut down — 13,000 vehicles/day lost", "ja": "全14工場停止 — 1日13,000台の損失", "es": "14 fábricas cerradas — 13,000 vehículos/día perdidos", "fr": "14 usines arrêtées — 13 000 véhicules/jour perdus", "zh": "14家工厂全部停工——每天损失13,000辆汽车", "zh-TW": "14家工廠全部停工——每天損失13,000輛汽車", "de": "Alle 14 Fabriken stillgelegt — 13.000 Fahrzeuge/Tag verloren", "ar": "توقف جميع المصانع الـ 14 — خسارة 13,000 مركبة يومياً" },
                "BREACH_JP_TOYOTA_WHAT": { "en": "Kojima Industries, a tier-2 supplier, was hit by ransomware. The attack cascaded through the supply chain, forcing Toyota to halt all domestic production.", "ja": "Tier-2サプライヤーの小島プレス工業がランサムウェアに被害。攻撃がサプライチェーンを通じて連鎖し、トヨタは国内全生産を停止。", "es": "Kojima Industries, un proveedor de nivel 2, fue golpeado por ransomware.", "fr": "Kojima Industries, un fournisseur de niveau 2, a été frappé par un ransomware.", "zh": "二级供应商小岛工业遭受勒索软件攻击。", "zh-TW": "二級供應商小島工業遭受勒索軟體攻擊。", "de": "Kojima Industries, ein Tier-2-Zulieferer, wurde von Ransomware getroffen.", "ar": "أُصيبت Kojima Industries، المورد من المستوى الثاني، ببرمجيات الفدية. الهجوم تسلسل عبر سلسلة التوريد، مما أجبر Toyota على وقف كل الإنتاج المحلي." },
                "BREACH_JP_TOYOTA_VENDOR": { "en": "A small supplier with weaker security became the entry point to Toyota's entire production network. The interconnected supply chain amplified the blast radius.", "ja": "セキュリティが弱い小規模サプライヤーがトヨタの生産ネットワーク全体への侵入口に。相互接続されたサプライチェーンが被害範囲を拡大。", "es": "Un pequeño proveedor con seguridad más débil se convirtió en el punto de entrada.", "fr": "Un petit fournisseur avec une sécurité plus faible est devenu le point d'entrée.", "zh": "安全较弱的小供应商成为进入丰田整个生产网络的入口。", "zh-TW": "安全較弱的小供應商成為進入豐田整個生產網路的入口。", "de": "Ein kleiner Zulieferer mit schwächerer Sicherheit wurde zum Einfallstor.", "ar": "مورد صغير بأمان أضعف أصبح نقطة الدخول لشبكة إنتاج Toyota بأكملها. سلسلة التوريد المترابطة ضاعفت نطاق الضرر." },
                "BREACH_JP_TOYOTA_PREVENT": { "en": "Enbarr's distributed mesh would have detected the anomalous traffic patterns from the compromised supplier and autonomously isolated affected network segments within minutes.", "ja": "Enbarrの分散メッシュは、侵害されたサプライヤーからの異常なトラフィックパターンを検知し、影響を受けたネットワークセグメントを数分以内に自律的に分離していたでしょう。", "es": "La malla distribuida de Enbarr habría detectado los patrones de tráfico anómalos.", "fr": "Le maillage distribué d'Enbarr aurait détecté les schémas de trafic anormaux.", "zh": "Enbarr的分布式网格会检测到来自受损供应商的异常流量模式。", "zh-TW": "Enbarr的分散式網格會檢測到來自受損供應商的異常流量模式。", "de": "Enbarrs verteiltes Mesh hätte die anomalen Verkehrsmuster erkannt und betroffene Segmente isoliert.", "ar": "شبكة Enbarr الموزّعة كانت ستكتشف أنماط الحركة الشاذة من المورد المخترق وتعزل قطاعات الشبكة المتأثرة ذاتياً في دقائق." },
                "BREACH_JP_JAXA_NAME": { "en": "JAXA Cyber Attack", "ja": "JAXA サイバー攻撃", "es": "Ciberataque a JAXA", "fr": "Cyberattaque JAXA", "zh": "JAXA网络攻击", "zh-TW": "JAXA網路攻擊", "de": "JAXA Cyberangriff", "ar": "هجوم JAXA السيبراني" },
                "BREACH_JP_JAXA_DATE": { "en": "November 2023", "ja": "2023年11月", "es": "Noviembre 2023", "fr": "Novembre 2023", "zh": "2023年11月", "zh-TW": "2023年11月", "de": "November 2023", "ar": "نوفمبر 2023" },
                "BREACH_JP_JAXA_SECTOR": { "en": "Aerospace / Government", "ja": "航空宇宙 / 政府", "es": "Aeroespacial / Gobierno", "fr": "Aérospatiale / Gouvernement", "zh": "航空航天 / 政府", "zh-TW": "航空航天 / 政府", "de": "Luft- und Raumfahrt / Regierung", "ar": "الفضاء / الحكومة" },
                "BREACH_JP_JAXA_RECORDS": { "en": "Sensitive space program and defense-related data", "ja": "機密宇宙計画および防衛関連データ", "es": "Datos sensibles del programa espacial y defensa", "fr": "Données sensibles du programme spatial et de la défense", "zh": "敏感的太空计划和国防相关数据", "zh-TW": "敏感的太空計劃和國防相關資料", "de": "Sensible Weltraumprogramm- und Verteidigungsdaten", "ar": "بيانات برنامج فضائي ودفاعية حساسة" },
                "BREACH_JP_JAXA_WHAT": { "en": "APT actors exploited a vulnerability in JAXA's Active Directory management tool (provided by a third-party vendor) to gain persistent access to internal systems.", "ja": "APTアクターがJAXAのActive Directory管理ツール（サードパーティベンダー提供）の脆弱性を悪用し、内部システムへの持続的なアクセスを獲得。", "es": "Actores APT explotaron una vulnerabilidad en la herramienta de gestión de Active Directory de JAXA.", "fr": "Des acteurs APT ont exploité une vulnérabilité dans l'outil de gestion AD de JAXA.", "zh": "APT攻击者利用JAXA的Active Directory管理工具中的漏洞。", "zh-TW": "APT攻擊者利用JAXA的Active Directory管理工具中的漏洞。", "de": "APT-Akteure nutzten eine Schwachstelle in JAXAs AD-Management-Tool aus.", "ar": "استغل ممثلو APT ثغرة في أداة إدارة Active Directory لـ JAXA (المقدمة من مورد خارجي) للحصول على وصول مستمر للأنظمة الداخلية." },
                "BREACH_JP_JAXA_VENDOR": { "en": "The third-party AD management tool had an unpatched vulnerability. The vendor's tool became the attack surface that bypassed JAXA's own security perimeter.", "ja": "サードパーティのAD管理ツールにパッチ未適用の脆弱性が存在。ベンダーのツールがJAXA自身のセキュリティ境界を迂回する攻撃面に。", "es": "La herramienta de gestión AD de terceros tenía una vulnerabilidad sin parche.", "fr": "L'outil de gestion AD tiers avait une vulnérabilité non corrigée.", "zh": "第三方AD管理工具存在未修补的漏洞。", "zh-TW": "第三方AD管理工具存在未修補的漏洞。", "de": "Das Drittanbieter-AD-Management-Tool hatte eine ungepatchte Schwachstelle.", "ar": "أداة إدارة AD الخارجية كان بها ثغرة غير مُصلحة. أداة المورد أصبحت سطح الهجوم الذي تجاوز محيط أمان JAXA الخاص." },
                "BREACH_JP_JAXA_PREVENT": { "en": "Enbarr eliminates third-party tool dependencies entirely. With zero-knowledge architecture, there are no vendor tools to exploit as an attack vector.", "ja": "Enbarrはサードパーティツールの依存を完全に排除。ゼロ知識アーキテクチャにより、攻撃ベクトルとして悪用されるベンダーツールが存在しません。", "es": "Enbarr elimina las dependencias de herramientas de terceros por completo.", "fr": "Enbarr élimine entièrement les dépendances aux outils tiers.", "zh": "Enbarr完全消除第三方工具依赖。", "zh-TW": "Enbarr完全消除第三方工具依賴。", "de": "Enbarr eliminiert Drittanbieter-Tool-Abhängigkeiten vollständig.", "ar": "Enbarr يزيل تبعيات أدوات الطرف الثالث بالكامل. مع هندسة المعرفة الصفرية، لا توجد أدوات مورد لاستغلالها كناقل هجوم." },
                "BREACH_JP_CAPCOM_NAME": { "en": "Capcom Ransomware Attack", "ja": "カプコン ランサムウェア攻撃", "es": "Ataque Ransomware a Capcom", "fr": "Attaque Ransomware Capcom", "zh": "卡普空勒索软件攻击", "zh-TW": "卡普空勒索軟體攻擊", "de": "Capcom Ransomware-Angriff", "ar": "هجوم فيروس الفدية على Capcom" },
                "BREACH_JP_CAPCOM_DATE": { "en": "November 2020", "ja": "2020年11月", "es": "Noviembre 2020", "fr": "Novembre 2020", "zh": "2020年11月", "zh-TW": "2020年11月", "de": "November 2020", "ar": "نوفمبر 2020" },
                "BREACH_JP_CAPCOM_SECTOR": { "en": "Gaming / Entertainment", "ja": "ゲーム / エンターテインメント", "es": "Videojuegos / Entretenimiento", "fr": "Jeux vidéo / Divertissement", "zh": "游戏 / 娱乐", "zh-TW": "遊戲 / 娛樂", "de": "Gaming / Unterhaltung", "ar": "الألعاب / الترفيه" },
                "BREACH_JP_CAPCOM_RECORDS": { "en": "390,000 personal records, unreleased game data", "ja": "39万件の個人情報、未公開ゲームデータ", "es": "390,000 registros personales, datos de juegos no publicados", "fr": "390 000 dossiers personnels, données de jeux non publiés", "zh": "390,000条个人记录，未发布的游戏数据", "zh-TW": "390,000條個人記錄，未釋出的遊戲資料", "de": "390.000 persönliche Datensätze, unveröffentlichte Spieldaten", "ar": "390,000 سجل شخصي، بيانات ألعاب غير مُصدرة" },
                "BREACH_JP_CAPCOM_WHAT": { "en": "Ragnar Locker ransomware infiltrated through an old VPN device at a North American subsidiary. Attackers exfiltrated 1TB of data before deploying encryption.", "ja": "Ragnar Lockerランサムウェアが北米子会社の古いVPN機器を通じて侵入。攻撃者は暗号化を展開する前に1TBのデータを窃取。", "es": "El ransomware Ragnar Locker se infiltró a través de un dispositivo VPN antiguo.", "fr": "Le ransomware Ragnar Locker s'est infiltré via un ancien dispositif VPN.", "zh": "Ragnar Locker勒索软件通过北美子公司的旧VPN设备渗透。", "zh-TW": "Ragnar Locker勒索軟體透過北美子公司的舊VPN裝置滲透。", "de": "Ragnar Locker Ransomware infiltrierte über ein altes VPN-Gerät einer nordamerikanischen Tochtergesellschaft.", "ar": "تسلل فيروس الفدية Ragnar Locker عبر جهاز VPN قديم في فرع أمريكا الشمالية. سرّب المهاجمون 1 تيرابايت من البيانات قبل نشر التشفير." },
                "BREACH_JP_CAPCOM_VENDOR": { "en": "The legacy VPN device from a third-party vendor was end-of-life and unpatched. Vendor dependency on obsolete hardware created the vulnerability.", "ja": "サードパーティベンダーのレガシーVPN機器はサポート終了でパッチ未適用。旧式ハードウェアへのベンダー依存が脆弱性を生み出しました。", "es": "El dispositivo VPN heredado de un proveedor externo estaba sin soporte y sin parches.", "fr": "Le dispositif VPN hérité d'un fournisseur tiers était en fin de vie et non corrigé.", "zh": "第三方供应商的旧VPN设备已停产且未修补。", "zh-TW": "第三方供應商的舊VPN裝置已停產且未修補。", "de": "Das Legacy-VPN-Gerät eines Drittanbieters war am End-of-Life und ungepatcht.", "ar": "جهاز VPN القديم من مورد خارجي كان منتهي الصلاحية وغير مُصلح. الاعتماد على أجهزة قديمة من المورد خلق الثغرة." },
                "BREACH_JP_CAPCOM_PREVENT": { "en": "Enbarr's behavioral detection would have flagged the anomalous data exfiltration patterns — 1TB of outbound data — within minutes, triggering containment before encryption deployment.", "ja": "Enbarrの行動検知は、異常なデータ窃取パターン（1TBの送信データ）を数分以内にフラグし、暗号化展開前に封じ込めをトリガーしていたでしょう。", "es": "La detección conductual de Enbarr habría marcado los patrones anómalos de exfiltración de datos.", "fr": "La détection comportementale d'Enbarr aurait signalé les schémas d'exfiltration anormaux.", "zh": "Enbarr的行为检测会在几分钟内标记异常的数据外泄模式。", "zh-TW": "Enbarr的行為檢測會在幾分鐘內標記異常的資料外洩模式。", "de": "Enbarrs Verhaltenserkennung hätte die anomalen Datenexfiltrationsmuster erkannt.", "ar": "كشف Enbarr السلوكي كان سيرصد أنماط تسريب البيانات الشاذة — 1 تيرابايت من البيانات الصادرة — في دقائق، مُطلقاً الاحتواء قبل نشر التشفير." },
                "BREACH_JP_NTT_NAME": { "en": "NTT Communications Breach", "ja": "NTTコミュニケーションズ 侵害", "es": "Brecha de NTT Communications", "fr": "Violation NTT Communications", "zh": "NTT通信数据泄露", "zh-TW": "NTT通訊資料外洩", "de": "NTT Communications Breach", "ar": "اختراق NTT Communications" },
                "BREACH_JP_NTT_DATE": { "en": "February 2020", "ja": "2020年2月", "es": "Febrero 2020", "fr": "Février 2020", "zh": "2020年2月", "zh-TW": "2020年2月", "de": "Februar 2020", "ar": "فبراير 2020" },
                "BREACH_JP_NTT_SECTOR": { "en": "Telecommunications", "ja": "通信", "es": "Telecomunicaciones", "fr": "Télécommunications", "zh": "电信", "zh-TW": "電信", "de": "Telekommunikation", "ar": "الاتصالات" },
                "BREACH_JP_NTT_RECORDS": { "en": "621 enterprise customers' data, including military contracts", "ja": "軍事契約を含む621の法人顧客データ", "es": "Datos de 621 clientes empresariales, incluyendo contratos militares", "fr": "Données de 621 clients entreprise, y compris des contrats militaires", "zh": "621家企业客户的数据，包括军事合同", "zh-TW": "621家企業客戶的資料，包括軍事合同", "de": "Daten von 621 Unternehmenskunden, einschließlich Militärverträge", "ar": "بيانات 621 عميل مؤسسي، بما في ذلك عقود عسكرية" },
                "BREACH_JP_NTT_WHAT": { "en": "Attackers exploited a vulnerability in a third-party cloud service to access NTT's internal Active Directory, then moved laterally to exfiltrate customer data.", "ja": "攻撃者がサードパーティのクラウドサービスの脆弱性を悪用してNTTの内部Active Directoryにアクセスし、横方向に移動して顧客データを窃取。", "es": "Los atacantes explotaron una vulnerabilidad en un servicio en la nube de terceros.", "fr": "Les attaquants ont exploité une vulnérabilité dans un service cloud tiers.", "zh": "攻击者利用第三方云服务的漏洞访问NTT的内部Active Directory。", "zh-TW": "攻擊者利用第三方雲服務的漏洞訪問NTT的內部Active Directory。", "de": "Angreifer nutzten eine Schwachstelle in einem Drittanbieter-Cloud-Dienst aus.", "ar": "استغل المهاجمون ثغرة في خدمة سحابية لطرف ثالث للوصول إلى Active Directory الداخلي لـ NTT، ثم تحركوا جانبياً لتسريب بيانات العملاء." },
                "BREACH_JP_NTT_VENDOR": { "en": "The third-party cloud service vulnerability provided the initial foothold. NTT's own security couldn't detect the lateral movement through vendor-managed infrastructure.", "ja": "サードパーティクラウドサービスの脆弱性が初期の足がかりを提供。NTT自身のセキュリティはベンダー管理のインフラを通じた横方向移動を検知できませんでした。", "es": "La vulnerabilidad del servicio en la nube de terceros proporcionó el punto de apoyo inicial.", "fr": "La vulnérabilité du service cloud tiers a fourni le point d'appui initial.", "zh": "第三方云服务漏洞提供了初始立足点。", "zh-TW": "第三方雲服務漏洞提供了初始立足點。", "de": "Die Schwachstelle des Drittanbieter-Cloud-Dienstes bot den ersten Fußpunkt.", "ar": "ثغرة خدمة السحابة الخارجية وفّرت موطئ القدم الأولي. أمان NTT لم يتمكن من كشف الحركة الجانبية عبر البنية التحتية المُدارة من المورد." },
                "BREACH_JP_NTT_PREVENT": { "en": "With Enbarr's distributed mesh and kernel-level monitoring, the lateral movement would have been detected at the first hop, with autonomous containment preventing data exfiltration.", "ja": "Enbarrの分散メッシュとカーネルレベルの監視により、最初のホップで横方向移動が検知され、自律的な封じ込めによりデータ窃取が防止されていたでしょう。", "es": "Con la malla distribuida de Enbarr, el movimiento lateral habría sido detectado en el primer salto.", "fr": "Avec le maillage distribué d'Enbarr, le mouvement latéral aurait été détecté au premier saut.", "zh": "通过Enbarr的分布式网格和内核级监控，横向移动会在第一跳被检测到。", "zh-TW": "透過Enbarr的分散式網格和核心層級監控，橫向移動會在第一跳被檢測到。", "de": "Mit Enbarrs verteiltem Mesh wäre die Seitwärtsbewegung beim ersten Hop erkannt worden.", "ar": "مع شبكة Enbarr الموزّعة والمراقبة على مستوى النواة، كانت الحركة الجانبية ستُكتشف عند أول قفزة، مع احتواء ذاتي يمنع تسريب البيانات." },
                "BREACH_WHAT_HAPPENED": { "en": "What Happened", "ja": "何が起きたか", "es": "Qué Sucedió", "fr": "Que S'est-il Passé", "zh": "发生了什么", "zh-TW": "發生了什麼", "de": "Was Passierte", "ar": "ما الذي حدث" },
                "BREACH_VENDOR_ANGLE": { "en": "The Vendor Angle", "ja": "ベンダー依存の問題点", "es": "El Ángulo del Proveedor", "fr": "L'Angle Fournisseur", "zh": "供应商角度", "zh-TW": "供應商角度", "de": "Der Anbieter-Aspekt", "ar": "زاوية المورد" },
                "BREACH_ENBARR_PREVENTS": { "en": "How Enbarr Prevents This", "ja": "Enbarrならどう防げたか", "es": "Cómo Enbarr Previene Esto", "fr": "Comment Enbarr Prévient Cela", "zh": "Enbarr如何防止此类事件", "zh-TW": "Enbarr如何防止此類事件", "de": "Wie Enbarr Dies Verhindert", "ar": "كيف يمنع Enbarr هذا" },
                "BREACH_REGION_GLOBAL": { "en": "Global", "ja": "グローバル", "es": "Global", "fr": "Mondial", "zh": "全球", "zh-TW": "全球", "de": "Global", "ar": "عالمي" },
                "BREACH_GL_SOLARWINDS_NAME": { "en": "SolarWinds SUNBURST", "ja": "SolarWinds SUNBURST", "es": "SolarWinds SUNBURST", "fr": "SolarWinds SUNBURST", "zh": "SolarWinds SUNBURST", "zh-TW": "SolarWinds SUNBURST", "de": "SolarWinds SUNBURST", "ar": "SolarWinds SUNBURST" },
                "BREACH_GL_SOLARWINDS_DATE": { "en": "December 2020", "ja": "2020年12月", "es": "Diciembre 2020", "fr": "Décembre 2020", "zh": "2020年12月", "zh-TW": "2020年12月", "de": "Dezember 2020", "ar": "ديسمبر 2020" },
                "BREACH_GL_SOLARWINDS_SECTOR": { "en": "Government / Enterprise", "ja": "政府 / 企業", "es": "Gobierno / Empresa", "fr": "Gouvernement / Entreprise", "zh": "政府 / 企业", "zh-TW": "政府 / 企業", "de": "Regierung / Unternehmen", "ar": "الحكومة / المؤسسات" },
                "BREACH_GL_SOLARWINDS_RECORDS": { "en": "18,000+ organizations including US federal agencies", "ja": "米国連邦機関を含む18,000以上の組織", "es": "18,000+ organizaciones incluyendo agencias federales de EE.UU.", "fr": "18 000+ organisations dont des agences fédérales américaines", "zh": "18,000+组织，包括美国联邦机构", "zh-TW": "18,000+組織，包括美國聯邦機構", "de": "18.000+ Organisationen einschließlich US-Bundesbehörden", "ar": "18,000+ مؤسسة بما في ذلك وكالات فيدرالية أمريكية" },
                "BREACH_GL_SOLARWINDS_WHAT": { "en": "Nation-state actors injected a backdoor into SolarWinds' Orion software update. Every organization that installed the update was compromised.", "ja": "国家アクターがSolarWindsのOrionソフトウェアアップデートにバックドアを注入。アップデートをインストールしたすべての組織が侵害されました。", "es": "Actores estatales inyectaron una puerta trasera en la actualización del software Orion de SolarWinds.", "fr": "Des acteurs étatiques ont injecté une porte dérobée dans la mise à jour du logiciel Orion de SolarWinds.", "zh": "国家行为者在SolarWinds的Orion软件更新中注入后门。", "zh-TW": "國家行為者在SolarWinds的Orion軟體更新中注入後門。", "de": "Staatliche Akteure injizierten eine Hintertür in das SolarWinds Orion Software-Update.", "ar": "حقن ممثلون تابعون لدولة باباً خلفياً في تحديث برنامج Orion لـ SolarWinds. كل مؤسسة ثبّتت التحديث تعرضت للاختراق." },
                "BREACH_GL_SOLARWINDS_VENDOR": { "en": "The trusted software vendor's update mechanism became the attack vector. Organizations trusted the vendor's supply chain — and that trust was weaponized.", "ja": "信頼されたソフトウェアベンダーのアップデートメカニズムが攻撃ベクトルに。組織はベンダーのサプライチェーンを信頼し、その信頼が武器化されました。", "es": "El mecanismo de actualización del proveedor de software de confianza se convirtió en el vector de ataque.", "fr": "Le mécanisme de mise à jour du fournisseur de confiance est devenu le vecteur d'attaque.", "zh": "受信任的软件供应商的更新机制成为攻击向量。", "zh-TW": "受信任的軟體供應商的更新機制成為攻擊向量。", "de": "Der Update-Mechanismus des vertrauenswürdigen Software-Anbieters wurde zum Angriffsvektor.", "ar": "آلية التحديث لمورد البرمجيات الموثوق أصبحت ناقل الهجوم. وثقت المؤسسات في سلسلة توريد المورد — وتم تسليح تلك الثقة." },
                "BREACH_GL_SOLARWINDS_PREVENT": { "en": "Enbarr has zero third-party software dependencies. No vendor updates to compromise. Behavioral detection at the kernel level would have flagged SUNBURST's C2 communications immediately.", "ja": "Enbarrにはサードパーティソフトウェアの依存がゼロ。侵害されるベンダーアップデートなし。カーネルレベルの行動検知がSUNBURSTのC2通信を即座にフラグしていたでしょう。", "es": "Enbarr tiene cero dependencias de software de terceros. La detección conductual habría marcado las comunicaciones C2.", "fr": "Enbarr n'a aucune dépendance logicielle tierce. La détection comportementale aurait signalé les communications C2.", "zh": "Enbarr零第三方软件依赖。内核级行为检测会立即标记SUNBURST的C2通信。", "zh-TW": "Enbarr零第三方軟體依賴。核心層級行為檢測會立即標記SUNBURST的C2通訊。", "de": "Enbarr hat null Drittanbieter-Software-Abhängigkeiten. Keine Vendor-Updates zu kompromittieren.", "ar": "Enbarr ليس لديه أي تبعيات برمجيات خارجية. لا تحديثات مورد للاختراق. الكشف السلوكي على مستوى النواة كان سيرصد اتصالات C2 لـ SUNBURST فوراً." },
                "BREACH_GL_MOVEIT_NAME": { "en": "MOVEit Transfer", "ja": "MOVEit Transfer", "es": "MOVEit Transfer", "fr": "MOVEit Transfer", "zh": "MOVEit Transfer", "zh-TW": "MOVEit Transfer", "de": "MOVEit Transfer", "ar": "MOVEit Transfer" },
                "BREACH_GL_MOVEIT_DATE": { "en": "May 2023", "ja": "2023年5月", "es": "Mayo 2023", "fr": "Mai 2023", "zh": "2023年5月", "zh-TW": "2023年5月", "de": "Mai 2023", "ar": "مايو 2023" },
                "BREACH_GL_MOVEIT_SECTOR": { "en": "Cross-industry", "ja": "業界横断", "es": "Multi-industria", "fr": "Multi-industrie", "zh": "跨行业", "zh-TW": "跨行業", "de": "Branchenübergreifend", "ar": "متعدد القطاعات" },
                "BREACH_GL_MOVEIT_RECORDS": { "en": "2,500+ organizations, 65M+ individuals", "ja": "2,500以上の組織、6,500万以上の個人", "es": "2,500+ organizaciones, 65M+ individuos", "fr": "2 500+ organisations, 65M+ individus", "zh": "2,500+组织，6,500万+个人", "zh-TW": "2,500+組織，6,500萬+個人", "de": "2.500+ Organisationen, 65M+ Personen", "ar": "2,500+ مؤسسة، 65 مليون+ فرد" },
                "BREACH_GL_MOVEIT_WHAT": { "en": "Cl0p ransomware gang exploited a zero-day SQL injection in MOVEit Transfer, a widely-used managed file transfer tool, to steal data from thousands of organizations.", "ja": "Cl0pランサムウェアギャングが広く使用されているマネージドファイル転送ツール、MOVEit TransferのゼロデイSQL インジェクションを悪用し、数千の組織からデータを窃取。", "es": "La banda Cl0p explotó una inyección SQL zero-day en MOVEit Transfer.", "fr": "Le gang Cl0p a exploité une injection SQL zero-day dans MOVEit Transfer.", "zh": "Cl0p勒索软件团伙利用MOVEit Transfer中的零日SQL注入漏洞。", "zh-TW": "Cl0p勒索軟體團伙利用MOVEit Transfer中的零日SQL隱碼攻擊漏洞。", "de": "Die Cl0p-Ransomware-Gruppe nutzte eine Zero-Day SQL-Injection in MOVEit Transfer aus.", "ar": "استغلت عصابة Cl0p لبرمجيات الفدية ثغرة يوم صفر لحقن SQL في MOVEit Transfer، أداة نقل ملفات مُدارة واسعة الاستخدام، لسرقة بيانات آلاف المؤسسات." },
                "BREACH_GL_MOVEIT_VENDOR": { "en": "A single vendor's file transfer tool exposed thousands of organizations. Every customer of MOVEit was affected by one vendor's vulnerability.", "ja": "1つのベンダーのファイル転送ツールが数千の組織を露出。MOVEitのすべての顧客が1つのベンダーの脆弱性の影響を受けました。", "es": "La herramienta de transferencia de archivos de un solo proveedor expuso a miles de organizaciones.", "fr": "L'outil de transfert de fichiers d'un seul fournisseur a exposé des milliers d'organisations.", "zh": "单一供应商的文件传输工具暴露了数千家组织。", "zh-TW": "單一供應商的檔案傳輸工具暴露了數千家組織。", "de": "Das Dateitransfer-Tool eines einzigen Anbieters exponierte Tausende Organisationen.", "ar": "أداة نقل ملفات مورد واحد كشفت آلاف المؤسسات. كل عميل MOVEit تأثر بثغرة مورد واحد." },
                "BREACH_GL_MOVEIT_PREVENT": { "en": "Enbarr replaces third-party file transfer tools entirely. With zero vendor dependencies, there's no shared vulnerability to exploit across your organization.", "ja": "Enbarrはサードパーティのファイル転送ツールを完全に置き換え。ベンダー依存がゼロのため、組織全体で悪用される共有脆弱性がありません。", "es": "Enbarr reemplaza las herramientas de transferencia de archivos de terceros por completo.", "fr": "Enbarr remplace entièrement les outils de transfert de fichiers tiers.", "zh": "Enbarr完全替换第三方文件传输工具。", "zh-TW": "Enbarr完全替換第三方檔案傳輸工具。", "de": "Enbarr ersetzt Drittanbieter-Dateitransfer-Tools vollständig.", "ar": "Enbarr يحل محل أدوات نقل الملفات الخارجية بالكامل. مع صفر تبعيات مورد، لا توجد ثغرة مشتركة لاستغلالها عبر مؤسستك." },
                "BREACH_GL_KASEYA_NAME": { "en": "Kaseya VSA Attack", "ja": "Kaseya VSA 攻撃", "es": "Ataque Kaseya VSA", "fr": "Attaque Kaseya VSA", "zh": "Kaseya VSA攻击", "zh-TW": "Kaseya VSA攻擊", "de": "Kaseya VSA Angriff", "ar": "هجوم Kaseya VSA" },
                "BREACH_GL_KASEYA_DATE": { "en": "July 2021", "ja": "2021年7月", "es": "Julio 2021", "fr": "Juillet 2021", "zh": "2021年7月", "zh-TW": "2021年7月", "de": "Juli 2021", "ar": "يوليو 2021" },
                "BREACH_GL_KASEYA_SECTOR": { "en": "Managed Service Providers", "ja": "マネージドサービスプロバイダー", "es": "Proveedores de Servicios Gestionados", "fr": "Fournisseurs de Services Gérés", "zh": "托管服务提供商", "zh-TW": "託管服務提供商", "de": "Managed Service Provider", "ar": "مزودو الخدمات المُدارة" },
                "BREACH_GL_KASEYA_RECORDS": { "en": "1,500+ businesses via 60 MSPs", "ja": "60のMSP経由で1,500以上の企業", "es": "1,500+ empresas a través de 60 MSPs", "fr": "1 500+ entreprises via 60 MSP", "zh": "通过60个MSP影响1,500+企业", "zh-TW": "透過60個MSP影響1,500+企業", "de": "1.500+ Unternehmen über 60 MSPs", "ar": "1,500+ شركة عبر 60 MSP" },
                "BREACH_GL_KASEYA_WHAT": { "en": "REvil ransomware exploited zero-day vulnerabilities in Kaseya VSA (a remote management tool) to push ransomware through MSPs to their downstream customers.", "ja": "REvilランサムウェアがKaseya VSA（リモート管理ツール）のゼロデイ脆弱性を悪用し、MSPを通じて下流の顧客にランサムウェアを配布。", "es": "REvil explotó vulnerabilidades zero-day en Kaseya VSA para distribuir ransomware a través de MSPs.", "fr": "REvil a exploité des vulnérabilités zero-day dans Kaseya VSA pour distribuer un ransomware via les MSP.", "zh": "REvil勒索软件利用Kaseya VSA中的零日漏洞通过MSP向下游客户推送勒索软件。", "zh-TW": "REvil勒索軟體利用Kaseya VSA中的零日漏洞透過MSP向下遊客戶推送勒索軟體。", "de": "REvil nutzte Zero-Day-Schwachstellen in Kaseya VSA aus, um Ransomware über MSPs zu verbreiten.", "ar": "استغلت برمجيات الفدية REvil ثغرات يوم صفر في Kaseya VSA (أداة إدارة عن بُعد) لنشر برمجيات الفدية عبر مزودي الخدمات المُدارة إلى عملائهم." },
                "BREACH_GL_KASEYA_VENDOR": { "en": "The RMM vendor's tool — designed to manage and protect endpoints — became the weapon that attacked them. Trust in the management platform was weaponized.", "ja": "エンドポイントを管理・保護するために設計されたRMMベンダーのツールが、それらを攻撃する武器に。管理プラットフォームへの信頼が武器化されました。", "es": "La herramienta del proveedor RMM — diseñada para proteger endpoints — se convirtió en el arma.", "fr": "L'outil du fournisseur RMM — conçu pour protéger les endpoints — est devenu l'arme.", "zh": "RMM供应商的工具——旨在管理和保护端点——成为攻击它们的武器。", "zh-TW": "RMM供應商的工具——旨在管理和保護端點裝置——成為攻擊它們的武器。", "de": "Das RMM-Tool des Anbieters — zum Schutz von Endpunkten konzipiert — wurde zur Waffe.", "ar": "أداة مورد RMM — المصممة لإدارة وحماية نقاط النهاية — أصبحت السلاح الذي هاجمها. تم تسليح الثقة في منصة الإدارة." },
                "BREACH_GL_KASEYA_PREVENT": { "en": "Enbarr replaces RMM tools entirely. With built-in endpoint management and no third-party agents, there's no vendor tool to weaponize against your fleet.", "ja": "EnbarrはRMMツールを完全に置き換え。組み込みのエンドポイント管理とサードパーティエージェントなしで、フリートに対して武器化されるベンダーツールがありません。", "es": "Enbarr reemplaza las herramientas RMM por completo.", "fr": "Enbarr remplace entièrement les outils RMM.", "zh": "Enbarr完全替换RMM工具。", "zh-TW": "Enbarr完全替換RMM工具。", "de": "Enbarr ersetzt RMM-Tools vollständig.", "ar": "Enbarr يحل محل أدوات RMM بالكامل. مع إدارة نقاط نهاية مدمجة وبدون وكلاء خارجيين، لا توجد أداة مورد لتسليحها ضد أسطولك." },
                "BREACH_GL_OKTA_NAME": { "en": "Okta Support Breach", "ja": "Okta サポート侵害", "es": "Brecha de Soporte de Okta", "fr": "Violation Support Okta", "zh": "Okta支持系统泄露", "zh-TW": "Okta支援系統洩露", "de": "Okta Support Breach", "ar": "اختراق دعم Okta" },
                "BREACH_GL_OKTA_DATE": { "en": "October 2023", "ja": "2023年10月", "es": "Octubre 2023", "fr": "Octobre 2023", "zh": "2023年10月", "zh-TW": "2023年10月", "de": "Oktober 2023", "ar": "أكتوبر 2023" },
                "BREACH_GL_OKTA_SECTOR": { "en": "Identity / Authentication", "ja": "アイデンティティ / 認証", "es": "Identidad / Autenticación", "fr": "Identité / Authentification", "zh": "身份 / 认证", "zh-TW": "身份 / 認證", "de": "Identität / Authentifizierung", "ar": "الهوية / المصادقة" },
                "BREACH_GL_OKTA_RECORDS": { "en": "All customer support system users' data", "ja": "すべてのカスタマーサポートシステムユーザーのデータ", "es": "Datos de todos los usuarios del sistema de soporte", "fr": "Données de tous les utilisateurs du système de support", "zh": "所有客户支持系统用户的数据", "zh-TW": "所有客戶支援系統使用者的資料", "de": "Daten aller Kunden-Support-System-Benutzer", "ar": "بيانات جميع مستخدمي نظام دعم العملاء" },
                "BREACH_GL_OKTA_WHAT": { "en": "Attackers compromised Okta's support case management system using stolen credentials, accessing customer-uploaded HAR files containing session tokens.", "ja": "攻撃者が盗まれた資格情報を使用してOktaのサポートケース管理システムを侵害し、セッショントークンを含む顧客アップロードのHARファイルにアクセス。", "es": "Los atacantes comprometieron el sistema de gestión de soporte de Okta usando credenciales robadas.", "fr": "Les attaquants ont compromis le système de gestion de support d'Okta avec des identifiants volés.", "zh": "攻击者使用被盗凭证侵入Okta的支持案例管理系统。", "zh-TW": "攻擊者使用被盜憑證侵入Okta的支援案例管理系統。", "de": "Angreifer kompromittierten Oktas Support-Fallmanagementsystem mit gestohlenen Zugangsdaten.", "ar": "اخترق المهاجمون نظام إدارة حالات دعم Okta باستخدام بيانات اعتماد مسروقة، ووصلوا إلى ملفات HAR المرفوعة من العملاء والتي تحتوي على رموز الجلسات." },
                "BREACH_GL_OKTA_VENDOR": { "en": "The identity vendor — whose entire purpose is security — became the breach vector. Customers who trusted Okta for authentication had their trust exploited.", "ja": "セキュリティが全目的であるアイデンティティベンダーが侵害ベクトルに。認証のためにOktaを信頼した顧客の信頼が悪用されました。", "es": "El proveedor de identidad — cuyo propósito es la seguridad — se convirtió en el vector de brecha.", "fr": "Le fournisseur d'identité — dont le but est la sécurité — est devenu le vecteur de violation.", "zh": "身份供应商——其全部目的就是安全——成为了泄露向量。", "zh-TW": "身份供應商——其全部目的就是安全——成為了洩露向量。", "de": "Der Identity-Anbieter — dessen Zweck die Sicherheit ist — wurde zum Breach-Vektor.", "ar": "مورد الهوية — الذي هدفه الوحيد هو الأمان — أصبح ناقل الاختراق. العملاء الذين وثقوا بـ Okta للمصادقة تم استغلال ثقتهم." },
                "BREACH_GL_OKTA_PREVENT": { "en": "Enbarr's zero-knowledge architecture means no customer data flows through vendor systems. Your authentication data stays on your infrastructure, eliminating this class of vendor breach.", "ja": "Enbarrのゼロ知識アーキテクチャは、顧客データがベンダーシステムを通過しないことを意味します。認証データはお客様のインフラに留まり、このクラスのベンダー侵害を排除します。", "es": "La arquitectura de conocimiento cero de Enbarr significa que ningún dato fluye a través de sistemas de proveedores.", "fr": "L'architecture connaissance zéro d'Enbarr signifie qu'aucune donnée ne transite par les systèmes fournisseurs.", "zh": "Enbarr的零知识架构意味着没有客户数据流经供应商系统。", "zh-TW": "Enbarr的零信任架構意味著沒有客戶資料流經供應商系統。", "de": "Enbarrs Zero-Knowledge-Architektur bedeutet, dass keine Kundendaten durch Anbietersysteme fließen.", "ar": "هندسة Enbarr ذات المعرفة الصفرية تعني أن بيانات العملاء لا تمر عبر أنظمة المورد. بيانات المصادقة تبقى على بنيتك التحتية، مما يزيل هذا النوع من اختراقات الموردين." },
                "BREACH_GL_CHANGE_NAME": { "en": "Change Healthcare Attack", "ja": "Change Healthcare 攻撃", "es": "Ataque a Change Healthcare", "fr": "Attaque Change Healthcare", "zh": "Change Healthcare攻击", "zh-TW": "Change Healthcare攻擊", "de": "Change Healthcare Angriff", "ar": "هجوم Change Healthcare" },
                "BREACH_GL_CHANGE_DATE": { "en": "February 2024", "ja": "2024年2月", "es": "Febrero 2024", "fr": "Février 2024", "zh": "2024年2月", "zh-TW": "2024年2月", "de": "Februar 2024", "ar": "فبراير 2024" },
                "BREACH_GL_CHANGE_SECTOR": { "en": "Healthcare / Insurance", "ja": "医療 / 保険", "es": "Salud / Seguros", "fr": "Santé / Assurance", "zh": "医疗 / 保险", "zh-TW": "醫療 / 保險", "de": "Gesundheit / Versicherung", "ar": "الرعاية الصحية / التأمين" },
                "BREACH_GL_CHANGE_RECORDS": { "en": "100M+ patient records, $22B+ estimated impact", "ja": "1億以上の患者記録、推定220億ドル以上の影響", "es": "100M+ registros de pacientes, impacto estimado $22B+", "fr": "100M+ dossiers patients, impact estimé 22B$+", "zh": "1亿+患者记录，估计影响220亿美元+", "zh-TW": "1億+患者記錄，估計影響220億美元+", "de": "100M+ Patientendaten, geschätzter Schaden 22B$+", "ar": "100 مليون+ سجل مريض، أثر تقديري 22 مليار$+" },
                "BREACH_GL_CHANGE_WHAT": { "en": "ALPHV/BlackCat ransomware breached Change Healthcare via compromised Citrix remote access credentials. Disrupted pharmacy and insurance claims processing nationwide for weeks.", "ja": "ALPHV/BlackCatランサムウェアが侵害されたCitrixリモートアクセス資格情報を通じてChange Healthcareを侵害。薬局と保険請求処理が全国で数週間にわたり混乱。", "es": "ALPHV/BlackCat ransomware vulneró Change Healthcare a través de credenciales Citrix comprometidas.", "fr": "ALPHV/BlackCat a pénétré Change Healthcare via des identifiants Citrix compromis.", "zh": "ALPHV/BlackCat勒索软件通过被泄露的Citrix远程访问凭证侵入Change Healthcare。", "zh-TW": "ALPHV/BlackCat勒索軟體透過被洩露的Citrix遠端訪問憑證侵入Change Healthcare。", "de": "ALPHV/BlackCat Ransomware kompromittierte Change Healthcare über gestohlene Citrix-Zugangsdaten.", "ar": "اخترقت برمجيات الفدية ALPHV/BlackCat Change Healthcare عبر بيانات اعتماد Citrix المخترقة للوصول عن بُعد. عطّلت معالجة مطالبات الصيدليات والتأمين على مستوى البلاد لأسابيع." },
                "BREACH_GL_CHANGE_VENDOR": { "en": "Citrix remote access — a third-party vendor tool — provided the entry point. Change Healthcare's concentration as a single vendor processing 40% of US claims amplified the national impact.", "ja": "サードパーティベンダーツールのCitrixリモートアクセスが侵入口を提供。米国の請求の40%を処理する単一ベンダーとしてのChange Healthcareの集中が国家的影響を増幅。", "es": "Citrix remote access — una herramienta de terceros — proporcionó el punto de entrada.", "fr": "L'accès distant Citrix — un outil tiers — a fourni le point d'entrée.", "zh": "Citrix远程访问——第三方供应商工具——提供了入口点。", "zh-TW": "Citrix遠端訪問——第三方供應商工具——提供了入口點。", "de": "Citrix Remote Access — ein Drittanbieter-Tool — bot den Einstiegspunkt.", "ar": "Citrix للوصول عن بُعد — أداة مورد خارجي — وفّرت نقطة الدخول. تركّز Change Healthcare كمورد واحد يعالج 40% من المطالبات الأمريكية ضاعف الأثر الوطني." },
                "BREACH_GL_CHANGE_PREVENT": { "en": "Enbarr eliminates remote access tool dependencies. With encrypted P2P mesh connectivity and kernel-level behavioral monitoring, compromised credentials are detected and contained in seconds.", "ja": "Enbarrはリモートアクセスツールの依存を排除。暗号化P2Pメッシュ接続とカーネルレベルの行動監視により、侵害された資格情報が数秒で検知・封じ込められます。", "es": "Enbarr elimina las dependencias de herramientas de acceso remoto.", "fr": "Enbarr élimine les dépendances aux outils d'accès distant.", "zh": "Enbarr消除远程访问工具依赖。", "zh-TW": "Enbarr消除遠端訪問工具依賴。", "de": "Enbarr eliminiert Abhängigkeiten von Remote-Access-Tools.", "ar": "Enbarr يزيل تبعيات أدوات الوصول عن بُعد. مع اتصال شبكة P2P مشفر ومراقبة سلوكية على مستوى النواة، يتم كشف واحتواء بيانات الاعتماد المخترقة في ثوانٍ." },
                "BREACH_PATTERN_BADGE": { "en": "THE PATTERN", "ja": "パターン", "es": "EL PATRÓN", "fr": "LE SCHÉMA", "zh": "规律", "zh-TW": "規律", "de": "DAS MUSTER", "ar": "النمط" },
                "BREACH_PATTERN_TITLE": { "en": "The Third-Party Problem", "ja": "サードパーティの問題", "es": "El Problema de Terceros", "fr": "Le Problème des Tiers", "zh": "第三方问题", "zh-TW": "第三方問題", "de": "Das Drittanbieter-Problem", "ar": "مشكلة الطرف الثالث" },
                "BREACH_PATTERN_DESC": { "en": "Every breach above shares the same root cause. The pattern is clear — and the solution is architectural.", "ja": "上記のすべての侵害は同じ根本原因を共有しています。パターンは明確で、解決策はアーキテクチャにあります。", "es": "Cada brecha comparte la misma causa raíz. El patrón es claro.", "fr": "Chaque violation partage la même cause racine. Le schéma est clair.", "zh": "上述每次泄露都有相同的根本原因。模式很清楚。", "zh-TW": "上述每次洩露都有相同的根本原因。模式很清楚。", "de": "Jeder Vorfall teilt die gleiche Grundursache. Das Muster ist klar.", "ar": "كل اختراق أعلاه يشترك في نفس السبب الجذري. النمط واضح — والحل هندسي." },
                "BREACH_PATTERN_1_LABEL": { "en": "Trusted Vendor Becomes Attack Vector", "ja": "信頼されたベンダーが攻撃ベクトルに", "es": "Proveedor de Confianza Se Convierte en Vector de Ataque", "fr": "Le Fournisseur de Confiance Devient Vecteur d'Attaque", "zh": "受信任的供应商成为攻击向量", "zh-TW": "受信任的供應商成為攻擊向量", "de": "Vertrauenswürdiger Anbieter wird zum Angriffsvektor", "ar": "المورد الموثوق يصبح ناقل هجوم" },
                "BREACH_PATTERN_1_DESC": { "en": "Organizations trust their vendors implicitly. Attackers exploit that trust to bypass security perimeters.", "ja": "組織はベンダーを暗黙的に信頼。攻撃者はその信頼を悪用してセキュリティ境界を迂回。", "es": "Las organizaciones confían implícitamente en sus proveedores. Los atacantes explotan esa confianza.", "fr": "Les organisations font confiance implicitement à leurs fournisseurs. Les attaquants exploitent cette confiance.", "zh": "组织隐式信任其供应商。攻击者利用这种信任绕过安全边界。", "zh-TW": "組織預設信任其供應商。攻擊者利用這種信任繞過安全邊界。", "de": "Organisationen vertrauen ihren Anbietern implizit. Angreifer nutzen dieses Vertrauen aus.", "ar": "المؤسسات تثق بمورديها ضمنياً. المهاجمون يستغلون تلك الثقة لتجاوز المحيط الأمني." },
                "BREACH_PATTERN_2_LABEL": { "en": "Shared Vulnerability, Massive Blast Radius", "ja": "共有脆弱性、大規模な被害範囲", "es": "Vulnerabilidad Compartida, Radio de Impacto Masivo", "fr": "Vulnérabilité Partagée, Rayon de Dégâts Massif", "zh": "共享漏洞，大规模影响范围", "zh-TW": "共享漏洞，大規模影響範圍", "de": "Geteilte Schwachstelle, Massiver Blast-Radius", "ar": "ثغرة مشتركة، نطاق ضرر هائل" },
                "BREACH_PATTERN_2_DESC": { "en": "When thousands of organizations use the same vendor tool, one vulnerability compromises them all simultaneously.", "ja": "数千の組織が同じベンダーツールを使用する場合、1つの脆弱性がすべてを同時に侵害。", "es": "Cuando miles de organizaciones usan la misma herramienta, una vulnerabilidad las compromete a todas.", "fr": "Quand des milliers d'organisations utilisent le même outil, une vulnérabilité les compromet toutes.", "zh": "当数千个组织使用同一供应商工具时，一个漏洞同时危及所有组织。", "zh-TW": "當數千個組織使用同一供應商工具時，一個漏洞同時危及所有組織。", "de": "Wenn Tausende Organisationen dasselbe Tool nutzen, kompromittiert eine Schwachstelle alle gleichzeitig.", "ar": "عندما تستخدم آلاف المؤسسات نفس أداة المورد، ثغرة واحدة تخترقها جميعاً في وقت واحد." },
                "BREACH_PATTERN_3_LABEL": { "en": "Detection Blind Spots at Vendor Boundaries", "ja": "ベンダー境界での検知の盲点", "es": "Puntos Ciegos de Detección en Límites de Proveedores", "fr": "Angles Morts de Détection aux Frontières Fournisseurs", "zh": "供应商边界的检测盲点", "zh-TW": "供應商邊界的檢測盲點", "de": "Erkennungs-Blindspots an Anbieter-Grenzen", "ar": "نقاط عمياء في الكشف عند حدود المورد" },
                "BREACH_PATTERN_3_DESC": { "en": "Traditional security can't monitor what happens inside vendor-managed tools and infrastructure.", "ja": "従来のセキュリティはベンダー管理のツールやインフラ内で何が起きているかを監視できません。", "es": "La seguridad tradicional no puede monitorear lo que sucede dentro de herramientas gestionadas por proveedores.", "fr": "La sécurité traditionnelle ne peut pas surveiller ce qui se passe dans les outils gérés par les fournisseurs.", "zh": "传统安全无法监控供应商管理的工具和基础设施内部发生的事情。", "zh-TW": "傳統安全無法監控供應商管理的工具和基礎設施內部發生的事情。", "de": "Traditionelle Sicherheit kann nicht überwachen, was in Anbieter-Tools geschieht.", "ar": "الأمان التقليدي لا يمكنه مراقبة ما يحدث داخل أدوات وبنية تحتية يديرها المورد." },
                "BREACH_PATTERN_4_LABEL": { "en": "Slow Detection, Slower Response", "ja": "遅い検知、さらに遅い対応", "es": "Detección Lenta, Respuesta Más Lenta", "fr": "Détection Lente, Réponse Plus Lente", "zh": "检测慢，响应更慢", "zh-TW": "檢測慢，響應更慢", "de": "Langsame Erkennung, Langsamere Reaktion", "ar": "كشف بطيء، استجابة أبطأ" },
                "BREACH_PATTERN_4_DESC": { "en": "Average breach detection takes 277 days. Average response adds 70 more. Attackers have months to operate.", "ja": "平均侵害検知には277日。平均対応にさらに70日。攻撃者は数ヶ月間活動できます。", "es": "La detección promedio toma 277 días. La respuesta promedio agrega 70 más.", "fr": "La détection moyenne prend 277 jours. La réponse moyenne ajoute 70 de plus.", "zh": "平均泄露检测需要277天。平均响应再增加70天。", "zh-TW": "平均洩露檢測需要277天。平均響應再增加70天。", "de": "Durchschnittliche Breach-Erkennung dauert 277 Tage. Reaktion fügt 70 weitere hinzu.", "ar": "متوسط كشف الاختراق يستغرق 277 يوماً. متوسط الاستجابة يضيف 70 يوماً أخرى. المهاجمون لديهم أشهر للعمل." },
                "BREACH_SOLUTION_BADGE": { "en": "THE SOLUTION", "ja": "ソリューション", "es": "LA SOLUCIÓN", "fr": "LA SOLUTION", "zh": "解决方案", "zh-TW": "解決方案", "de": "DIE LÖSUNG", "ar": "الحل" },
                "BREACH_SOLUTION_TITLE": { "en": "How Enbarr Eliminates the Pattern", "ja": "Enbarrがパターンを排除する方法", "es": "Cómo Enbarr Elimina el Patrón", "fr": "Comment Enbarr Élimine le Schéma", "zh": "Enbarr如何消除这种模式", "zh-TW": "Enbarr如何消除這種模式", "de": "Wie Enbarr das Muster Eliminiert", "ar": "كيف يزيل Enbarr النمط" },
                "BREACH_SOLUTION_DESC": { "en": "The answer isn't better vendor management — it's eliminating vendor dependencies entirely.", "ja": "答えはより良いベンダー管理ではなく、ベンダー依存の完全な排除です。", "es": "La respuesta no es mejor gestión de proveedores — es eliminar las dependencias por completo.", "fr": "La réponse n'est pas une meilleure gestion des fournisseurs — c'est éliminer les dépendances entièrement.", "zh": "答案不是更好的供应商管理——而是完全消除供应商依赖。", "zh-TW": "答案不是更好的供應商管理——而是完全消除供應商依賴。", "de": "Die Antwort ist nicht besseres Vendor-Management — sondern die vollständige Eliminierung von Abhängigkeiten.", "ar": "الإجابة ليست إدارة موردين أفضل — إنها إزالة تبعيات الموردين بالكامل." },
                "BREACH_SOL_1_TITLE": { "en": "Zero Third-Party Dependencies", "ja": "サードパーティ依存ゼロ", "es": "Cero Dependencias de Terceros", "fr": "Zéro Dépendances Tierces", "zh": "零第三方依赖", "zh-TW": "零第三方依賴", "de": "Null Drittanbieter-Abhängigkeiten", "ar": "صفر تبعيات أطراف ثالثة" },
                "BREACH_SOL_1_DESC": { "en": "One platform replaces EDR, SIEM, RMM, and UEM. Every vendor removed is an attack surface closed.", "ja": "1つのプラットフォームがEDR、SIEM、RMM、UEMを置き換え。削除するベンダーごとに攻撃面が閉じられます。", "es": "Una plataforma reemplaza EDR, SIEM, RMM y UEM. Cada proveedor eliminado es una superficie de ataque cerrada.", "fr": "Une plateforme remplace EDR, SIEM, RMM et UEM. Chaque fournisseur supprimé est une surface d'attaque fermée.", "zh": "一个平台替换EDR、SIEM、RMM和UEM。每移除一个供应商就关闭一个攻击面。", "zh-TW": "一個平台替換EDR、SIEM、RMM和UEM。每移除一個供應商就關閉一個攻擊面。", "de": "Eine Plattform ersetzt EDR, SIEM, RMM und UEM. Jeder entfernte Anbieter schließt eine Angriffsfläche.", "ar": "منصة واحدة تحل محل EDR وSIEM وRMM وUEM. كل مورد يُزال هو سطح هجوم مغلق." },
                "BREACH_SOL_2_TITLE": { "en": "Kernel-Level Behavioral Detection", "ja": "カーネルレベル行動検知", "es": "Detección Conductual a Nivel de Kernel", "fr": "Détection Comportementale au Niveau du Noyau", "zh": "内核级行为检测", "zh-TW": "核心層級行為檢測", "de": "Kernel-Level Verhaltenserkennung", "ar": "كشف سلوكي على مستوى النواة" },
                "BREACH_SOL_2_DESC": { "en": "No signatures to update, no cloud to depend on. Detects novel attacks by behavior, not known patterns.", "ja": "更新するシグネチャなし、依存するクラウドなし。既知のパターンではなく行動で新しい攻撃を検知。", "es": "Sin firmas que actualizar, sin nube de la que depender. Detecta ataques nuevos por comportamiento.", "fr": "Pas de signatures à mettre à jour, pas de cloud dont dépendre. Détecte les attaques nouvelles par comportement.", "zh": "无需更新签名，无需依赖云。通过行为而非已知模式检测新型攻击。", "zh-TW": "無需更新特徵碼，無需依賴雲。透過行為而非已知模式檢測新型攻擊。", "de": "Keine Signaturen zu aktualisieren, keine Cloud-Abhängigkeit. Erkennt neuartige Angriffe durch Verhalten.", "ar": "لا توقيعات للتحديث، لا سحابة للاعتماد عليها. يكتشف الهجمات الجديدة بالسلوك، وليس بالأنماط المعروفة." },
                "BREACH_SOL_3_TITLE": { "en": "Autonomous Response in Minutes", "ja": "数分での自律対応", "es": "Respuesta Autónoma en Minutos", "fr": "Réponse Autonome en Minutes", "zh": "几分钟内自主响应", "zh-TW": "幾分鐘內自主響應", "de": "Autonome Reaktion in Minuten", "ar": "استجابة ذاتية في دقائق" },
                "BREACH_SOL_3_DESC": { "en": "From detection to containment in under 3 minutes. Not 277 days to detect and 70 days to respond.", "ja": "検知から封じ込めまで3分未満。検知に277日、対応に70日ではありません。", "es": "De la detección a la contención en menos de 3 minutos. No 277 días para detectar.", "fr": "De la détection au confinement en moins de 3 minutes. Pas 277 jours pour détecter.", "zh": "从检测到遏制不到3分钟。不是277天检测和70天响应。", "zh-TW": "從檢測到封鎖控制不到3分鐘。不是277天檢測和70天響應。", "de": "Von Erkennung bis Eindämmung in unter 3 Minuten. Nicht 277 Tage zur Erkennung.", "ar": "من الكشف إلى الاحتواء في أقل من 3 دقائق. ليس 277 يوماً للكشف و70 يوماً للاستجابة." },
                "BREACH_SOL_4_TITLE": { "en": "Zero-Knowledge Architecture", "ja": "ゼロ知識アーキテクチャ", "es": "Arquitectura de Conocimiento Cero", "fr": "Architecture Connaissance Zéro", "zh": "零知识架构", "zh-TW": "零信任架構", "de": "Zero-Knowledge-Architektur", "ar": "هندسة المعرفة الصفرية" },
                "BREACH_SOL_4_DESC": { "en": "Your data never touches vendor infrastructure. No telemetry exfiltration, no cloud processing of your sensitive data.", "ja": "データはベンダーインフラに触れません。テレメトリの窃取なし、機密データのクラウド処理なし。", "es": "Sus datos nunca tocan la infraestructura del proveedor. Sin exfiltración de telemetría.", "fr": "Vos données ne touchent jamais l'infrastructure du fournisseur. Pas d'exfiltration de télémétrie.", "zh": "您的数据永远不会接触供应商基础设施。无遥测数据外泄。", "zh-TW": "您的資料永遠不會接觸供應商基礎設施。無監控資料資料外洩。", "de": "Ihre Daten berühren nie die Anbieter-Infrastruktur. Keine Telemetrie-Exfiltration.", "ar": "بياناتك لا تلمس بنية مورد تحتية أبداً. لا تسريب للقياس عن بُعد، لا معالجة سحابية لبياناتك الحساسة." },
                "BREACH_SOL_5_TITLE": { "en": "Distributed Mesh Intelligence", "ja": "分散メッシュインテリジェンス", "es": "Inteligencia de Malla Distribuida", "fr": "Intelligence de Maillage Distribuée", "zh": "分布式网格智能", "zh-TW": "分散式網格智慧", "de": "Verteilte Mesh-Intelligenz", "ar": "ذكاء شبكة Mesh موزّع" },
                "BREACH_SOL_5_DESC": { "en": "Every node in your fleet shares threat intelligence. No central server to compromise, no single point of failure.", "ja": "フリート内のすべてのノードが脅威インテリジェンスを共有。侵害される中央サーバーなし、単一障害点なし。", "es": "Cada nodo comparte inteligencia de amenazas. Sin servidor central que comprometer.", "fr": "Chaque nœud partage le renseignement sur les menaces. Pas de serveur central à compromettre.", "zh": "您设备群中的每个节点共享威胁情报。无需妥协的中央服务器。", "zh-TW": "您裝置群中的每個節點共享威脅情報。無需妥協的中央伺服器。", "de": "Jeder Knoten teilt Bedrohungsintelligenz. Kein zentraler Server zu kompromittieren.", "ar": "كل عقدة في أسطولك تشارك استخبارات التهديدات. لا خادم مركزي للاختراق، لا نقطة فشل فردية." },
                "BREACH_CTA_TITLE": { "en": "Don't Be the Next Case Study.", "ja": "次の事例にならないでください。", "es": "No Sea el Próximo Caso de Estudio.", "fr": "Ne Soyez Pas la Prochaine Étude de Cas.", "zh": "不要成为下一个案例研究。", "zh-TW": "不要成為下一個案例研究。", "de": "Werden Sie Nicht die Nächste Fallstudie.", "ar": "لا تكن دراسة الحالة التالية." },
                "BREACH_CTA_TEXT": { "en": "Every breach above was preventable with the right architecture. Eliminate your third-party vendor dependencies and close the attack surfaces that matter.", "ja": "上記のすべての侵害は、適切なアーキテクチャで防止可能でした。サードパーティベンダーの依存を排除し、重要な攻撃面を閉じましょう。", "es": "Cada brecha fue prevenible con la arquitectura correcta. Elimine las dependencias de proveedores.", "fr": "Chaque violation était évitable avec la bonne architecture. Éliminez les dépendances fournisseurs.", "zh": "上述每次泄露都可以通过正确的架构来预防。消除第三方供应商依赖。", "zh-TW": "上述每次洩露都可以透過正確的架構來預防。消除第三方供應商依賴。", "de": "Jeder Vorfall war mit der richtigen Architektur vermeidbar. Eliminieren Sie Anbieter-Abhängigkeiten.", "ar": "كل اختراق أعلاه كان يمكن منعه بالهندسة الصحيحة. أزل تبعيات موردي الطرف الثالث وأغلق أسطح الهجوم المهمة." },
                "BREACH_CTA_BUTTON": { "en": "Secure Your Organization", "ja": "組織を守る", "es": "Asegure Su Organización", "fr": "Sécurisez Votre Organisation", "zh": "保护您的组织", "zh-TW": "保護您的組織", "de": "Sichern Sie Ihre Organisation", "ar": "أمّن مؤسستك" }
            })
        }
    );

export {translationStore, RTL_LANGS};
